var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g6, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeloGreenSteel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_4148)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_4148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 101,
    height: 96
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.66 49.9823C100.66 55.1017 94.9083 59.2534 93.4086 63.8742C91.8543 68.6627 94.016 75.3908 91.1128 79.3749C88.1844 83.4008 81.096 83.4092 77.0701 86.3418C73.086 89.2408 70.8991 95.9941 66.1107 97.5483C61.4898 99.0481 55.7755 94.9174 50.6561 94.9174C45.5368 94.9174 39.8225 99.0481 35.2016 97.5483C30.5807 96.0485 28.2305 89.2408 24.2422 86.3418C20.2163 83.4134 13.1321 83.4008 10.1995 79.3749C7.30048 75.3908 9.458 68.6627 7.90374 63.8742C6.40395 59.2534 0.651962 55.1059 0.651962 49.9823C0.651962 44.8587 6.40395 40.7113 7.90374 36.0904C9.458 31.302 7.29629 24.5739 10.1995 20.5898C13.1279 16.5638 20.2163 16.5554 24.2422 13.6229C28.2263 10.7238 30.4132 3.97059 35.2016 2.41634C39.8267 0.916545 45.5409 5.04725 50.6603 5.04725C55.7797 5.04725 61.494 0.916545 66.1149 2.41634C70.9033 3.97059 73.086 10.7238 77.0742 13.6229C81.1002 16.5512 88.1844 16.5638 91.117 20.5898C94.016 24.5739 91.8585 31.302 93.4128 36.0904C94.9125 40.7113 100.665 44.8587 100.665 49.9823H100.66Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_4148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.735748 0.916504H0.660339V99.048H0.735748V0.916504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.811157 0.916504H0.735748V99.048H0.811157V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.886566 0.916504H0.811157V99.048H0.886566V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.961975 0.916504H0.886566V99.048H0.961975V0.916504Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03738 0.916504H0.961975V99.048H1.03738V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11279 0.916504H1.03738V99.048H1.11279V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1882 0.916504H1.11279V99.048H1.1882V0.916504Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26361 0.916504H1.1882V99.048H1.26361V0.916504Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33902 0.916504H1.26361V99.048H1.33902V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41442 0.916504H1.33901V99.048H1.41442V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49402 0.916504H1.41861V99.048H1.49402V0.916504Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.56943 0.916504H1.49402V99.048H1.56943V0.916504Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64484 0.916504H1.56943V99.048H1.64484V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72024 0.916504H1.64484V99.048H1.72024V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79565 0.916504H1.72025V99.048H1.79565V0.916504Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87106 0.916504H1.79565V99.048H1.87106V0.916504Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94647 0.916504H1.87106V99.048H1.94647V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02188 0.916504H1.94647V99.048H2.02188V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09729 0.916504H2.02188V99.048H2.09729V0.916504Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1727 0.916504H2.09729V99.048H2.1727V0.916504Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24811 0.916504H2.1727V99.048H2.24811V0.916504Z",
    fill: "#F1F1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32352 0.916504H2.24811V99.048H2.32352V0.916504Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39893 0.916504H2.32352V99.048H2.39893V0.916504Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47433 0.916504H2.39893V99.048H2.47433V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54974 0.916504H2.47433V99.048H2.54974V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62515 0.916504H2.54974V99.048H2.62515V0.916504Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70056 0.916504H2.62515V99.048H2.70056V0.916504Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77596 0.916504H2.70055V99.048H2.77596V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85137 0.916504H2.77596V99.048H2.85137V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93097 0.916504H2.85556V99.048H2.93097V0.916504Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00638 0.916504H2.93097V99.048H3.00638V0.916504Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08179 0.916504H3.00638V99.048H3.08179V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1572 0.916504H3.08179V99.048H3.1572V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2326 0.916504H3.1572V99.048H3.2326V0.916504Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30801 0.916504H3.2326V99.048H3.30801V0.916504Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38342 0.916504H3.30801V99.048H3.38342V0.916504Z",
    fill: "#E6E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.45883 0.916504H3.38342V99.048H3.45883V0.916504Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53424 0.916504H3.45883V99.048H3.53424V0.916504Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60965 0.916504H3.53424V99.048H3.60965V0.916504Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68506 0.916504H3.60965V99.048H3.68506V0.916504Z",
    fill: "#E3E3E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76047 0.916504H3.68506V99.048H3.76047V0.916504Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83588 0.916504H3.76047V99.048H3.83588V0.916504Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91129 0.916504H3.83588V99.048H3.91129V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98669 0.916504H3.91129V99.048H3.98669V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0621 0.916504H3.98669V99.048H4.0621V0.916504Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1375 0.916504H4.0621V99.048H4.1375V0.916504Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21291 0.916504H4.1375V99.048H4.21291V0.916504Z",
    fill: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28832 0.916504H4.21291V99.048H4.28832V0.916504Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36792 0.916504H4.29251V99.048H4.36792V0.916504Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44333 0.916504H4.36792V99.048H4.44333V0.916504Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51874 0.916504H4.44333V99.048H4.51874V0.916504Z",
    fill: "#DBDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59415 0.916504H4.51874V99.048H4.59415V0.916504Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66955 0.916504H4.59415V99.048H4.66955V0.916504Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74496 0.916504H4.66956V99.048H4.74496V0.916504Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82037 0.916504H4.74496V99.048H4.82037V0.916504Z",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89578 0.916504H4.82037V99.048H4.89578V0.916504Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97119 0.916504H4.89578V99.048H4.97119V0.916504Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0466 0.916504H4.97119V99.048H5.0466V0.916504Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12201 0.916504H5.0466V99.048H5.12201V0.916504Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19742 0.916504H5.12201V99.048H5.19742V0.916504Z",
    fill: "#D4D4D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27283 0.916504H5.19742V99.048H5.27283V0.916504Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34824 0.916504H5.27283V99.048H5.34824V0.916504Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42364 0.916504H5.34823V99.048H5.42364V0.916504Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49905 0.916504H5.42364V99.048H5.49905V0.916504Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57445 0.916504H5.49905V99.048H5.57445V0.916504Z",
    fill: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64986 0.916504H5.57446V99.048H5.64986V0.916504Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72527 0.916504H5.64986V99.048H5.72527V0.916504Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80068 0.916504H5.72527V99.048H5.80068V0.916504Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88028 0.916504H5.80487V99.048H5.88028V0.916504Z",
    fill: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95569 0.916504H5.88028V99.048H5.95569V0.916504Z",
    fill: "#CCCCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0311 0.916504H5.95569V99.048H6.0311V0.916504Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10651 0.916504H6.0311V99.048H6.10651V0.916504Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18191 0.916504H6.10651V99.048H6.18191V0.916504Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25732 0.916504H6.18192V99.048H6.25732V0.916504Z",
    fill: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33273 0.916504H6.25732V99.048H6.33273V0.916504Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40814 0.916504H6.33273V99.048H6.40814V0.916504Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48355 0.916504H6.40814V99.048H6.48355V0.916504Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55896 0.916504H6.48355V99.048H6.55896V0.916504Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63437 0.916504H6.55896V99.048H6.63437V0.916504Z",
    fill: "#C5C5C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70978 0.916504H6.63437V99.048H6.70978V0.916504Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78518 0.916504H6.70977V99.048H6.78518V0.916504Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86059 0.916504H6.78518V99.048H6.86059V0.916504Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.936 0.916504H6.86059V99.048H6.936V0.916504Z",
    fill: "#C2C2C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01141 0.916504H6.936V99.048H7.01141V0.916504Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08681 0.916504H7.01141V99.048H7.08681V0.916504Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16222 0.916504H7.08681V99.048H7.16222V0.916504Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23763 0.916504H7.16222V99.048H7.23763V0.916504Z",
    fill: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31723 0.916504H7.24182V99.048H7.31723V0.916504Z",
    fill: "#BEBEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39264 0.916504H7.31723V99.048H7.39264V0.916504Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46805 0.916504H7.39264V99.048H7.46805V0.916504Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54346 0.916504H7.46805V99.048H7.54346V0.916504Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61887 0.916504H7.54346V99.048H7.61887V0.916504Z",
    fill: "#BBBBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69427 0.916504H7.61887V99.048H7.69427V0.916504Z",
    fill: "#BABAB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76968 0.916504H7.69427V99.048H7.76968V0.916504Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84509 0.916504H7.76968V99.048H7.84509V0.916504Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9205 0.916504H7.84509V99.048H7.9205V0.916504Z",
    fill: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99591 0.916504H7.9205V99.048H7.99591V0.916504Z",
    fill: "#B7B7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07132 0.916504H7.99591V99.048H8.07132V0.916504Z",
    fill: "#B6B6B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14672 0.916504H8.07131V99.048H8.14672V0.916504Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22213 0.916504H8.14672V99.048H8.22213V0.916504Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29754 0.916504H8.22213V99.048H8.29754V0.916504Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37295 0.916504H8.29754V99.048H8.37295V0.916504Z",
    fill: "#B3B3B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44836 0.916504H8.37295V99.048H8.44836V0.916504Z",
    fill: "#B2B2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52377 0.916504H8.44836V99.048H8.52377V0.916504Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59917 0.916504H8.52377V99.048H8.59917V0.916504Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67458 0.916504H8.59917V99.048H8.67458V0.916504Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75418 0.916504H8.67877V99.048H8.75418V0.916504Z",
    fill: "#AFAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82959 0.916504H8.75418V99.048H8.82959V0.916504Z",
    fill: "#AEAEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.905 0.916504H8.82959V99.048H8.905V0.916504Z",
    fill: "#ADADAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98041 0.916504H8.905V99.048H8.98041V0.916504Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05582 0.916504H8.98041V99.048H9.05582V0.916504Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13122 0.916504H9.05582V99.048H9.13122V0.916504Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20663 0.916504H9.13123V99.048H9.20663V0.916504Z",
    fill: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28204 0.916504H9.20663V99.048H9.28204V0.916504Z",
    fill: "#A9A9A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35745 0.916504H9.28204V99.048H9.35745V0.916504Z",
    fill: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43286 0.916504H9.35745V99.048H9.43286V0.916504Z",
    fill: "#A7A7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50827 0.916504H9.43286V99.048H9.50827V0.916504Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58367 0.916504H9.50826V99.048H9.58367V0.916504Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65908 0.916504H9.58367V99.048H9.65908V0.916504Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73449 0.916504H9.65908V99.048H9.73449V0.916504Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8099 0.916504H9.73449V99.048H9.8099V0.916504Z",
    fill: "#A3A3A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88531 0.916504H9.8099V99.048H9.88531V0.916504Z",
    fill: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96072 0.916504H9.88531V99.048H9.96072V0.916504Z",
    fill: "#A1A1A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0361 0.916504H9.96072V99.048H10.0361V0.916504Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1115 0.916504H10.0361V99.048H10.1115V0.916504Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1911 0.916504H10.1157V99.048H10.1911V0.916504Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2665 0.916504H10.1911V99.048H10.2665V0.916504Z",
    fill: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3419 0.916504H10.2665V99.048H10.3419V0.916504Z",
    fill: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4174 0.916504H10.3419V99.048H10.4174V0.916504Z",
    fill: "#9C9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4928 0.916504H10.4174V99.048H10.4928V0.916504Z",
    fill: "#9B9B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5682 0.916504H10.4928V99.048H10.5682V0.916504Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6436 0.916504H10.5682V99.048H10.6436V0.916504Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.719 0.916504H10.6436V99.048H10.719V0.916504Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7944 0.916504H10.719V99.048H10.7944V0.916504Z",
    fill: "#989797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8698 0.916504H10.7944V99.048H10.8698V0.916504Z",
    fill: "#979796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9452 0.916504H10.8698V99.048H10.9452V0.916504Z",
    fill: "#969695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0206 0.916504H10.9452V99.048H11.0206V0.916504Z",
    fill: "#959594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.096 0.916504H11.0206V99.048H11.096V0.916504Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1714 0.916504H11.096V99.048H11.1714V0.916504Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2469 0.916504H11.1714V99.048H11.2469V0.916504Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3223 0.916504H11.2469V99.048H11.3223V0.916504Z",
    fill: "#929291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3977 0.916504H11.3223V99.048H11.3977V0.916504Z",
    fill: "#919190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4731 0.916504H11.3977V99.048H11.4731V0.916504Z",
    fill: "#90908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5485 0.916504H11.4731V99.048H11.5485V0.916504Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6281 0.916504H11.5527V99.048H11.6281V0.916504Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7035 0.916504H11.6281V99.048H11.7035V0.916504Z",
    fill: "#8E8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7789 0.916504H11.7035V99.048H11.7789V0.916504Z",
    fill: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8543 0.916504H11.7789V99.048H11.8543V0.916504Z",
    fill: "#8C8C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9297 0.916504H11.8543V99.048H11.9297V0.916504Z",
    fill: "#8B8B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0051 0.916504H11.9297V99.048H12.0051V0.916504Z",
    fill: "#8A8A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0805 0.916504H12.0051V99.048H12.0805V0.916504Z",
    fill: "#898988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1559 0.916504H12.0805V99.048H12.1559V0.916504Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2314 0.916504H12.1559V99.048H12.2314V0.916504Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3068 0.916504H12.2314V99.048H12.3068V0.916504Z",
    fill: "#878686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3822 0.916504H12.3068V99.048H12.3822V0.916504Z",
    fill: "#868585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4576 0.916504H12.3822V99.048H12.4576V0.916504Z",
    fill: "#858584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.533 0.916504H12.4576V99.048H12.533V0.916504Z",
    fill: "#848483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6084 0.916504H12.533V99.048H12.6084V0.916504Z",
    fill: "#838382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6838 0.916504H12.6084V99.048H12.6838V0.916504Z",
    fill: "#828281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7592 0.916504H12.6838V99.048H12.7592V0.916504Z",
    fill: "#818180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8346 0.916504H12.7592V99.048H12.8346V0.916504Z",
    fill: "#80807F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.91 0.916504H12.8346V99.048H12.91V0.916504Z",
    fill: "#7F7F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9854 0.916504H12.91V99.048H12.9854V0.916504Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.065 0.916504H12.9896V99.048H13.065V0.916504Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1404 0.916504H13.065V99.048H13.1404V0.916504Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2158 0.916504H13.1404V99.048H13.2158V0.916504Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2913 0.916504H13.2159V99.048H13.2913V0.916504Z",
    fill: "#7B7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3667 0.916504H13.2913V99.048H13.3667V0.916504Z",
    fill: "#7A7979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4421 0.916504H13.3667V99.048H13.4421V0.916504Z",
    fill: "#797878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5175 0.916504H13.4421V99.048H13.5175V0.916504Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5929 0.916504H13.5175V99.048H13.5929V0.916504Z",
    fill: "#777676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6683 0.916504H13.5929V99.048H13.6683V0.916504Z",
    fill: "#767575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7437 0.916504H13.6683V99.048H13.7437V0.916504Z",
    fill: "#757474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8191 0.916504H13.7437V99.048H13.8191V0.916504Z",
    fill: "#747473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8945 0.916504H13.8191V99.048H13.8945V0.916504Z",
    fill: "#737372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9699 0.916504H13.8945V99.048H13.9699V0.916504Z",
    fill: "#727271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0453 0.916504H13.9699V99.048H14.0453V0.916504Z",
    fill: "#717170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1208 0.916504H14.0453V99.048H14.1208V0.916504Z",
    fill: "#70706F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1962 0.916504H14.1207V99.048H14.1962V0.916504Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2716 0.916504H14.1962V99.048H14.2716V0.916504Z",
    fill: "#6E6E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.347 0.916504H14.2716V99.048H14.347V0.916504Z",
    fill: "#6D6D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4224 0.916504H14.347V99.048H14.4224V0.916504Z",
    fill: "#6C6C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4978 0.916504H14.4224V99.048H14.4978V0.916504Z",
    fill: "#6B6B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5774 0.916504H14.502V99.048H14.5774V0.916504Z",
    fill: "#6A6A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 0.916504H14.5774V99.048H14.6528V0.916504Z",
    fill: "#696968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7282 0.916504H14.6528V99.048H14.7282V0.916504Z",
    fill: "#686867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8036 0.916504H14.7282V99.048H14.8036V0.916504Z",
    fill: "#676766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.879 0.916504H14.8036V99.048H14.879V0.916504Z",
    fill: "#666665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9544 0.916504H14.879V99.048H14.9544V0.916504Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0298 0.916504H14.9544V99.048H15.0298V0.916504Z",
    fill: "#656464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1053 0.916504H15.0298V99.048H15.1053V0.916504Z",
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1807 0.916504H15.1053V99.048H15.1807V0.916504Z",
    fill: "#636262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2561 0.916504H15.1807V99.048H15.2561V0.916504Z",
    fill: "#626161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3315 0.916504H15.2561V99.048H15.3315V0.916504Z",
    fill: "#616060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4069 0.916504H15.3315V99.048H15.4069V0.916504Z",
    fill: "#605F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4823 0.916504H15.4069V99.048H15.4823V0.916504Z",
    fill: "#5F5F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5577 0.916504H15.4823V99.048H15.5577V0.916504Z",
    fill: "#5E5E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6331 0.916504H15.5577V99.048H15.6331V0.916504Z",
    fill: "#5D5D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7085 0.916504H15.6331V99.048H15.7085V0.916504Z",
    fill: "#5C5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7839 0.916504H15.7085V99.048H15.7839V0.916504Z",
    fill: "#5B5B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8593 0.916504H15.7839V99.048H15.8593V0.916504Z",
    fill: "#5A5A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9347 0.916504H15.8593V99.048H15.9347V0.916504Z",
    fill: "#595958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0143 0.916504H15.9389V99.048H16.0143V0.916504Z",
    fill: "#585857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0898 0.916504H16.0143V99.048H16.0898V0.916504Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1652 0.916504H16.0898V99.048H16.1652V0.916504Z",
    fill: "#565655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2406 0.916504H16.1652V99.048H16.2406V0.916504Z",
    fill: "#555554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.316 0.916504H16.2406V99.048H16.316V0.916504Z",
    fill: "#545453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3914 0.916504H16.316V99.048H16.3914V0.916504Z",
    fill: "#535352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4668 0.916504H16.3914V99.048H16.4668V0.916504Z",
    fill: "#525251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5422 0.916504H16.4668V99.048H16.5422V0.916504Z",
    fill: "#515150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6176 0.916504H16.5422V99.048H16.6176V0.916504Z",
    fill: "#504F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.693 0.916504H16.6176V99.048H16.693V0.916504Z",
    fill: "#4F4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7684 0.916504H16.693V99.048H16.7684V0.916504Z",
    fill: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 0.916504H16.7684V99.048H16.8438V0.916504Z",
    fill: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9193 0.916504H16.8438V99.048H16.9193V0.916504Z",
    fill: "#4C4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9947 0.916504H16.9193V99.048H16.9947V0.916504Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0701 0.916504H16.9946V99.048H17.0701V0.916504Z",
    fill: "#494948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1455 0.916504H17.0701V99.048H17.1455V0.916504Z",
    fill: "#484847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2209 0.916504H17.1455V99.048H17.2209V0.916504Z",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2963 0.916504H17.2209V99.048H17.2963V0.916504Z",
    fill: "#464645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3717 0.916504H17.2963V99.048H17.3717V0.916504Z",
    fill: "#454544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4513 0.916504H17.3759V99.048H17.4513V0.916504Z",
    fill: "#444443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5267 0.916504H17.4513V99.048H17.5267V0.916504Z",
    fill: "#434342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6021 0.916504H17.5267V99.048H17.6021V0.916504Z",
    fill: "#424241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6775 0.916504H17.6021V99.048H17.6775V0.916504Z",
    fill: "#414040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7529 0.916504H17.6775V99.048H17.7529V0.916504Z",
    fill: "#403F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8283 0.916504H17.7529V99.048H17.8283V0.916504Z",
    fill: "#3F3E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9037 0.916504H17.8283V99.048H17.9037V0.916504Z",
    fill: "#3D3D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9792 0.916504H17.9037V99.048H17.9792V0.916504Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0629 0.916504H17.9792V99.048H18.0629V0.916504Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1467 0.916504H18.0629V99.048H18.1467V0.916504Z",
    fill: "#3D3D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2263 0.916504H18.1425V99.048H18.2263V0.916504Z",
    fill: "#3F3E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3101 0.916504H18.2263V99.048H18.3101V0.916504Z",
    fill: "#403F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3939 0.916504H18.3101V99.048H18.3939V0.916504Z",
    fill: "#414040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4735 0.916504H18.3897V99.048H18.4735V0.916504Z",
    fill: "#424241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5573 0.916504H18.4735V99.048H18.5573V0.916504Z",
    fill: "#434342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6411 0.916504H18.5573V99.048H18.6411V0.916504Z",
    fill: "#444443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7207 0.916504H18.6369V99.048H18.7207V0.916504Z",
    fill: "#454544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8045 0.916504H18.7207V99.048H18.8045V0.916504Z",
    fill: "#464645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8882 0.916504H18.8045V99.048H18.8882V0.916504Z",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9678 0.916504H18.884V99.048H18.9678V0.916504Z",
    fill: "#484847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0516 0.916504H18.9678V99.048H19.0516V0.916504Z",
    fill: "#494948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1354 0.916504H19.0516V99.048H19.1354V0.916504Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2192 0.916504H19.1354V99.048H19.2192V0.916504Z",
    fill: "#4C4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2988 0.916504H19.215V99.048H19.2988V0.916504Z",
    fill: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3826 0.916504H19.2988V99.048H19.3826V0.916504Z",
    fill: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4664 0.916504H19.3826V99.048H19.4664V0.916504Z",
    fill: "#4F4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.546 0.916504H19.4622V99.048H19.546V0.916504Z",
    fill: "#504F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6298 0.916504H19.546V99.048H19.6298V0.916504Z",
    fill: "#515150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7135 0.916504H19.6298V99.048H19.7135V0.916504Z",
    fill: "#525251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7931 0.916504H19.7094V99.048H19.7931V0.916504Z",
    fill: "#535352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8769 0.916504H19.7931V99.048H19.8769V0.916504Z",
    fill: "#545453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9607 0.916504H19.8769V99.048H19.9607V0.916504Z",
    fill: "#555554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0403 0.916504H19.9565V99.048H20.0403V0.916504Z",
    fill: "#565655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1241 0.916504H20.0403V99.048H20.1241V0.916504Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2079 0.916504H20.1241V99.048H20.2079V0.916504Z",
    fill: "#585857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2875 0.916504H20.2037V99.048H20.2875V0.916504Z",
    fill: "#595958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3713 0.916504H20.2875V99.048H20.3713V0.916504Z",
    fill: "#5A5A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4551 0.916504H20.3713V99.048H20.4551V0.916504Z",
    fill: "#5B5B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5347 0.916504H20.4509V99.048H20.5347V0.916504Z",
    fill: "#5C5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6184 0.916504H20.5347V99.048H20.6184V0.916504Z",
    fill: "#5D5D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7022 0.916504H20.6184V99.048H20.7022V0.916504Z",
    fill: "#5E5E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7818 0.916504H20.698V99.048H20.7818V0.916504Z",
    fill: "#5F5F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8656 0.916504H20.7818V99.048H20.8656V0.916504Z",
    fill: "#605F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9494 0.916504H20.8656V99.048H20.9494V0.916504Z",
    fill: "#616060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0332 0.916504H20.9494V99.048H21.0332V0.916504Z",
    fill: "#626161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1128 0.916504H21.029V99.048H21.1128V0.916504Z",
    fill: "#636262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1966 0.916504H21.1128V99.048H21.1966V0.916504Z",
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2804 0.916504H21.1966V99.048H21.2804V0.916504Z",
    fill: "#656464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.36 0.916504H21.2762V99.048H21.36V0.916504Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4437 0.916504H21.36V99.048H21.4437V0.916504Z",
    fill: "#666665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5275 0.916504H21.4438V99.048H21.5275V0.916504Z",
    fill: "#676766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6071 0.916504H21.5233V99.048H21.6071V0.916504Z",
    fill: "#686867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6909 0.916504H21.6071V99.048H21.6909V0.916504Z",
    fill: "#696968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7747 0.916504H21.6909V99.048H21.7747V0.916504Z",
    fill: "#6A6A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8543 0.916504H21.7705V99.048H21.8543V0.916504Z",
    fill: "#6B6B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9381 0.916504H21.8543V99.048H21.9381V0.916504Z",
    fill: "#6C6C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0219 0.916504H21.9381V99.048H22.0219V0.916504Z",
    fill: "#6D6D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1015 0.916504H22.0177V99.048H22.1015V0.916504Z",
    fill: "#6E6E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1853 0.916504H22.1015V99.048H22.1853V0.916504Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2691 0.916504H22.1853V99.048H22.2691V0.916504Z",
    fill: "#70706F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3486 0.916504H22.2649V99.048H22.3486V0.916504Z",
    fill: "#717170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4324 0.916504H22.3486V99.048H22.4324V0.916504Z",
    fill: "#727271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5162 0.916504H22.4324V99.048H22.5162V0.916504Z",
    fill: "#737372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5958 0.916504H22.512V99.048H22.5958V0.916504Z",
    fill: "#747473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6796 0.916504H22.5958V99.048H22.6796V0.916504Z",
    fill: "#757474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7634 0.916504H22.6796V99.048H22.7634V0.916504Z",
    fill: "#767575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8472 0.916504H22.7634V99.048H22.8472V0.916504Z",
    fill: "#777676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9268 0.916504H22.843V99.048H22.9268V0.916504Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0106 0.916504H22.9268V99.048H23.0106V0.916504Z",
    fill: "#797878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0944 0.916504H23.0106V99.048H23.0944V0.916504Z",
    fill: "#7A7979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.174 0.916504H23.0902V99.048H23.174V0.916504Z",
    fill: "#7B7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2577 0.916504H23.174V99.048H23.2577V0.916504Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3415 0.916504H23.2577V99.048H23.3415V0.916504Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4211 0.916504H23.3373V99.048H23.4211V0.916504Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5049 0.916504H23.4211V99.048H23.5049V0.916504Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5887 0.916504H23.5049V99.048H23.5887V0.916504Z",
    fill: "#7F7F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6683 0.916504H23.5845V99.048H23.6683V0.916504Z",
    fill: "#80807F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7521 0.916504H23.6683V99.048H23.7521V0.916504Z",
    fill: "#818180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 0.916504H23.7521V99.048H23.8359V0.916504Z",
    fill: "#828281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9155 0.916504H23.8317V99.048H23.9155V0.916504Z",
    fill: "#838382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9993 0.916504H23.9155V99.048H23.9993V0.916504Z",
    fill: "#848483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.083 0.916504H23.9993V99.048H24.083V0.916504Z",
    fill: "#858584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1626 0.916504H24.0789V99.048H24.1626V0.916504Z",
    fill: "#868585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2464 0.916504H24.1626V99.048H24.2464V0.916504Z",
    fill: "#878686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3302 0.916504H24.2464V99.048H24.3302V0.916504Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.414 0.916504H24.3302V99.048H24.414V0.916504Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4936 0.916504H24.4098V99.048H24.4936V0.916504Z",
    fill: "#898988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5774 0.916504H24.4936V99.048H24.5774V0.916504Z",
    fill: "#8A8A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6612 0.916504H24.5774V99.048H24.6612V0.916504Z",
    fill: "#8B8B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7408 0.916504H24.657V99.048H24.7408V0.916504Z",
    fill: "#8C8C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8246 0.916504H24.7408V99.048H24.8246V0.916504Z",
    fill: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9083 0.916504H24.8246V99.048H24.9083V0.916504Z",
    fill: "#8E8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9879 0.916504H24.9042V99.048H24.9879V0.916504Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0717 0.916504H24.9879V99.048H25.0717V0.916504Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1555 0.916504H25.0717V99.048H25.1555V0.916504Z",
    fill: "#90908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2351 0.916504H25.1513V99.048H25.2351V0.916504Z",
    fill: "#919190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3189 0.916504H25.2351V99.048H25.3189V0.916504Z",
    fill: "#929291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4027 0.916504H25.3189V99.048H25.4027V0.916504Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4823 0.916504H25.3985V99.048H25.4823V0.916504Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5661 0.916504H25.4823V99.048H25.5661V0.916504Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6499 0.916504H25.5661V99.048H25.6499V0.916504Z",
    fill: "#959594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7295 0.916504H25.6457V99.048H25.7295V0.916504Z",
    fill: "#969695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8132 0.916504H25.7295V99.048H25.8132V0.916504Z",
    fill: "#979796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.897 0.916504H25.8132V99.048H25.897V0.916504Z",
    fill: "#989797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9766 0.916504H25.8929V99.048H25.9766V0.916504Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0604 0.916504H25.9766V99.048H26.0604V0.916504Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1442 0.916504H26.0604V99.048H26.1442V0.916504Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.228 0.916504H26.1442V99.048H26.228V0.916504Z",
    fill: "#9B9B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3076 0.916504H26.2238V99.048H26.3076V0.916504Z",
    fill: "#9C9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3914 0.916504H26.3076V99.048H26.3914V0.916504Z",
    fill: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 0.916504H26.3914V99.048H26.4752V0.916504Z",
    fill: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5548 0.916504H26.471V99.048H26.5548V0.916504Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6385 0.916504H26.5548V99.048H26.6385V0.916504Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7223 0.916504H26.6385V99.048H26.7223V0.916504Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8019 0.916504H26.7182V99.048H26.8019V0.916504Z",
    fill: "#A1A1A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8857 0.916504H26.8019V99.048H26.8857V0.916504Z",
    fill: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9695 0.916504H26.8857V99.048H26.9695V0.916504Z",
    fill: "#A3A3A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0491 0.916504H26.9653V99.048H27.0491V0.916504Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1329 0.916504H27.0491V99.048H27.1329V0.916504Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2167 0.916504H27.1329V99.048H27.2167V0.916504Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2963 0.916504H27.2125V99.048H27.2963V0.916504Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3801 0.916504H27.2963V99.048H27.3801V0.916504Z",
    fill: "#A7A7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4639 0.916504H27.3801V99.048H27.4639V0.916504Z",
    fill: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5435 0.916504H27.4597V99.048H27.5435V0.916504Z",
    fill: "#A9A9A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6272 0.916504H27.5435V99.048H27.6272V0.916504Z",
    fill: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.711 0.916504H27.6272V99.048H27.711V0.916504Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7948 0.916504H27.711V99.048H27.7948V0.916504Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8744 0.916504H27.7906V99.048H27.8744V0.916504Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9582 0.916504H27.8744V99.048H27.9582V0.916504Z",
    fill: "#ADADAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.042 0.916504H27.9582V99.048H28.042V0.916504Z",
    fill: "#AEAEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1216 0.916504H28.0378V99.048H28.1216V0.916504Z",
    fill: "#AFAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2054 0.916504H28.1216V99.048H28.2054V0.916504Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2892 0.916504H28.2054V99.048H28.2892V0.916504Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3688 0.916504H28.285V99.048H28.3688V0.916504Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4525 0.916504H28.3688V99.048H28.4525V0.916504Z",
    fill: "#B2B2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5363 0.916504H28.4525V99.048H28.5363V0.916504Z",
    fill: "#B3B3B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6159 0.916504H28.5322V99.048H28.6159V0.916504Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 0.916504H28.6159V99.048H28.6997V0.916504Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7835 0.916504H28.6997V99.048H28.7835V0.916504Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8631 0.916504H28.7793V99.048H28.8631V0.916504Z",
    fill: "#B6B6B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9469 0.916504H28.8631V99.048H28.9469V0.916504Z",
    fill: "#B7B7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0307 0.916504H28.9469V99.048H29.0307V0.916504Z",
    fill: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1103 0.916504H29.0265V99.048H29.1103V0.916504Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1941 0.916504H29.1103V99.048H29.1941V0.916504Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2778 0.916504H29.1941V99.048H29.2778V0.916504Z",
    fill: "#BABAB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3575 0.916504H29.2737V99.048H29.3575V0.916504Z",
    fill: "#BBBBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4412 0.916504H29.3575V99.048H29.4412V0.916504Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.525 0.916504H29.4412V99.048H29.525V0.916504Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6088 0.916504H29.525V99.048H29.6088V0.916504Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6884 0.916504H29.6046V99.048H29.6884V0.916504Z",
    fill: "#BEBEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7722 0.916504H29.6884V99.048H29.7722V0.916504Z",
    fill: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.856 0.916504H29.7722V99.048H29.856V0.916504Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9356 0.916504H29.8518V99.048H29.9356V0.916504Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0194 0.916504H29.9356V99.048H30.0194V0.916504Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1031 0.916504H30.0194V99.048H30.1031V0.916504Z",
    fill: "#C2C2C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1828 0.916504H30.099V99.048H30.1828V0.916504Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2665 0.916504H30.1828V99.048H30.2665V0.916504Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3503 0.916504H30.2665V99.048H30.3503V0.916504Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4299 0.916504H30.3461V99.048H30.4299V0.916504Z",
    fill: "#C5C5C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5137 0.916504H30.4299V99.048H30.5137V0.916504Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5975 0.916504H30.5137V99.048H30.5975V0.916504Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6771 0.916504H30.5933V99.048H30.6771V0.916504Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7609 0.916504H30.6771V99.048H30.7609V0.916504Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8447 0.916504H30.7609V99.048H30.8447V0.916504Z",
    fill: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9243 0.916504H30.8405V99.048H30.9243V0.916504Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0081 0.916504H30.9243V99.048H31.0081V0.916504Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0918 0.916504H31.0081V99.048H31.0918V0.916504Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1714 0.916504H31.0876V99.048H31.1714V0.916504Z",
    fill: "#CCCCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2552 0.916504H31.1714V99.048H31.2552V0.916504Z",
    fill: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.339 0.916504H31.2552V99.048H31.339V0.916504Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4228 0.916504H31.339V99.048H31.4228V0.916504Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5024 0.916504H31.4186V99.048H31.5024V0.916504Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5862 0.916504H31.5024V99.048H31.5862V0.916504Z",
    fill: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.67 0.916504H31.5862V99.048H31.67V0.916504Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7496 0.916504H31.6658V99.048H31.7496V0.916504Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8334 0.916504H31.7496V99.048H31.8334V0.916504Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9171 0.916504H31.8334V99.048H31.9171V0.916504Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9968 0.916504H31.913V99.048H31.9968V0.916504Z",
    fill: "#D4D4D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0805 0.916504H31.9967V99.048H32.0805V0.916504Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1643 0.916504H32.0805V99.048H32.1643V0.916504Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2439 0.916504H32.1601V99.048H32.2439V0.916504Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3277 0.916504H32.2439V99.048H32.3277V0.916504Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4115 0.916504H32.3277V99.048H32.4115V0.916504Z",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4911 0.916504H32.4073V99.048H32.4911V0.916504Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5749 0.916504H32.4911V99.048H32.5749V0.916504Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6587 0.916504H32.5749V99.048H32.6587V0.916504Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7383 0.916504H32.6545V99.048H32.7383V0.916504Z",
    fill: "#DBDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8221 0.916504H32.7383V99.048H32.8221V0.916504Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9058 0.916504H32.8221V99.048H32.9058V0.916504Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9896 0.916504H32.9058V99.048H32.9896V0.916504Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0692 0.916504H32.9854V99.048H33.0692V0.916504Z",
    fill: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.153 0.916504H33.0692V99.048H33.153V0.916504Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2368 0.916504H33.153V99.048H33.2368V0.916504Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3164 0.916504H33.2326V99.048H33.3164V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4002 0.916504H33.3164V99.048H33.4002V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.484 0.916504H33.4002V99.048H33.484V0.916504Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5636 0.916504H33.4798V99.048H33.5636V0.916504Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6474 0.916504H33.5636V99.048H33.6474V0.916504Z",
    fill: "#E3E3E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7311 0.916504H33.6474V99.048H33.7311V0.916504Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8107 0.916504H33.7269V99.048H33.8107V0.916504Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8945 0.916504H33.8107V99.048H33.8945V0.916504Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9783 0.916504H33.8945V99.048H33.9783V0.916504Z",
    fill: "#E6E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0579 0.916504H33.9741V99.048H34.0579V0.916504Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1417 0.916504H34.0579V99.048H34.1417V0.916504Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2255 0.916504H34.1417V99.048H34.2255V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3051 0.916504H34.2213V99.048H34.3051V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3889 0.916504H34.3051V99.048H34.3889V0.916504Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4727 0.916504H34.3889V99.048H34.4727V0.916504Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5523 0.916504H34.4685V99.048H34.5523V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.636 0.916504H34.5522V99.048H34.636V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7198 0.916504H34.636V99.048H34.7198V0.916504Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8036 0.916504H34.7198V99.048H34.8036V0.916504Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8832 0.916504H34.7994V99.048H34.8832V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.967 0.916504H34.8832V99.048H34.967V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0508 0.916504H34.967V99.048H35.0508V0.916504Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1304 0.916504H35.0466V99.048H35.1304V0.916504Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2142 0.916504H35.1304V99.048H35.2142V0.916504Z",
    fill: "#F1F1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.298 0.916504H35.2142V99.048H35.298V0.916504Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3776 0.916504H35.2938V99.048H35.3776V0.916504Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4613 0.916504H35.3776V99.048H35.4613V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5451 0.916504H35.4613V99.048H35.5451V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6247 0.916504H35.541V99.048H35.6247V0.916504Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7085 0.916504H35.6247V99.048H35.7085V0.916504Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7923 0.916504H35.7085V99.048H35.7923V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8719 0.916504H35.7881V99.048H35.8719V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9557 0.916504H35.8719V99.048H35.9557V0.916504Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0395 0.916504H35.9557V99.048H36.0395V0.916504Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1191 0.916504H36.0353V99.048H36.1191V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2029 0.916504H36.1191V99.048H36.2029V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2866 0.916504H36.2029V99.048H36.2866V0.916504Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3704 0.916504H36.2867V99.048H36.3704V0.916504Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.45 0.916504H36.3662V99.048H36.45V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5338 0.916504H36.45V99.048H36.5338V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6176 0.916504H36.5338V99.048H36.6176V0.916504Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6972 0.916504H36.6134V99.048H36.6972V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.781 0.916504H36.6972V99.048H36.781V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8648 0.916504H36.781V99.048H36.8648V0.916504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9528 0.916504H36.8606V99.048H36.9528V0.916504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0491 0.916504H36.9569V99.048H37.0491V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1413 0.916504H37.0491V99.048H37.1413V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2334 0.916504H37.1413V99.048H37.2334V0.916504Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3256 0.916504H37.2334V99.048H37.3256V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.422 0.916504H37.3298V99.048H37.422V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5141 0.916504H37.422V99.048H37.5141V0.916504Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6063 0.916504H37.5141V99.048H37.6063V0.916504Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6985 0.916504H37.6063V99.048H37.6985V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7906 0.916504H37.6985V99.048H37.7906V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.887 0.916504H37.7948V99.048H37.887V0.916504Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9792 0.916504H37.887V99.048H37.9792V0.916504Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0713 0.916504H37.9792V99.048H38.0713V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1635 0.916504H38.0713V99.048H38.1635V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2598 0.916504H38.1677V99.048H38.2598V0.916504Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.352 0.916504H38.2598V99.048H38.352V0.916504Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4442 0.916504H38.352V99.048H38.4442V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5363 0.916504H38.4442V99.048H38.5363V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6327 0.916504H38.5405V99.048H38.6327V0.916504Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7249 0.916504H38.6327V99.048H38.7249V0.916504Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.817 0.916504H38.7249V99.048H38.817V0.916504Z",
    fill: "#F1F1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9092 0.916504H38.817V99.048H38.9092V0.916504Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0055 0.916504H38.9134V99.048H39.0055V0.916504Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0977 0.916504H39.0055V99.048H39.0977V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1899 0.916504H39.0977V99.048H39.1899V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.282 0.916504H39.1899V99.048H39.282V0.916504Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3784 0.916504H39.2862V99.048H39.3784V0.916504Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4706 0.916504H39.3784V99.048H39.4706V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5627 0.916504H39.4706V99.048H39.5627V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6549 0.916504H39.5627V99.048H39.6549V0.916504Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7513 0.916504H39.6591V99.048H39.7513V0.916504Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8434 0.916504H39.7513V99.048H39.8434V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9356 0.916504H39.8434V99.048H39.9356V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0277 0.916504H39.9356V99.048H40.0277V0.916504Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1241 0.916504H40.0319V99.048H40.1241V0.916504Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2163 0.916504H40.1241V99.048H40.2163V0.916504Z",
    fill: "#E6E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3084 0.916504H40.2163V99.048H40.3084V0.916504Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4006 0.916504H40.3084V99.048H40.4006V0.916504Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4969 0.916504H40.4048V99.048H40.4969V0.916504Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5891 0.916504H40.4969V99.048H40.5891V0.916504Z",
    fill: "#E3E3E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6813 0.916504H40.5891V99.048H40.6813V0.916504Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7735 0.916504H40.6813V99.048H40.7735V0.916504Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8698 0.916504H40.7776V99.048H40.8698V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.962 0.916504H40.8698V99.048H40.962V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0541 0.916504H40.962V99.048H41.0541V0.916504Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1463 0.916504H41.0541V99.048H41.1463V0.916504Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2427 0.916504H41.1505V99.048H41.2427V0.916504Z",
    fill: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3348 0.916504H41.2427V99.048H41.3348V0.916504Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.427 0.916504H41.3348V99.048H41.427V0.916504Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5192 0.916504H41.427V99.048H41.5192V0.916504Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6155 0.916504H41.5233V99.048H41.6155V0.916504Z",
    fill: "#DBDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7077 0.916504H41.6155V99.048H41.7077V0.916504Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7998 0.916504H41.7077V99.048H41.7998V0.916504Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.892 0.916504H41.7998V99.048H41.892V0.916504Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9884 0.916504H41.8962V99.048H41.9884V0.916504Z",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0805 0.916504H41.9884V99.048H42.0805V0.916504Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1727 0.916504H42.0805V99.048H42.1727V0.916504Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2649 0.916504H42.1727V99.048H42.2649V0.916504Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.357 0.916504H42.2649V99.048H42.357V0.916504Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4534 0.916504H42.3612V99.048H42.4534V0.916504Z",
    fill: "#D4D4D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5456 0.916504H42.4534V99.048H42.5456V0.916504Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6377 0.916504H42.5456V99.048H42.6377V0.916504Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7299 0.916504H42.6377V99.048H42.7299V0.916504Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8262 0.916504H42.7341V99.048H42.8262V0.916504Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9184 0.916504H42.8262V99.048H42.9184V0.916504Z",
    fill: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0106 0.916504H42.9184V99.048H43.0106V0.916504Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1027 0.916504H43.0106V99.048H43.1027V0.916504Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1991 0.916504H43.1069V99.048H43.1991V0.916504Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2913 0.916504H43.1991V99.048H43.2913V0.916504Z",
    fill: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3834 0.916504H43.2913V99.048H43.3834V0.916504Z",
    fill: "#CCCCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4756 0.916504H43.3834V99.048H43.4756V0.916504Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5719 0.916504H43.4798V99.048H43.5719V0.916504Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6641 0.916504H43.5719V99.048H43.6641V0.916504Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7563 0.916504H43.6641V99.048H43.7563V0.916504Z",
    fill: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8484 0.916504H43.7563V99.048H43.8484V0.916504Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9448 0.916504H43.8526V99.048H43.9448V0.916504Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.037 0.916504H43.9448V99.048H44.037V0.916504Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1291 0.916504H44.037V99.048H44.1291V0.916504Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2213 0.916504H44.1291V99.048H44.2213V0.916504Z",
    fill: "#C5C5C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3177 0.916504H44.2255V99.048H44.3177V0.916504Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4098 0.916504H44.3177V99.048H44.4098V0.916504Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.502 0.916504H44.4098V99.048H44.502V0.916504Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5942 0.916504H44.502V99.048H44.5942V0.916504Z",
    fill: "#C2C2C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6905 0.916504H44.5983V99.048H44.6905V0.916504Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7827 0.916504H44.6905V99.048H44.7827V0.916504Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8748 0.916504H44.7827V99.048H44.8748V0.916504Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.967 0.916504H44.8748V99.048H44.967V0.916504Z",
    fill: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0634 0.916504H44.9712V99.048H45.0634V0.916504Z",
    fill: "#BEBEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1555 0.916504H45.0634V99.048H45.1555V0.916504Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2477 0.916504H45.1555V99.048H45.2477V0.916504Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3399 0.916504H45.2477V99.048H45.3399V0.916504Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4362 0.916504H45.344V99.048H45.4362V0.916504Z",
    fill: "#BBBBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5284 0.916504H45.4362V99.048H45.5284V0.916504Z",
    fill: "#BABAB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6205 0.916504H45.5284V99.048H45.6205V0.916504Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7127 0.916504H45.6205V99.048H45.7127V0.916504Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8091 0.916504H45.7169V99.048H45.8091V0.916504Z",
    fill: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9012 0.916504H45.8091V99.048H45.9012V0.916504Z",
    fill: "#B7B7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9934 0.916504H45.9012V99.048H45.9934V0.916504Z",
    fill: "#B6B6B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0856 0.916504H45.9934V99.048H46.0856V0.916504Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1819 0.916504H46.0898V99.048H46.1819V0.916504Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2741 0.916504H46.1819V99.048H46.2741V0.916504Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3662 0.916504H46.2741V99.048H46.3662V0.916504Z",
    fill: "#B3B3B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4584 0.916504H46.3662V99.048H46.4584V0.916504Z",
    fill: "#B2B2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5548 0.916504H46.4626V99.048H46.5548V0.916504Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6469 0.916504H46.5548V99.048H46.6469V0.916504Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7391 0.916504H46.6469V99.048H46.7391V0.916504Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8313 0.916504H46.7391V99.048H46.8313V0.916504Z",
    fill: "#AFAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9234 0.916504H46.8313V99.048H46.9234V0.916504Z",
    fill: "#AEAEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0198 0.916504H46.9276V99.048H47.0198V0.916504Z",
    fill: "#ADADAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.112 0.916504H47.0198V99.048H47.112V0.916504Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2041 0.916504H47.112V99.048H47.2041V0.916504Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2963 0.916504H47.2041V99.048H47.2963V0.916504Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3926 0.916504H47.3005V99.048H47.3926V0.916504Z",
    fill: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4848 0.916504H47.3926V99.048H47.4848V0.916504Z",
    fill: "#A9A9A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.577 0.916504H47.4848V99.048H47.577V0.916504Z",
    fill: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6691 0.916504H47.577V99.048H47.6691V0.916504Z",
    fill: "#A7A7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7655 0.916504H47.6733V99.048H47.7655V0.916504Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8577 0.916504H47.7655V99.048H47.8577V0.916504Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9498 0.916504H47.8577V99.048H47.9498V0.916504Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.042 0.916504H47.9498V99.048H48.042V0.916504Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1383 0.916504H48.0462V99.048H48.1383V0.916504Z",
    fill: "#A3A3A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2305 0.916504H48.1384V99.048H48.2305V0.916504Z",
    fill: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3227 0.916504H48.2305V99.048H48.3227V0.916504Z",
    fill: "#A1A1A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4148 0.916504H48.3227V99.048H48.4148V0.916504Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5112 0.916504H48.419V99.048H48.5112V0.916504Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6034 0.916504H48.5112V99.048H48.6034V0.916504Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6955 0.916504H48.6034V99.048H48.6955V0.916504Z",
    fill: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7877 0.916504H48.6955V99.048H48.7877V0.916504Z",
    fill: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8841 0.916504H48.7919V99.048H48.8841V0.916504Z",
    fill: "#9C9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9762 0.916504H48.8841V99.048H48.9762V0.916504Z",
    fill: "#9B9B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0684 0.916504H48.9762V99.048H49.0684V0.916504Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1606 0.916504H49.0684V99.048H49.1606V0.916504Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2569 0.916504H49.1647V99.048H49.2569V0.916504Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3491 0.916504H49.2569V99.048H49.3491V0.916504Z",
    fill: "#989797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4412 0.916504H49.3491V99.048H49.4412V0.916504Z",
    fill: "#979796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5334 0.916504H49.4412V99.048H49.5334V0.916504Z",
    fill: "#969695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6298 0.916504H49.5376V99.048H49.6298V0.916504Z",
    fill: "#959594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7219 0.916504H49.6298V99.048H49.7219V0.916504Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8141 0.916504H49.7219V99.048H49.8141V0.916504Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9063 0.916504H49.8141V99.048H49.9063V0.916504Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0026 0.916504H49.9104V99.048H50.0026V0.916504Z",
    fill: "#929291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0948 0.916504H50.0026V99.048H50.0948V0.916504Z",
    fill: "#919190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.187 0.916504H50.0948V99.048H50.187V0.916504Z",
    fill: "#90908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2791 0.916504H50.187V99.048H50.2791V0.916504Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3755 0.916504H50.2833V99.048H50.3755V0.916504Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4676 0.916504H50.3755V99.048H50.4676V0.916504Z",
    fill: "#8E8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5598 0.916504H50.4676V99.048H50.5598V0.916504Z",
    fill: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.652 0.916504H50.5598V99.048H50.652V0.916504Z",
    fill: "#8C8C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7483 0.916504H50.6562V99.048H50.7483V0.916504Z",
    fill: "#8B8B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8405 0.916504H50.7483V99.048H50.8405V0.916504Z",
    fill: "#8A8A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9327 0.916504H50.8405V99.048H50.9327V0.916504Z",
    fill: "#898988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0248 0.916504H50.9326V99.048H51.0248V0.916504Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1212 0.916504H51.029V99.048H51.1212V0.916504Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2133 0.916504H51.1212V99.048H51.2133V0.916504Z",
    fill: "#878686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3055 0.916504H51.2133V99.048H51.3055V0.916504Z",
    fill: "#868585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3977 0.916504H51.3055V99.048H51.3977V0.916504Z",
    fill: "#858584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4898 0.916504H51.3977V99.048H51.4898V0.916504Z",
    fill: "#848483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5862 0.916504H51.494V99.048H51.5862V0.916504Z",
    fill: "#838382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6783 0.916504H51.5862V99.048H51.6783V0.916504Z",
    fill: "#828281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7705 0.916504H51.6784V99.048H51.7705V0.916504Z",
    fill: "#818180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8627 0.916504H51.7705V99.048H51.8627V0.916504Z",
    fill: "#80807F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.959 0.916504H51.8669V99.048H51.959V0.916504Z",
    fill: "#7F7F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0512 0.916504H51.959V99.048H52.0512V0.916504Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1434 0.916504H52.0512V99.048H52.1434V0.916504Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2355 0.916504H52.1434V99.048H52.2355V0.916504Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3319 0.916504H52.2397V99.048H52.3319V0.916504Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4241 0.916504H52.3319V99.048H52.4241V0.916504Z",
    fill: "#7B7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5162 0.916504H52.4241V99.048H52.5162V0.916504Z",
    fill: "#7A7979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6084 0.916504H52.5162V99.048H52.6084V0.916504Z",
    fill: "#797878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7047 0.916504H52.6126V99.048H52.7047V0.916504Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7969 0.916504H52.7047V99.048H52.7969V0.916504Z",
    fill: "#777676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8891 0.916504H52.7969V99.048H52.8891V0.916504Z",
    fill: "#767575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9812 0.916504H52.8891V99.048H52.9812V0.916504Z",
    fill: "#757474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0776 0.916504H52.9854V99.048H53.0776V0.916504Z",
    fill: "#747473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1698 0.916504H53.0776V99.048H53.1698V0.916504Z",
    fill: "#737372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2619 0.916504H53.1698V99.048H53.2619V0.916504Z",
    fill: "#727271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3541 0.916504H53.2619V99.048H53.3541V0.916504Z",
    fill: "#717170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4505 0.916504H53.3583V99.048H53.4505V0.916504Z",
    fill: "#70706F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5426 0.916504H53.4505V99.048H53.5426V0.916504Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6348 0.916504H53.5426V99.048H53.6348V0.916504Z",
    fill: "#6E6E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7269 0.916504H53.6348V99.048H53.7269V0.916504Z",
    fill: "#6D6D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8233 0.916504H53.7311V99.048H53.8233V0.916504Z",
    fill: "#6C6C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9155 0.916504H53.8233V99.048H53.9155V0.916504Z",
    fill: "#6B6B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0076 0.916504H53.9155V99.048H54.0076V0.916504Z",
    fill: "#6A6A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0998 0.916504H54.0076V99.048H54.0998V0.916504Z",
    fill: "#696968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1962 0.916504H54.104V99.048H54.1962V0.916504Z",
    fill: "#686867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2883 0.916504H54.1962V99.048H54.2883V0.916504Z",
    fill: "#676766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3805 0.916504H54.2883V99.048H54.3805V0.916504Z",
    fill: "#666665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4727 0.916504H54.3805V99.048H54.4727V0.916504Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.569 0.916504H54.4769V99.048H54.569V0.916504Z",
    fill: "#656464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6612 0.916504H54.569V99.048H54.6612V0.916504Z",
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7533 0.916504H54.6612V99.048H54.7533V0.916504Z",
    fill: "#636262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8455 0.916504H54.7533V99.048H54.8455V0.916504Z",
    fill: "#626161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9419 0.916504H54.8497V99.048H54.9419V0.916504Z",
    fill: "#616060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.034 0.916504H54.9419V99.048H55.034V0.916504Z",
    fill: "#605F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1262 0.916504H55.034V99.048H55.1262V0.916504Z",
    fill: "#5F5F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2184 0.916504H55.1262V99.048H55.2184V0.916504Z",
    fill: "#5E5E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3147 0.916504H55.2225V99.048H55.3147V0.916504Z",
    fill: "#5D5D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4069 0.916504H55.3147V99.048H55.4069V0.916504Z",
    fill: "#5C5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.499 0.916504H55.4069V99.048H55.499V0.916504Z",
    fill: "#5B5B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5912 0.916504H55.4991V99.048H55.5912V0.916504Z",
    fill: "#5A5A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6876 0.916504H55.5954V99.048H55.6876V0.916504Z",
    fill: "#595958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7797 0.916504H55.6876V99.048H55.7797V0.916504Z",
    fill: "#585857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8719 0.916504H55.7797V99.048H55.8719V0.916504Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9641 0.916504H55.8719V99.048H55.9641V0.916504Z",
    fill: "#565655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0604 0.916504H55.9683V99.048H56.0604V0.916504Z",
    fill: "#555554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1526 0.916504H56.0604V99.048H56.1526V0.916504Z",
    fill: "#545453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2447 0.916504H56.1526V99.048H56.2447V0.916504Z",
    fill: "#535352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3369 0.916504H56.2448V99.048H56.3369V0.916504Z",
    fill: "#525251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4291 0.916504H56.3369V99.048H56.4291V0.916504Z",
    fill: "#515150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5255 0.916504H56.4333V99.048H56.5255V0.916504Z",
    fill: "#504F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6176 0.916504H56.5255V99.048H56.6176V0.916504Z",
    fill: "#4F4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7098 0.916504H56.6176V99.048H56.7098V0.916504Z",
    fill: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8019 0.916504H56.7098V99.048H56.8019V0.916504Z",
    fill: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8983 0.916504H56.8061V99.048H56.8983V0.916504Z",
    fill: "#4C4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9905 0.916504H56.8983V99.048H56.9905V0.916504Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0826 0.916504H56.9905V99.048H57.0826V0.916504Z",
    fill: "#494948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1748 0.916504H57.0826V99.048H57.1748V0.916504Z",
    fill: "#484847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2712 0.916504H57.179V99.048H57.2712V0.916504Z",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3633 0.916504H57.2711V99.048H57.3633V0.916504Z",
    fill: "#464645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4555 0.916504H57.3633V99.048H57.4555V0.916504Z",
    fill: "#454544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5477 0.916504H57.4555V99.048H57.5477V0.916504Z",
    fill: "#444443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.644 0.916504H57.5518V99.048H57.644V0.916504Z",
    fill: "#434342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7362 0.916504H57.644V99.048H57.7362V0.916504Z",
    fill: "#424241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8283 0.916504H57.7362V99.048H57.8283V0.916504Z",
    fill: "#414040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9205 0.916504H57.8283V99.048H57.9205V0.916504Z",
    fill: "#403F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0169 0.916504H57.9247V99.048H58.0169V0.916504Z",
    fill: "#3F3E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.109 0.916504H58.0169V99.048H58.109V0.916504Z",
    fill: "#3D3D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2012 0.916504H58.109V99.048H58.2012V0.916504Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2305 0.916504H58.2012V99.048H58.2305V0.916504Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2598 0.916504H58.2305V99.048H58.2598V0.916504Z",
    fill: "#3D3D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2934 0.916504H58.264V99.048H58.2934V0.916504Z",
    fill: "#3F3E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3227 0.916504H58.2934V99.048H58.3227V0.916504Z",
    fill: "#403F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.352 0.916504H58.3227V99.048H58.352V0.916504Z",
    fill: "#414040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3813 0.916504H58.352V99.048H58.3813V0.916504Z",
    fill: "#424241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4107 0.916504H58.3813V99.048H58.4107V0.916504Z",
    fill: "#434342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.44 0.916504H58.4106V99.048H58.44V0.916504Z",
    fill: "#444443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4693 0.916504H58.44V99.048H58.4693V0.916504Z",
    fill: "#454544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4986 0.916504H58.4693V99.048H58.4986V0.916504Z",
    fill: "#464645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.528 0.916504H58.4986V99.048H58.528V0.916504Z",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5573 0.916504H58.528V99.048H58.5573V0.916504Z",
    fill: "#484847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5866 0.916504H58.5573V99.048H58.5866V0.916504Z",
    fill: "#494948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6159 0.916504H58.5866V99.048H58.6159V0.916504Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6453 0.916504H58.6159V99.048H58.6453V0.916504Z",
    fill: "#4C4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6746 0.916504H58.6453V99.048H58.6746V0.916504Z",
    fill: "#4D4C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7039 0.916504H58.6746V99.048H58.7039V0.916504Z",
    fill: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7332 0.916504H58.7039V99.048H58.7332V0.916504Z",
    fill: "#4F4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7626 0.916504H58.7332V99.048H58.7626V0.916504Z",
    fill: "#504F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7961 0.916504H58.7668V99.048H58.7961V0.916504Z",
    fill: "#515050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8254 0.916504H58.7961V99.048H58.8254V0.916504Z",
    fill: "#525251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8547 0.916504H58.8254V99.048H58.8547V0.916504Z",
    fill: "#535352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8841 0.916504H58.8547V99.048H58.8841V0.916504Z",
    fill: "#545453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9134 0.916504H58.884V99.048H58.9134V0.916504Z",
    fill: "#555554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9427 0.916504H58.9134V99.048H58.9427V0.916504Z",
    fill: "#565655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.972 0.916504H58.9427V99.048H58.972V0.916504Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0014 0.916504H58.972V99.048H59.0014V0.916504Z",
    fill: "#585857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0307 0.916504H59.0014V99.048H59.0307V0.916504Z",
    fill: "#595958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.06 0.916504H59.0307V99.048H59.06V0.916504Z",
    fill: "#5A5A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0893 0.916504H59.06V99.048H59.0893V0.916504Z",
    fill: "#5B5B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1186 0.916504H59.0893V99.048H59.1186V0.916504Z",
    fill: "#5C5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.148 0.916504H59.1187V99.048H59.148V0.916504Z",
    fill: "#5D5D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1773 0.916504H59.148V99.048H59.1773V0.916504Z",
    fill: "#5E5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2066 0.916504H59.1773V99.048H59.2066V0.916504Z",
    fill: "#5F5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.236 0.916504H59.2066V99.048H59.236V0.916504Z",
    fill: "#605F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2653 0.916504H59.236V99.048H59.2653V0.916504Z",
    fill: "#616060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2988 0.916504H59.2695V99.048H59.2988V0.916504Z",
    fill: "#626161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3281 0.916504H59.2988V99.048H59.3281V0.916504Z",
    fill: "#636262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3575 0.916504H59.3281V99.048H59.3575V0.916504Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3868 0.916504H59.3575V99.048H59.3868V0.916504Z",
    fill: "#646463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4161 0.916504H59.3868V99.048H59.4161V0.916504Z",
    fill: "#656564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4454 0.916504H59.4161V99.048H59.4454V0.916504Z",
    fill: "#666665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4748 0.916504H59.4454V99.048H59.4748V0.916504Z",
    fill: "#676766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5041 0.916504H59.4747V99.048H59.5041V0.916504Z",
    fill: "#686867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5334 0.916504H59.5041V99.048H59.5334V0.916504Z",
    fill: "#696968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5627 0.916504H59.5334V99.048H59.5627V0.916504Z",
    fill: "#6A6A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5921 0.916504H59.5627V99.048H59.5921V0.916504Z",
    fill: "#6B6B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6214 0.916504H59.5921V99.048H59.6214V0.916504Z",
    fill: "#6C6C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6507 0.916504H59.6214V99.048H59.6507V0.916504Z",
    fill: "#6D6D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68 0.916504H59.6507V99.048H59.68V0.916504Z",
    fill: "#6E6E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7093 0.916504H59.68V99.048H59.7093V0.916504Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7387 0.916504H59.7094V99.048H59.7387V0.916504Z",
    fill: "#706F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.768 0.916504H59.7387V99.048H59.768V0.916504Z",
    fill: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8015 0.916504H59.7722V99.048H59.8015V0.916504Z",
    fill: "#727171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8309 0.916504H59.8015V99.048H59.8309V0.916504Z",
    fill: "#737272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8602 0.916504H59.8308V99.048H59.8602V0.916504Z",
    fill: "#747373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8895 0.916504H59.8602V99.048H59.8895V0.916504Z",
    fill: "#757474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9188 0.916504H59.8895V99.048H59.9188V0.916504Z",
    fill: "#767575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9482 0.916504H59.9188V99.048H59.9482V0.916504Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9775 0.916504H59.9482V99.048H59.9775V0.916504Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0068 0.916504H59.9775V99.048H60.0068V0.916504Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0361 0.916504H60.0068V99.048H60.0361V0.916504Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0655 0.916504H60.0361V99.048H60.0655V0.916504Z",
    fill: "#7A7A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0948 0.916504H60.0654V99.048H60.0948V0.916504Z",
    fill: "#7B7B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1241 0.916504H60.0948V99.048H60.1241V0.916504Z",
    fill: "#7C7C7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1534 0.916504H60.1241V99.048H60.1534V0.916504Z",
    fill: "#7D7D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1828 0.916504H60.1534V99.048H60.1828V0.916504Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2121 0.916504H60.1828V99.048H60.2121V0.916504Z",
    fill: "#7F7F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2414 0.916504H60.2121V99.048H60.2414V0.916504Z",
    fill: "#80807F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2749 0.916504H60.2456V99.048H60.2749V0.916504Z",
    fill: "#818180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3042 0.916504H60.2749V99.048H60.3042V0.916504Z",
    fill: "#828281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3336 0.916504H60.3042V99.048H60.3336V0.916504Z",
    fill: "#838282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3629 0.916504H60.3336V99.048H60.3629V0.916504Z",
    fill: "#848383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3922 0.916504H60.3629V99.048H60.3922V0.916504Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4215 0.916504H60.3922V99.048H60.4215V0.916504Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4509 0.916504H60.4215V99.048H60.4509V0.916504Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4802 0.916504H60.4509V99.048H60.4802V0.916504Z",
    fill: "#878786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5095 0.916504H60.4802V99.048H60.5095V0.916504Z",
    fill: "#888887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5388 0.916504H60.5095V99.048H60.5388V0.916504Z",
    fill: "#898988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5682 0.916504H60.5388V99.048H60.5682V0.916504Z",
    fill: "#8A8A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5975 0.916504H60.5682V99.048H60.5975V0.916504Z",
    fill: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6268 0.916504H60.5975V99.048H60.6268V0.916504Z",
    fill: "#8C8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6562 0.916504H60.6268V99.048H60.6562V0.916504Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6855 0.916504H60.6562V99.048H60.6855V0.916504Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7148 0.916504H60.6855V99.048H60.7148V0.916504Z",
    fill: "#8E8E8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7441 0.916504H60.7148V99.048H60.7441V0.916504Z",
    fill: "#8F8F8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7777 0.916504H60.7483V99.048H60.7777V0.916504Z",
    fill: "#90908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.807 0.916504H60.7776V99.048H60.807V0.916504Z",
    fill: "#919090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8363 0.916504H60.807V99.048H60.8363V0.916504Z",
    fill: "#929191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8656 0.916504H60.8363V99.048H60.8656V0.916504Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8949 0.916504H60.8656V99.048H60.8949V0.916504Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9243 0.916504H60.8949V99.048H60.9243V0.916504Z",
    fill: "#949493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9536 0.916504H60.9243V99.048H60.9536V0.916504Z",
    fill: "#959594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9829 0.916504H60.9536V99.048H60.9829V0.916504Z",
    fill: "#969695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0122 0.916504H60.9829V99.048H61.0122V0.916504Z",
    fill: "#979696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0416 0.916504H61.0122V99.048H61.0416V0.916504Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0709 0.916504H61.0416V99.048H61.0709V0.916504Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1002 0.916504H61.0709V99.048H61.1002V0.916504Z",
    fill: "#999998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1295 0.916504H61.1002V99.048H61.1295V0.916504Z",
    fill: "#9A9A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1589 0.916504H61.1295V99.048H61.1589V0.916504Z",
    fill: "#9B9B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1882 0.916504H61.1589V99.048H61.1882V0.916504Z",
    fill: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2175 0.916504H61.1882V99.048H61.2175V0.916504Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2469 0.916504H61.2175V99.048H61.2469V0.916504Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2804 0.916504H61.251V99.048H61.2804V0.916504Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3097 0.916504H61.2804V99.048H61.3097V0.916504Z",
    fill: "#9F9F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.339 0.916504H61.3097V99.048H61.339V0.916504Z",
    fill: "#A0A09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3683 0.916504H61.339V99.048H61.3683V0.916504Z",
    fill: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3977 0.916504H61.3683V99.048H61.3977V0.916504Z",
    fill: "#A2A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.427 0.916504H61.3977V99.048H61.427V0.916504Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4563 0.916504H61.427V99.048H61.4563V0.916504Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4856 0.916504H61.4563V99.048H61.4856V0.916504Z",
    fill: "#A4A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.515 0.916504H61.4856V99.048H61.515V0.916504Z",
    fill: "#A5A5A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5443 0.916504H61.515V99.048H61.5443V0.916504Z",
    fill: "#A6A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5736 0.916504H61.5443V99.048H61.5736V0.916504Z",
    fill: "#A7A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6029 0.916504H61.5736V99.048H61.6029V0.916504Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6323 0.916504H61.6029V99.048H61.6323V0.916504Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6616 0.916504H61.6323V99.048H61.6616V0.916504Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6909 0.916504H61.6616V99.048H61.6909V0.916504Z",
    fill: "#AAAAA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7202 0.916504H61.6909V99.048H61.7202V0.916504Z",
    fill: "#ABABAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7538 0.916504H61.7244V99.048H61.7538V0.916504Z",
    fill: "#ACACAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7831 0.916504H61.7538V99.048H61.7831V0.916504Z",
    fill: "#ADACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8124 0.916504H61.7831V99.048H61.8124V0.916504Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8417 0.916504H61.8124V99.048H61.8417V0.916504Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8711 0.916504H61.8417V99.048H61.8711V0.916504Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9004 0.916504H61.8711V99.048H61.9004V0.916504Z",
    fill: "#B0B0AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9297 0.916504H61.9004V99.048H61.9297V0.916504Z",
    fill: "#B1B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.959 0.916504H61.9297V99.048H61.959V0.916504Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9884 0.916504H61.959V99.048H61.9884V0.916504Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0177 0.916504H61.9884V99.048H62.0177V0.916504Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.047 0.916504H62.0177V99.048H62.047V0.916504Z",
    fill: "#B4B4B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0763 0.916504H62.047V99.048H62.0763V0.916504Z",
    fill: "#B5B5B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1057 0.916504H62.0763V99.048H62.1057V0.916504Z",
    fill: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.135 0.916504H62.1057V99.048H62.135V0.916504Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1643 0.916504H62.135V99.048H62.1643V0.916504Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1936 0.916504H62.1643V99.048H62.1936V0.916504Z",
    fill: "#B8B8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.223 0.916504H62.1936V99.048H62.223V0.916504Z",
    fill: "#B9B9B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2565 0.916504H62.2272V99.048H62.2565V0.916504Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2858 0.916504H62.2565V99.048H62.2858V0.916504Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3151 0.916504H62.2858V99.048H62.3151V0.916504Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3445 0.916504H62.3151V99.048H62.3445V0.916504Z",
    fill: "#BCBCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3738 0.916504H62.3445V99.048H62.3738V0.916504Z",
    fill: "#BDBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4031 0.916504H62.3738V99.048H62.4031V0.916504Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4324 0.916504H62.4031V99.048H62.4324V0.916504Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4618 0.916504H62.4324V99.048H62.4618V0.916504Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4911 0.916504H62.4618V99.048H62.4911V0.916504Z",
    fill: "#C0C0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5204 0.916504H62.4911V99.048H62.5204V0.916504Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5497 0.916504H62.5204V99.048H62.5497V0.916504Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5791 0.916504H62.5497V99.048H62.5791V0.916504Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6084 0.916504H62.5791V99.048H62.6084V0.916504Z",
    fill: "#C3C3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6377 0.916504H62.6084V99.048H62.6377V0.916504Z",
    fill: "#C4C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.667 0.916504H62.6377V99.048H62.667V0.916504Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6964 0.916504H62.667V99.048H62.6964V0.916504Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7257 0.916504H62.6964V99.048H62.7257V0.916504Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7592 0.916504H62.7299V99.048H62.7592V0.916504Z",
    fill: "#C7C7C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7885 0.916504H62.7592V99.048H62.7885V0.916504Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8179 0.916504H62.7885V99.048H62.8179V0.916504Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8472 0.916504H62.8179V99.048H62.8472V0.916504Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8765 0.916504H62.8472V99.048H62.8765V0.916504Z",
    fill: "#CACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9058 0.916504H62.8765V99.048H62.9058V0.916504Z",
    fill: "#CBCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9352 0.916504H62.9058V99.048H62.9352V0.916504Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9645 0.916504H62.9352V99.048H62.9645V0.916504Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9938 0.916504H62.9645V99.048H62.9938V0.916504Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0231 0.916504H62.9938V99.048H63.0231V0.916504Z",
    fill: "#CECECD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0525 0.916504H63.0231V99.048H63.0525V0.916504Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0818 0.916504H63.0525V99.048H63.0818V0.916504Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1111 0.916504H63.0818V99.048H63.1111V0.916504Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1404 0.916504H63.1111V99.048H63.1404V0.916504Z",
    fill: "#D1D1D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1698 0.916504H63.1404V99.048H63.1698V0.916504Z",
    fill: "#D2D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1991 0.916504H63.1698V99.048H63.1991V0.916504Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2284 0.916504H63.1991V99.048H63.2284V0.916504Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2619 0.916504H63.2326V99.048H63.2619V0.916504Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2913 0.916504H63.2619V99.048H63.2913V0.916504Z",
    fill: "#D5D5D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3206 0.916504H63.2913V99.048H63.3206V0.916504Z",
    fill: "#D6D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3499 0.916504H63.3206V99.048H63.3499V0.916504Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3792 0.916504H63.3499V99.048H63.3792V0.916504Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4086 0.916504H63.3792V99.048H63.4086V0.916504Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4379 0.916504H63.4086V99.048H63.4379V0.916504Z",
    fill: "#D9D9D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4672 0.916504H63.4379V99.048H63.4672V0.916504Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4965 0.916504H63.4672V99.048H63.4965V0.916504Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5259 0.916504H63.4965V99.048H63.5259V0.916504Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5552 0.916504H63.5258V99.048H63.5552V0.916504Z",
    fill: "#DCDCDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5845 0.916504H63.5552V99.048H63.5845V0.916504Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6138 0.916504H63.5845V99.048H63.6138V0.916504Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6432 0.916504H63.6138V99.048H63.6432V0.916504Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6725 0.916504H63.6432V99.048H63.6725V0.916504Z",
    fill: "#DFDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7018 0.916504H63.6725V99.048H63.7018V0.916504Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7353 0.916504H63.706V99.048H63.7353V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9951 0.916504H63.7353V99.048H63.9951V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2548 0.916504H63.9951V99.048H64.2548V0.916504Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5145 0.916504H64.2548V99.048H64.5145V0.916504Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7743 0.916504H64.5145V99.048H64.7743V0.916504Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.034 0.916504H64.7743V99.048H65.034V0.916504Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2938 0.916504H65.034V99.048H65.2938V0.916504Z",
    fill: "#E4E4E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5535 0.916504H65.2938V99.048H65.5535V0.916504Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8133 0.916504H65.5535V99.048H65.8133V0.916504Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.073 0.916504H65.8132V99.048H66.073V0.916504Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3327 0.916504H66.073V99.048H66.3327V0.916504Z",
    fill: "#E7E7E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5925 0.916504H66.3327V99.048H66.5925V0.916504Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8522 0.916504H66.5925V99.048H66.8522V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.112 0.916504H66.8522V99.048H67.112V0.916504Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3717 0.916504H67.112V99.048H67.3717V0.916504Z",
    fill: "#EAEAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6314 0.916504H67.3717V99.048H67.6314V0.916504Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8912 0.916504H67.6314V99.048H67.8912V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1509 0.916504H67.8912V99.048H68.1509V0.916504Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4106 0.916504H68.1509V99.048H68.4106V0.916504Z",
    fill: "#EDEDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6704 0.916504H68.4106V99.048H68.6704V0.916504Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9301 0.916504H68.6704V99.048H68.9301V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1899 0.916504H68.9301V99.048H69.1899V0.916504Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4496 0.916504H69.1899V99.048H69.4496V0.916504Z",
    fill: "#F0F0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7094 0.916504H69.4496V99.048H69.7094V0.916504Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9691 0.916504H69.7094V99.048H69.9691V0.916504Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2288 0.916504H69.9691V99.048H70.2288V0.916504Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4886 0.916504H70.2288V99.048H70.4886V0.916504Z",
    fill: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7483 0.916504H70.4886V99.048H70.7483V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0081 0.916504H70.7483V99.048H71.0081V0.916504Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2678 0.916504H71.0081V99.048H71.2678V0.916504Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5275 0.916504H71.2678V99.048H71.5275V0.916504Z",
    fill: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7873 0.916504H71.5275V99.048H71.7873V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.047 0.916504H71.7873V99.048H72.047V0.916504Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3068 0.916504H72.047V99.048H72.3068V0.916504Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5665 0.916504H72.3068V99.048H72.5665V0.916504Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8262 0.916504H72.5665V99.048H72.8262V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.086 0.916504H72.8262V99.048H73.086V0.916504Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3457 0.916504H73.086V99.048H73.3457V0.916504Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6055 0.916504H73.3457V99.048H73.6055V0.916504Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8694 0.916504H73.6096V99.048H73.8694V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1291 0.916504H73.8694V99.048H74.1291V0.916504Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3889 0.916504H74.1291V99.048H74.3889V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6486 0.916504H74.3889V99.048H74.6486V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9084 0.916504H74.6486V99.048H74.9084V0.916504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9586 0.916504H74.9084V99.048H74.9586V0.916504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0089 0.916504H74.9586V99.048H75.0089V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0592 0.916504H75.0089V99.048H75.0592V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1136 0.916504H75.0634V99.048H75.1136V0.916504Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1639 0.916504H75.1136V99.048H75.1639V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2184 0.916504H75.1681V99.048H75.2184V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2686 0.916504H75.2184V99.048H75.2686V0.916504Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3189 0.916504H75.2686V99.048H75.3189V0.916504Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3734 0.916504H75.3231V99.048H75.3734V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4237 0.916504H75.3734V99.048H75.4237V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4781 0.916504H75.4278V99.048H75.4781V0.916504Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5284 0.916504H75.4781V99.048H75.5284V0.916504Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5787 0.916504H75.5284V99.048H75.5787V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6331 0.916504H75.5828V99.048H75.6331V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6834 0.916504H75.6331V99.048H75.6834V0.916504Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7378 0.916504H75.6876V99.048H75.7378V0.916504Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7881 0.916504H75.7378V99.048H75.7881V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8384 0.916504H75.7881V99.048H75.8384V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8929 0.916504H75.8426V99.048H75.8929V0.916504Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9431 0.916504H75.8929V99.048H75.9431V0.916504Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9976 0.916504H75.9473V99.048H75.9976V0.916504Z",
    fill: "#F1F1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0479 0.916504H75.9976V99.048H76.0479V0.916504Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1023 0.916504H76.052V99.048H76.1023V0.916504Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1526 0.916504H76.1023V99.048H76.1526V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2029 0.916504H76.1526V99.048H76.2029V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2573 0.916504H76.207V99.048H76.2573V0.916504Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3076 0.916504H76.2573V99.048H76.3076V0.916504Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3621 0.916504H76.3118V99.048H76.3621V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4123 0.916504H76.3621V99.048H76.4123V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4626 0.916504H76.4123V99.048H76.4626V0.916504Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5171 0.916504H76.4668V99.048H76.5171V0.916504Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5673 0.916504H76.5171V99.048H76.5673V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6218 0.916504H76.5715V99.048H76.6218V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6721 0.916504H76.6218V99.048H76.6721V0.916504Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7223 0.916504H76.6721V99.048H76.7223V0.916504Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7768 0.916504H76.7265V99.048H76.7768V0.916504Z",
    fill: "#E6E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8271 0.916504H76.7768V99.048H76.8271V0.916504Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8815 0.916504H76.8313V99.048H76.8815V0.916504Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9318 0.916504H76.8815V99.048H76.9318V0.916504Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9821 0.916504H76.9318V99.048H76.9821V0.916504Z",
    fill: "#E3E3E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0365 0.916504H76.9863V99.048H77.0365V0.916504Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0868 0.916504H77.0365V99.048H77.0868V0.916504Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1413 0.916504H77.091V99.048H77.1413V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1915 0.916504H77.1413V99.048H77.1915V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2418 0.916504H77.1915V99.048H77.2418V0.916504Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2963 0.916504H77.246V99.048H77.2963V0.916504Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3466 0.916504H77.2963V99.048H77.3466V0.916504Z",
    fill: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.401 0.916504H77.3507V99.048H77.401V0.916504Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4513 0.916504H77.401V99.048H77.4513V0.916504Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5016 0.916504H77.4513V99.048H77.5016V0.916504Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.556 0.916504H77.5058V99.048H77.556V0.916504Z",
    fill: "#DBDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6063 0.916504H77.556V99.048H77.6063V0.916504Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6608 0.916504H77.6105V99.048H77.6608V0.916504Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.711 0.916504H77.6608V99.048H77.711V0.916504Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7613 0.916504H77.711V99.048H77.7613V0.916504Z",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8158 0.916504H77.7655V99.048H77.8158V0.916504Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.866 0.916504H77.8158V99.048H77.866V0.916504Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9205 0.916504H77.8702V99.048H77.9205V0.916504Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9708 0.916504H77.9205V99.048H77.9708V0.916504Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.021 0.916504H77.9708V99.048H78.021V0.916504Z",
    fill: "#D4D4D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0755 0.916504H78.0252V99.048H78.0755V0.916504Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1258 0.916504H78.0755V99.048H78.1258V0.916504Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1802 0.916504H78.13V99.048H78.1802V0.916504Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2305 0.916504H78.1802V99.048H78.2305V0.916504Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2808 0.916504H78.2305V99.048H78.2808V0.916504Z",
    fill: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3352 0.916504H78.285V99.048H78.3352V0.916504Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3855 0.916504H78.3353V99.048H78.3855V0.916504Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.44 0.916504H78.3897V99.048H78.44V0.916504Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4902 0.916504H78.44V99.048H78.4902V0.916504Z",
    fill: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5405 0.916504H78.4902V99.048H78.5405V0.916504Z",
    fill: "#CCCCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.595 0.916504H78.5447V99.048H78.595V0.916504Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6453 0.916504H78.595V99.048H78.6453V0.916504Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6997 0.916504H78.6494V99.048H78.6997V0.916504Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.75 0.916504H78.6997V99.048H78.75V0.916504Z",
    fill: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8003 0.916504H78.75V99.048H78.8003V0.916504Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8547 0.916504H78.8045V99.048H78.8547V0.916504Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.905 0.916504H78.8547V99.048H78.905V0.916504Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9594 0.916504H78.9092V99.048H78.9594V0.916504Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0097 0.916504H78.9595V99.048H79.0097V0.916504Z",
    fill: "#C5C5C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0642 0.916504H79.0139V99.048H79.0642V0.916504Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1145 0.916504H79.0642V99.048H79.1145V0.916504Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1647 0.916504H79.1145V99.048H79.1647V0.916504Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2192 0.916504H79.1689V99.048H79.2192V0.916504Z",
    fill: "#C2C2C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2695 0.916504H79.2192V99.048H79.2695V0.916504Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3239 0.916504H79.2737V99.048H79.3239V0.916504Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3742 0.916504H79.3239V99.048H79.3742V0.916504Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4245 0.916504H79.3742V99.048H79.4245V0.916504Z",
    fill: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4789 0.916504H79.4287V99.048H79.4789V0.916504Z",
    fill: "#BEBEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5292 0.916504H79.4789V99.048H79.5292V0.916504Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5837 0.916504H79.5334V99.048H79.5837V0.916504Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6339 0.916504H79.5837V99.048H79.6339V0.916504Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6842 0.916504H79.6339V99.048H79.6842V0.916504Z",
    fill: "#BBBBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7387 0.916504H79.6884V99.048H79.7387V0.916504Z",
    fill: "#BABAB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.789 0.916504H79.7387V99.048H79.789V0.916504Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8434 0.916504H79.7932V99.048H79.8434V0.916504Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8937 0.916504H79.8434V99.048H79.8937V0.916504Z",
    fill: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9439 0.916504H79.8937V99.048H79.9439V0.916504Z",
    fill: "#B7B7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9984 0.916504H79.9482V99.048H79.9984V0.916504Z",
    fill: "#B6B6B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0487 0.916504H79.9984V99.048H80.0487V0.916504Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1032 0.916504H80.0529V99.048H80.1032V0.916504Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1534 0.916504H80.1031V99.048H80.1534V0.916504Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2037 0.916504H80.1534V99.048H80.2037V0.916504Z",
    fill: "#B3B3B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2582 0.916504H80.2079V99.048H80.2582V0.916504Z",
    fill: "#B2B2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3084 0.916504H80.2582V99.048H80.3084V0.916504Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3629 0.916504H80.3126V99.048H80.3629V0.916504Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4132 0.916504H80.3629V99.048H80.4132V0.916504Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4634 0.916504H80.4132V99.048H80.4634V0.916504Z",
    fill: "#AFAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5179 0.916504H80.4676V99.048H80.5179V0.916504Z",
    fill: "#AEAEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5682 0.916504H80.5179V99.048H80.5682V0.916504Z",
    fill: "#ADADAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6226 0.916504H80.5724V99.048H80.6226V0.916504Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6729 0.916504H80.6226V99.048H80.6729V0.916504Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7232 0.916504H80.6729V99.048H80.7232V0.916504Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7776 0.916504H80.7274V99.048H80.7776V0.916504Z",
    fill: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8279 0.916504H80.7776V99.048H80.8279V0.916504Z",
    fill: "#A9A9A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8824 0.916504H80.8321V99.048H80.8824V0.916504Z",
    fill: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9327 0.916504H80.8824V99.048H80.9327V0.916504Z",
    fill: "#A7A7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9829 0.916504H80.9326V99.048H80.9829V0.916504Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0374 0.916504H80.9871V99.048H81.0374V0.916504Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0877 0.916504H81.0374V99.048H81.0877V0.916504Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1421 0.916504H81.0918V99.048H81.1421V0.916504Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1924 0.916504H81.1421V99.048H81.1924V0.916504Z",
    fill: "#A3A3A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2427 0.916504H81.1924V99.048H81.2427V0.916504Z",
    fill: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2971 0.916504H81.2469V99.048H81.2971V0.916504Z",
    fill: "#A1A1A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3474 0.916504H81.2971V99.048H81.3474V0.916504Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4018 0.916504H81.3516V99.048H81.4018V0.916504Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4521 0.916504H81.4019V99.048H81.4521V0.916504Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5024 0.916504H81.4521V99.048H81.5024V0.916504Z",
    fill: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5569 0.916504H81.5066V99.048H81.5569V0.916504Z",
    fill: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6071 0.916504H81.5569V99.048H81.6071V0.916504Z",
    fill: "#9C9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6616 0.916504H81.6113V99.048H81.6616V0.916504Z",
    fill: "#9B9B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7119 0.916504H81.6616V99.048H81.7119V0.916504Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7663 0.916504H81.7161V99.048H81.7663V0.916504Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8166 0.916504H81.7663V99.048H81.8166V0.916504Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8669 0.916504H81.8166V99.048H81.8669V0.916504Z",
    fill: "#989797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9213 0.916504H81.8711V99.048H81.9213V0.916504Z",
    fill: "#979796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9716 0.916504H81.9213V99.048H81.9716V0.916504Z",
    fill: "#969695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0261 0.916504H81.9758V99.048H82.0261V0.916504Z",
    fill: "#959594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0763 0.916504H82.0261V99.048H82.0763V0.916504Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1266 0.916504H82.0763V99.048H82.1266V0.916504Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1811 0.916504H82.1308V99.048H82.1811V0.916504Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2314 0.916504H82.1811V99.048H82.2314V0.916504Z",
    fill: "#929291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2858 0.916504H82.2355V99.048H82.2858V0.916504Z",
    fill: "#919190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3361 0.916504H82.2858V99.048H82.3361V0.916504Z",
    fill: "#90908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3864 0.916504H82.3361V99.048H82.3864V0.916504Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4408 0.916504H82.3905V99.048H82.4408V0.916504Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4911 0.916504H82.4408V99.048H82.4911V0.916504Z",
    fill: "#8E8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5455 0.916504H82.4953V99.048H82.5455V0.916504Z",
    fill: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5958 0.916504H82.5455V99.048H82.5958V0.916504Z",
    fill: "#8C8C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6461 0.916504H82.5958V99.048H82.6461V0.916504Z",
    fill: "#8B8B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7006 0.916504H82.6503V99.048H82.7006V0.916504Z",
    fill: "#8A8A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7508 0.916504H82.7006V99.048H82.7508V0.916504Z",
    fill: "#898988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8053 0.916504H82.755V99.048H82.8053V0.916504Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8556 0.916504H82.8053V99.048H82.8556V0.916504Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9058 0.916504H82.8556V99.048H82.9058V0.916504Z",
    fill: "#878686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9603 0.916504H82.91V99.048H82.9603V0.916504Z",
    fill: "#868585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0106 0.916504H82.9603V99.048H83.0106V0.916504Z",
    fill: "#858584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.065 0.916504H83.0148V99.048H83.065V0.916504Z",
    fill: "#848483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1153 0.916504H83.065V99.048H83.1153V0.916504Z",
    fill: "#838382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1656 0.916504H83.1153V99.048H83.1656V0.916504Z",
    fill: "#828281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.22 0.916504H83.1698V99.048H83.22V0.916504Z",
    fill: "#818180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2703 0.916504H83.22V99.048H83.2703V0.916504Z",
    fill: "#80807F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3248 0.916504H83.2745V99.048H83.3248V0.916504Z",
    fill: "#7F7F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.375 0.916504H83.3248V99.048H83.375V0.916504Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4253 0.916504H83.375V99.048H83.4253V0.916504Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4798 0.916504H83.4295V99.048H83.4798V0.916504Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5301 0.916504H83.4798V99.048H83.5301V0.916504Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5845 0.916504H83.5342V99.048H83.5845V0.916504Z",
    fill: "#7B7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6348 0.916504H83.5845V99.048H83.6348V0.916504Z",
    fill: "#7A7979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6851 0.916504H83.6348V99.048H83.6851V0.916504Z",
    fill: "#797878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7395 0.916504H83.6892V99.048H83.7395V0.916504Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7898 0.916504H83.7395V99.048H83.7898V0.916504Z",
    fill: "#777676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8442 0.916504H83.794V99.048H83.8442V0.916504Z",
    fill: "#767575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8945 0.916504H83.8443V99.048H83.8945V0.916504Z",
    fill: "#757474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9448 0.916504H83.8945V99.048H83.9448V0.916504Z",
    fill: "#747473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9993 0.916504H83.949V99.048H83.9993V0.916504Z",
    fill: "#737372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0495 0.916504H83.9993V99.048H84.0495V0.916504Z",
    fill: "#727271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.104 0.916504H84.0537V99.048H84.104V0.916504Z",
    fill: "#717170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1543 0.916504H84.104V99.048H84.1543V0.916504Z",
    fill: "#70706F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2045 0.916504H84.1543V99.048H84.2045V0.916504Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.259 0.916504H84.2087V99.048H84.259V0.916504Z",
    fill: "#6E6E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3093 0.916504H84.259V99.048H84.3093V0.916504Z",
    fill: "#6D6D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3637 0.916504H84.3135V99.048H84.3637V0.916504Z",
    fill: "#6C6C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.414 0.916504H84.3637V99.048H84.414V0.916504Z",
    fill: "#6B6B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4643 0.916504H84.414V99.048H84.4643V0.916504Z",
    fill: "#6A6A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5187 0.916504H84.4685V99.048H84.5187V0.916504Z",
    fill: "#696968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.569 0.916504H84.5187V99.048H84.569V0.916504Z",
    fill: "#686867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6235 0.916504H84.5732V99.048H84.6235V0.916504Z",
    fill: "#676766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6737 0.916504H84.6235V99.048H84.6737V0.916504Z",
    fill: "#666665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7282 0.916504H84.6779V99.048H84.7282V0.916504Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7785 0.916504H84.7282V99.048H84.7785V0.916504Z",
    fill: "#656464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8287 0.916504H84.7785V99.048H84.8287V0.916504Z",
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8832 0.916504H84.8329V99.048H84.8832V0.916504Z",
    fill: "#636262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9335 0.916504H84.8832V99.048H84.9335V0.916504Z",
    fill: "#626161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9879 0.916504H84.9377V99.048H84.9879V0.916504Z",
    fill: "#616060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0382 0.916504H84.9879V99.048H85.0382V0.916504Z",
    fill: "#605F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0885 0.916504H85.0382V99.048H85.0885V0.916504Z",
    fill: "#5F5F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.143 0.916504H85.0927V99.048H85.143V0.916504Z",
    fill: "#5E5E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1932 0.916504H85.1429V99.048H85.1932V0.916504Z",
    fill: "#5D5D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2477 0.916504H85.1974V99.048H85.2477V0.916504Z",
    fill: "#5C5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.298 0.916504H85.2477V99.048H85.298V0.916504Z",
    fill: "#5B5B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3482 0.916504H85.298V99.048H85.3482V0.916504Z",
    fill: "#5A5A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4027 0.916504H85.3524V99.048H85.4027V0.916504Z",
    fill: "#595958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.453 0.916504H85.4027V99.048H85.453V0.916504Z",
    fill: "#585857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5074 0.916504H85.4572V99.048H85.5074V0.916504Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5577 0.916504H85.5074V99.048H85.5577V0.916504Z",
    fill: "#565655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.608 0.916504H85.5577V99.048H85.608V0.916504Z",
    fill: "#555554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6624 0.916504H85.6122V99.048H85.6624V0.916504Z",
    fill: "#545453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7127 0.916504H85.6624V99.048H85.7127V0.916504Z",
    fill: "#535352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7672 0.916504H85.7169V99.048H85.7672V0.916504Z",
    fill: "#525251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8174 0.916504H85.7672V99.048H85.8174V0.916504Z",
    fill: "#515150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8677 0.916504H85.8174V99.048H85.8677V0.916504Z",
    fill: "#504F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9222 0.916504H85.8719V99.048H85.9222V0.916504Z",
    fill: "#4F4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9725 0.916504H85.9222V99.048H85.9725V0.916504Z",
    fill: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0269 0.916504H85.9766V99.048H86.0269V0.916504Z",
    fill: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0772 0.916504H86.0269V99.048H86.0772V0.916504Z",
    fill: "#4C4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1274 0.916504H86.0772V99.048H86.1274V0.916504Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1819 0.916504H86.1317V99.048H86.1819V0.916504Z",
    fill: "#494948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2322 0.916504H86.1819V99.048H86.2322V0.916504Z",
    fill: "#484847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2866 0.916504H86.2364V99.048H86.2866V0.916504Z",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3369 0.916504H86.2867V99.048H86.3369V0.916504Z",
    fill: "#464645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3872 0.916504H86.3369V99.048H86.3872V0.916504Z",
    fill: "#454544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4417 0.916504H86.3914V99.048H86.4417V0.916504Z",
    fill: "#444443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4919 0.916504H86.4417V99.048H86.4919V0.916504Z",
    fill: "#434342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5464 0.916504H86.4961V99.048H86.5464V0.916504Z",
    fill: "#424241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5967 0.916504H86.5464V99.048H86.5967V0.916504Z",
    fill: "#414040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6469 0.916504H86.5967V99.048H86.6469V0.916504Z",
    fill: "#403F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7014 0.916504H86.6511V99.048H86.7014V0.916504Z",
    fill: "#3F3E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7517 0.916504H86.7014V99.048H86.7517V0.916504Z",
    fill: "#3D3D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8061 0.916504H86.7559V99.048H86.8061V0.916504Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8648 0.916504H86.8061V99.048H86.8648V0.916504Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9234 0.916504H86.8648V99.048H86.9234V0.916504Z",
    fill: "#3D3D3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9821 0.916504H86.9234V99.048H86.9821V0.916504Z",
    fill: "#3F3E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0407 0.916504H86.9821V99.048H87.0407V0.916504Z",
    fill: "#403F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0994 0.916504H87.0407V99.048H87.0994V0.916504Z",
    fill: "#414040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.158 0.916504H87.0994V99.048H87.158V0.916504Z",
    fill: "#424241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2167 0.916504H87.1581V99.048H87.2167V0.916504Z",
    fill: "#434342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2753 0.916504H87.2167V99.048H87.2753V0.916504Z",
    fill: "#444443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.334 0.916504H87.2753V99.048H87.334V0.916504Z",
    fill: "#454544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3926 0.916504H87.334V99.048H87.3926V0.916504Z",
    fill: "#464645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4513 0.916504H87.3926V99.048H87.4513V0.916504Z",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5099 0.916504H87.4513V99.048H87.5099V0.916504Z",
    fill: "#484847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5686 0.916504H87.5099V99.048H87.5686V0.916504Z",
    fill: "#494948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6272 0.916504H87.5686V99.048H87.6272V0.916504Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6859 0.916504H87.6273V99.048H87.6859V0.916504Z",
    fill: "#4C4B4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7445 0.916504H87.6859V99.048H87.7445V0.916504Z",
    fill: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8032 0.916504H87.7446V99.048H87.8032V0.916504Z",
    fill: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8618 0.916504H87.8032V99.048H87.8618V0.916504Z",
    fill: "#4F4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9205 0.916504H87.8618V99.048H87.9205V0.916504Z",
    fill: "#504F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9792 0.916504H87.9205V99.048H87.9792V0.916504Z",
    fill: "#515150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0378 0.916504H87.9792V99.048H88.0378V0.916504Z",
    fill: "#525251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0964 0.916504H88.0378V99.048H88.0964V0.916504Z",
    fill: "#535352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1551 0.916504H88.0965V99.048H88.1551V0.916504Z",
    fill: "#545453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2137 0.916504H88.1551V99.048H88.2137V0.916504Z",
    fill: "#555554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2682 0.916504H88.2096V99.048H88.2682V0.916504Z",
    fill: "#565655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3269 0.916504H88.2682V99.048H88.3269V0.916504Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3855 0.916504H88.3269V99.048H88.3855V0.916504Z",
    fill: "#585857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4441 0.916504H88.3855V99.048H88.4441V0.916504Z",
    fill: "#595958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5028 0.916504H88.4442V99.048H88.5028V0.916504Z",
    fill: "#5A5A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5615 0.916504H88.5028V99.048H88.5615V0.916504Z",
    fill: "#5B5B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6201 0.916504H88.5615V99.048H88.6201V0.916504Z",
    fill: "#5C5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6788 0.916504H88.6201V99.048H88.6788V0.916504Z",
    fill: "#5D5D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7374 0.916504H88.6788V99.048H88.7374V0.916504Z",
    fill: "#5E5E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7961 0.916504H88.7374V99.048H88.7961V0.916504Z",
    fill: "#5F5F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8547 0.916504H88.7961V99.048H88.8547V0.916504Z",
    fill: "#605F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9134 0.916504H88.8547V99.048H88.9134V0.916504Z",
    fill: "#616060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.972 0.916504H88.9134V99.048H88.972V0.916504Z",
    fill: "#626161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0307 0.916504H88.972V99.048H89.0307V0.916504Z",
    fill: "#636262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0893 0.916504H89.0307V99.048H89.0893V0.916504Z",
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.148 0.916504H89.0893V99.048H89.148V0.916504Z",
    fill: "#656464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2066 0.916504H89.148V99.048H89.2066V0.916504Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2653 0.916504H89.2066V99.048H89.2653V0.916504Z",
    fill: "#666665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3239 0.916504H89.2653V99.048H89.3239V0.916504Z",
    fill: "#676766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3826 0.916504H89.3239V99.048H89.3826V0.916504Z",
    fill: "#686867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4412 0.916504H89.3826V99.048H89.4412V0.916504Z",
    fill: "#696968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4999 0.916504H89.4412V99.048H89.4999V0.916504Z",
    fill: "#6A6A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5585 0.916504H89.4999V99.048H89.5585V0.916504Z",
    fill: "#6B6B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6172 0.916504H89.5585V99.048H89.6172V0.916504Z",
    fill: "#6C6C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6758 0.916504H89.6172V99.048H89.6758V0.916504Z",
    fill: "#6D6D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7345 0.916504H89.6758V99.048H89.7345V0.916504Z",
    fill: "#6E6E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7931 0.916504H89.7345V99.048H89.7931V0.916504Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8518 0.916504H89.7932V99.048H89.8518V0.916504Z",
    fill: "#70706F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9104 0.916504H89.8518V99.048H89.9104V0.916504Z",
    fill: "#717170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9691 0.916504H89.9104V99.048H89.9691V0.916504Z",
    fill: "#727271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0278 0.916504H89.9691V99.048H90.0278V0.916504Z",
    fill: "#737372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0864 0.916504H90.0277V99.048H90.0864V0.916504Z",
    fill: "#747473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.145 0.916504H90.0864V99.048H90.145V0.916504Z",
    fill: "#757474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2037 0.916504H90.1451V99.048H90.2037V0.916504Z",
    fill: "#767575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2624 0.916504H90.2037V99.048H90.2624V0.916504Z",
    fill: "#777676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.321 0.916504H90.2624V99.048H90.321V0.916504Z",
    fill: "#787777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3796 0.916504H90.321V99.048H90.3796V0.916504Z",
    fill: "#797878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4383 0.916504H90.3797V99.048H90.4383V0.916504Z",
    fill: "#7A7979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.497 0.916504H90.4383V99.048H90.497V0.916504Z",
    fill: "#7B7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5556 0.916504H90.4969V99.048H90.5556V0.916504Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6143 0.916504H90.5556V99.048H90.6143V0.916504Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6687 0.916504H90.6101V99.048H90.6687V0.916504Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7274 0.916504H90.6687V99.048H90.7274V0.916504Z",
    fill: "#7E7E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.786 0.916504H90.7274V99.048H90.786V0.916504Z",
    fill: "#7F7F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8447 0.916504H90.786V99.048H90.8447V0.916504Z",
    fill: "#80807F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9033 0.916504H90.8447V99.048H90.9033V0.916504Z",
    fill: "#818180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.962 0.916504H90.9033V99.048H90.962V0.916504Z",
    fill: "#828281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0206 0.916504H90.962V99.048H91.0206V0.916504Z",
    fill: "#838382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0793 0.916504H91.0206V99.048H91.0793V0.916504Z",
    fill: "#848483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1379 0.916504H91.0793V99.048H91.1379V0.916504Z",
    fill: "#858584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1966 0.916504H91.1379V99.048H91.1966V0.916504Z",
    fill: "#868585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2552 0.916504H91.1966V99.048H91.2552V0.916504Z",
    fill: "#878686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3139 0.916504H91.2552V99.048H91.3139V0.916504Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3725 0.916504H91.3139V99.048H91.3725V0.916504Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4312 0.916504H91.3725V99.048H91.4312V0.916504Z",
    fill: "#898988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4898 0.916504H91.4312V99.048H91.4898V0.916504Z",
    fill: "#8A8A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5485 0.916504H91.4898V99.048H91.5485V0.916504Z",
    fill: "#8B8B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6071 0.916504H91.5485V99.048H91.6071V0.916504Z",
    fill: "#8C8C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6658 0.916504H91.6071V99.048H91.6658V0.916504Z",
    fill: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7245 0.916504H91.6658V99.048H91.7245V0.916504Z",
    fill: "#8E8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7831 0.916504H91.7244V99.048H91.7831V0.916504Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8417 0.916504H91.7831V99.048H91.8417V0.916504Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9004 0.916504H91.8417V99.048H91.9004V0.916504Z",
    fill: "#90908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.959 0.916504H91.9004V99.048H91.959V0.916504Z",
    fill: "#919190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0177 0.916504H91.959V99.048H92.0177V0.916504Z",
    fill: "#929291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0764 0.916504H92.0177V99.048H92.0764V0.916504Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.135 0.916504H92.0763V99.048H92.135V0.916504Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1937 0.916504H92.135V99.048H92.1937V0.916504Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2523 0.916504H92.1936V99.048H92.2523V0.916504Z",
    fill: "#959594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.311 0.916504H92.2523V99.048H92.311V0.916504Z",
    fill: "#969695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3696 0.916504H92.3109V99.048H92.3696V0.916504Z",
    fill: "#979796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4282 0.916504H92.3696V99.048H92.4282V0.916504Z",
    fill: "#989797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4869 0.916504H92.4283V99.048H92.4869V0.916504Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5456 0.916504H92.4869V99.048H92.5456V0.916504Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6042 0.916504H92.5455V99.048H92.6042V0.916504Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6629 0.916504H92.6042V99.048H92.6629V0.916504Z",
    fill: "#9B9B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7215 0.916504H92.6628V99.048H92.7215V0.916504Z",
    fill: "#9C9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7802 0.916504H92.7215V99.048H92.7802V0.916504Z",
    fill: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8388 0.916504H92.7802V99.048H92.8388V0.916504Z",
    fill: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8975 0.916504H92.8388V99.048H92.8975V0.916504Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9561 0.916504H92.8975V99.048H92.9561V0.916504Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0148 0.916504H92.9561V99.048H93.0148V0.916504Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0692 0.916504H93.0106V99.048H93.0692V0.916504Z",
    fill: "#A1A1A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1279 0.916504H93.0692V99.048H93.1279V0.916504Z",
    fill: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1865 0.916504H93.1279V99.048H93.1865V0.916504Z",
    fill: "#A3A3A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2452 0.916504H93.1865V99.048H93.2452V0.916504Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3038 0.916504H93.2452V99.048H93.3038V0.916504Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3625 0.916504H93.3038V99.048H93.3625V0.916504Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4211 0.916504H93.3625V99.048H93.4211V0.916504Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4798 0.916504H93.4211V99.048H93.4798V0.916504Z",
    fill: "#A7A7A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5384 0.916504H93.4798V99.048H93.5384V0.916504Z",
    fill: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5971 0.916504H93.5384V99.048H93.5971V0.916504Z",
    fill: "#A9A9A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6557 0.916504H93.5971V99.048H93.6557V0.916504Z",
    fill: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7144 0.916504H93.6557V99.048H93.7144V0.916504Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.773 0.916504H93.7144V99.048H93.773V0.916504Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8317 0.916504H93.773V99.048H93.8317V0.916504Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8903 0.916504H93.8317V99.048H93.8903V0.916504Z",
    fill: "#ADADAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.949 0.916504H93.8903V99.048H93.949V0.916504Z",
    fill: "#AEAEAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0076 0.916504H93.949V99.048H94.0076V0.916504Z",
    fill: "#AFAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0663 0.916504H94.0076V99.048H94.0663V0.916504Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1249 0.916504H94.0663V99.048H94.1249V0.916504Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1836 0.916504H94.1249V99.048H94.1836V0.916504Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2422 0.916504H94.1836V99.048H94.2422V0.916504Z",
    fill: "#B2B2B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3009 0.916504H94.2422V99.048H94.3009V0.916504Z",
    fill: "#B3B3B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3596 0.916504H94.3009V99.048H94.3596V0.916504Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4182 0.916504H94.3595V99.048H94.4182V0.916504Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4768 0.916504H94.4182V99.048H94.4768V0.916504Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5355 0.916504H94.4769V99.048H94.5355V0.916504Z",
    fill: "#B6B6B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5941 0.916504H94.5355V99.048H94.5941V0.916504Z",
    fill: "#B7B7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6528 0.916504H94.5941V99.048H94.6528V0.916504Z",
    fill: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7115 0.916504H94.6528V99.048H94.7115V0.916504Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7701 0.916504H94.7115V99.048H94.7701V0.916504Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8288 0.916504H94.7701V99.048H94.8288V0.916504Z",
    fill: "#BABAB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8874 0.916504H94.8288V99.048H94.8874V0.916504Z",
    fill: "#BBBBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9461 0.916504H94.8874V99.048H94.9461V0.916504Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0047 0.916504H94.9461V99.048H95.0047V0.916504Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0634 0.916504H95.0047V99.048H95.0634V0.916504Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.122 0.916504H95.0634V99.048H95.122V0.916504Z",
    fill: "#BEBEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1807 0.916504H95.122V99.048H95.1807V0.916504Z",
    fill: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2393 0.916504H95.1807V99.048H95.2393V0.916504Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.298 0.916504H95.2393V99.048H95.298V0.916504Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3566 0.916504H95.298V99.048H95.3566V0.916504Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4153 0.916504H95.3566V99.048H95.4153V0.916504Z",
    fill: "#C2C2C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4739 0.916504H95.4153V99.048H95.4739V0.916504Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5284 0.916504H95.4697V99.048H95.5284V0.916504Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.587 0.916504H95.5284V99.048H95.587V0.916504Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6457 0.916504H95.587V99.048H95.6457V0.916504Z",
    fill: "#C5C5C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7043 0.916504H95.6457V99.048H95.7043V0.916504Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.763 0.916504H95.7043V99.048H95.763V0.916504Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8216 0.916504H95.763V99.048H95.8216V0.916504Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8803 0.916504H95.8216V99.048H95.8803V0.916504Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9389 0.916504H95.8803V99.048H95.9389V0.916504Z",
    fill: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9976 0.916504H95.9389V99.048H95.9976V0.916504Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0562 0.916504H95.9976V99.048H96.0562V0.916504Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1149 0.916504H96.0562V99.048H96.1149V0.916504Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1735 0.916504H96.1149V99.048H96.1735V0.916504Z",
    fill: "#CCCCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2322 0.916504H96.1736V99.048H96.2322V0.916504Z",
    fill: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2908 0.916504H96.2322V99.048H96.2908V0.916504Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3495 0.916504H96.2908V99.048H96.3495V0.916504Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4081 0.916504H96.3495V99.048H96.4081V0.916504Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4668 0.916504H96.4081V99.048H96.4668V0.916504Z",
    fill: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5254 0.916504H96.4668V99.048H96.5254V0.916504Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5841 0.916504H96.5255V99.048H96.5841V0.916504Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6427 0.916504H96.5841V99.048H96.6427V0.916504Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7014 0.916504H96.6428V99.048H96.7014V0.916504Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.76 0.916504H96.7014V99.048H96.76V0.916504Z",
    fill: "#D4D4D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8187 0.916504H96.7601V99.048H96.8187V0.916504Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8773 0.916504H96.8187V99.048H96.8773V0.916504Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.936 0.916504H96.8773V99.048H96.936V0.916504Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9947 0.916504H96.936V99.048H96.9947V0.916504Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0533 0.916504H96.9947V99.048H97.0533V0.916504Z",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1119 0.916504H97.0533V99.048H97.1119V0.916504Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1706 0.916504H97.112V99.048H97.1706V0.916504Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2292 0.916504H97.1706V99.048H97.2292V0.916504Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2879 0.916504H97.2293V99.048H97.2879V0.916504Z",
    fill: "#DBDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3466 0.916504H97.2879V99.048H97.3466V0.916504Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4052 0.916504H97.3466V99.048H97.4052V0.916504Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4639 0.916504H97.4052V99.048H97.4639V0.916504Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5225 0.916504H97.4639V99.048H97.5225V0.916504Z",
    fill: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5812 0.916504H97.5225V99.048H97.5812V0.916504Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6398 0.916504H97.5812V99.048H97.6398V0.916504Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6985 0.916504H97.6398V99.048H97.6985V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7571 0.916504H97.6985V99.048H97.7571V0.916504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8158 0.916504H97.7571V99.048H97.8158V0.916504Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8744 0.916504H97.8158V99.048H97.8744V0.916504Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9289 0.916504H97.8702V99.048H97.9289V0.916504Z",
    fill: "#E3E3E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9875 0.916504H97.9289V99.048H97.9875V0.916504Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0462 0.916504H97.9875V99.048H98.0462V0.916504Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1048 0.916504H98.0462V99.048H98.1048V0.916504Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1635 0.916504H98.1048V99.048H98.1635V0.916504Z",
    fill: "#E6E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2221 0.916504H98.1635V99.048H98.2221V0.916504Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2808 0.916504H98.2221V99.048H98.2808V0.916504Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3394 0.916504H98.2808V99.048H98.3394V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3981 0.916504H98.3394V99.048H98.3981V0.916504Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4567 0.916504H98.3981V99.048H98.4567V0.916504Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5154 0.916504H98.4567V99.048H98.5154V0.916504Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.574 0.916504H98.5154V99.048H98.574V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6327 0.916504H98.574V99.048H98.6327V0.916504Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6913 0.916504H98.6327V99.048H98.6913V0.916504Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.75 0.916504H98.6913V99.048H98.75V0.916504Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8087 0.916504H98.75V99.048H98.8087V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8673 0.916504H98.8087V99.048H98.8673V0.916504Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9259 0.916504H98.8673V99.048H98.9259V0.916504Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9846 0.916504H98.9259V99.048H98.9846V0.916504Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0433 0.916504H98.9846V99.048H99.0433V0.916504Z",
    fill: "#F1F1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1019 0.916504H99.0432V99.048H99.1019V0.916504Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1605 0.916504H99.1019V99.048H99.1605V0.916504Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2192 0.916504H99.1605V99.048H99.2192V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2779 0.916504H99.2192V99.048H99.2779V0.916504Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3365 0.916504H99.2778V99.048H99.3365V0.916504Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3952 0.916504H99.3365V99.048H99.3952V0.916504Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4538 0.916504H99.3951V99.048H99.4538V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5125 0.916504H99.4538V99.048H99.5125V0.916504Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5711 0.916504H99.5125V99.048H99.5711V0.916504Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6298 0.916504H99.5711V99.048H99.6298V0.916504Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6884 0.916504H99.6298V99.048H99.6884V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7471 0.916504H99.6884V99.048H99.7471V0.916504Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8057 0.916504H99.7471V99.048H99.8057V0.916504Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8644 0.916504H99.8057V99.048H99.8644V0.916504Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.923 0.916504H99.8644V99.048H99.923V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9817 0.916504H99.923V99.048H99.9817V0.916504Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.04 0.916504H99.9817V99.048H100.04V0.916504Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.099 0.916504H100.04V99.048H100.099V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.158 0.916504H100.099V99.048H100.158V0.916504Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.216 0.916504H100.158V99.048H100.216V0.916504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.665 0.916504H100.216V99.048H100.665V0.916504Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_26_4148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 97,
    height: 92
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5363 50.1037C98.5363 55.0053 93.0315 58.981 91.5946 63.405C90.1074 67.9881 92.1727 74.4314 89.3952 78.2479C86.5883 82.1021 79.8057 82.1105 75.9515 84.9173C72.135 87.6949 70.0445 94.159 65.4613 95.6463C61.0374 97.0832 55.5661 93.1285 50.6645 93.1285C45.763 93.1285 40.2917 97.0832 35.8677 95.6463C31.2846 94.159 29.1941 87.6949 25.3776 84.9173C21.5233 82.1105 14.7408 82.1021 11.9339 78.2479C9.12704 74.3937 11.2259 67.9923 9.73449 63.405C8.29754 58.981 2.79272 55.0095 2.79272 50.1037C2.79272 45.198 8.29754 41.2265 9.73449 36.8025C11.2217 32.2194 9.15636 25.7761 11.9339 21.9596C14.7408 18.1054 21.5233 18.097 25.3776 15.2902C29.1941 12.5126 31.2846 6.04845 35.8677 4.56122C40.2917 3.12427 45.763 7.07903 50.6645 7.07903C55.5661 7.07903 61.0374 3.12427 65.4613 4.56122C70.0445 6.04845 72.135 12.5126 75.9515 15.2902C79.8057 18.097 86.5883 18.1054 89.3952 21.9596C92.1727 25.7761 90.1032 32.2152 91.5946 36.8025C93.0315 41.2265 98.5363 45.198 98.5363 50.1037Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_26_4148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89746 3.12427H2.78854V97.0832H2.89746V3.12427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00638 3.12427H2.89746V97.0832H3.00638V3.12427Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11531 3.12427H3.00639V97.0832H3.11531V3.12427Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22423 3.12427H3.1153V97.0832H3.22423V3.12427Z",
    fill: "#FDFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33315 3.12427H3.22423V97.0832H3.33315V3.12427Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44208 3.12427H3.33315V97.0832H3.44208V3.12427Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55519 3.12427H3.44627V97.0832H3.55519V3.12427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66411 3.12427H3.55519V97.0832H3.66411V3.12427Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77304 3.12427H3.66412V97.0832H3.77304V3.12427Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88196 3.12427H3.77303V97.0832H3.88196V3.12427Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99088 3.12427H3.88196V97.0832H3.99088V3.12427Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10399 3.12427H3.99507V97.0832H4.10399V3.12427Z",
    fill: "#F6F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21292 3.12427H4.104V97.0832H4.21292V3.12427Z",
    fill: "#F5F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32184 3.12427H4.21292V97.0832H4.32184V3.12427Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43076 3.12427H4.32184V97.0832H4.43076V3.12427Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53969 3.12427H4.43076V97.0832H4.53969V3.12427Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64861 3.12427H4.53969V97.0832H4.64861V3.12427Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76172 3.12427H4.6528V97.0832H4.76172V3.12427Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87065 3.12427H4.76173V97.0832H4.87065V3.12427Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97957 3.12427H4.87065V97.0832H4.97957V3.12427Z",
    fill: "#EFEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08849 3.12427H4.97957V97.0832H5.08849V3.12427Z",
    fill: "#EEEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19742 3.12427H5.08849V97.0832H5.19742V3.12427Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30634 3.12427H5.19742V97.0832H5.30634V3.12427Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41945 3.12427H5.31053V97.0832H5.41945V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57027 3.12427H5.41946V97.0832H5.57027V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71689 3.12427H5.56608V97.0832H5.71689V3.12427Z",
    fill: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86771 3.12427H5.7169V97.0832H5.86771V3.12427Z",
    fill: "#E8E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01853 3.12427H5.86771V97.0832H6.01853V3.12427Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16935 3.12427H6.01853V97.0832H6.16935V3.12427Z",
    fill: "#E5E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31598 3.12427H6.16516V97.0832H6.31598V3.12427Z",
    fill: "#E3E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4668 3.12427H6.31598V97.0832H6.4668V3.12427Z",
    fill: "#E2E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61761 3.12427H6.4668V97.0832H6.61761V3.12427Z",
    fill: "#E0DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76424 3.12427H6.61342V97.0832H6.76424V3.12427Z",
    fill: "#DFDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91505 3.12427H6.76424V97.0832H6.91505V3.12427Z",
    fill: "#DDDBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06587 3.12427H6.91505V97.0832H7.06587V3.12427Z",
    fill: "#DCDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2125 3.12427H7.06168V97.0832H7.2125V3.12427Z",
    fill: "#DAD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36332 3.12427H7.2125V97.0832H7.36332V3.12427Z",
    fill: "#D9D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51414 3.12427H7.36332V97.0832H7.51414V3.12427Z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66495 3.12427H7.51413V97.0832H7.66495V3.12427Z",
    fill: "#D6D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81158 3.12427H7.66076V97.0832H7.81158V3.12427Z",
    fill: "#D4D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96239 3.12427H7.81158V97.0832H7.96239V3.12427Z",
    fill: "#D3D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11321 3.12427H7.96239V97.0832H8.11321V3.12427Z",
    fill: "#D1CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25984 3.12427H8.10902V97.0832H8.25984V3.12427Z",
    fill: "#D0CDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41066 3.12427H8.25984V97.0832H8.41066V3.12427Z",
    fill: "#CFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56148 3.12427H8.41066V97.0832H8.56148V3.12427Z",
    fill: "#CDCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71229 3.12427H8.56147V97.0832H8.71229V3.12427Z",
    fill: "#CCC8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85892 3.12427H8.7081V97.0832H8.85892V3.12427Z",
    fill: "#CAC7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00973 3.12427H8.85892V97.0832H9.00973V3.12427Z",
    fill: "#C9C5C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16055 3.12427H9.00974V97.0832H9.16055V3.12427Z",
    fill: "#C8C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30718 3.12427H9.15636V97.0832H9.30718V3.12427Z",
    fill: "#C6C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45799 3.12427H9.30717V97.0832H9.45799V3.12427Z",
    fill: "#C5C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60881 3.12427H9.45799V97.0832H9.60881V3.12427Z",
    fill: "#C4C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75544 3.12427H9.60462V97.0832H9.75544V3.12427Z",
    fill: "#C2BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90626 3.12427H9.75544V97.0832H9.90626V3.12427Z",
    fill: "#C1BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0571 3.12427H9.90626V97.0832H10.0571V3.12427Z",
    fill: "#C0BBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2079 3.12427H10.0571V97.0832H10.2079V3.12427Z",
    fill: "#BFBABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3545 3.12427H10.2037V97.0832H10.3545V3.12427Z",
    fill: "#BDB8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5053 3.12427H10.3545V97.0832H10.5053V3.12427Z",
    fill: "#BCB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 3.12427H10.5053V97.0832H10.6562V3.12427Z",
    fill: "#BBB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8028 3.12427H10.652V97.0832H10.8028V3.12427Z",
    fill: "#B9B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9536 3.12427H10.8028V97.0832H10.9536V3.12427Z",
    fill: "#B8B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1044 3.12427H10.9536V97.0832H11.1044V3.12427Z",
    fill: "#B7B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.251 3.12427H11.1002V97.0832H11.251V3.12427Z",
    fill: "#B6B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4019 3.12427H11.251V97.0832H11.4019V3.12427Z",
    fill: "#B4AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5527 3.12427H11.4019V97.0832H11.5527V3.12427Z",
    fill: "#B3AEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7035 3.12427H11.5527V97.0832H11.7035V3.12427Z",
    fill: "#B2ACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8501 3.12427H11.6993V97.0832H11.8501V3.12427Z",
    fill: "#B1ABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 3.12427H11.8501V97.0832H12.0009V3.12427Z",
    fill: "#AFAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1517 3.12427H12.0009V97.0832H12.1517V3.12427Z",
    fill: "#AEA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2984 3.12427H12.1476V97.0832H12.2984V3.12427Z",
    fill: "#ADA7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4492 3.12427H12.2984V97.0832H12.4492V3.12427Z",
    fill: "#ACA6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 3.12427H12.4492V97.0832H12.6V3.12427Z",
    fill: "#ABA5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7466 3.12427H12.5958V97.0832H12.7466V3.12427Z",
    fill: "#A9A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8975 3.12427H12.7466V97.0832H12.8975V3.12427Z",
    fill: "#A8A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0483 3.12427H12.8975V97.0832H13.0483V3.12427Z",
    fill: "#A7A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1991 3.12427H13.0483V97.0832H13.1991V3.12427Z",
    fill: "#A6A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3457 3.12427H13.1949V97.0832H13.3457V3.12427Z",
    fill: "#A59E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4965 3.12427H13.3457V97.0832H13.4965V3.12427Z",
    fill: "#A49D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6474 3.12427H13.4965V97.0832H13.6474V3.12427Z",
    fill: "#A39C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.794 3.12427H13.6432V97.0832H13.794V3.12427Z",
    fill: "#A19B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9448 3.12427H13.794V97.0832H13.9448V3.12427Z",
    fill: "#A09A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0956 3.12427H13.9448V97.0832H14.0956V3.12427Z",
    fill: "#9F9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2464 3.12427H14.0956V97.0832H14.2464V3.12427Z",
    fill: "#9E9797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3931 3.12427H14.2422V97.0832H14.3931V3.12427Z",
    fill: "#9D9696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5439 3.12427H14.3931V97.0832H14.5439V3.12427Z",
    fill: "#9C9595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6947 3.12427H14.5439V97.0832H14.6947V3.12427Z",
    fill: "#9B9494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8413 3.12427H14.6905V97.0832H14.8413V3.12427Z",
    fill: "#9A9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9921 3.12427H14.8413V97.0832H14.9921V3.12427Z",
    fill: "#999292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.143 3.12427H14.9921V97.0832H15.143V3.12427Z",
    fill: "#989191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2896 3.12427H15.1388V97.0832H15.2896V3.12427Z",
    fill: "#979090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4404 3.12427H15.2896V97.0832H15.4404V3.12427Z",
    fill: "#968F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5912 3.12427H15.4404V97.0832H15.5912V3.12427Z",
    fill: "#958E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.742 3.12427H15.5912V97.0832H15.742V3.12427Z",
    fill: "#948D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8887 3.12427H15.7378V97.0832H15.8887V3.12427Z",
    fill: "#938C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0395 3.12427H15.8887V97.0832H16.0395V3.12427Z",
    fill: "#928B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1903 3.12427H16.0395V97.0832H16.1903V3.12427Z",
    fill: "#918A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3369 3.12427H16.1861V97.0832H16.3369V3.12427Z",
    fill: "#908989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4877 3.12427H16.3369V97.0832H16.4877V3.12427Z",
    fill: "#8F8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6385 3.12427H16.4877V97.0832H16.6385V3.12427Z",
    fill: "#8E8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7852 3.12427H16.6344V97.0832H16.7852V3.12427Z",
    fill: "#8D8686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.936 3.12427H16.7852V97.0832H16.936V3.12427Z",
    fill: "#8C8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0868 3.12427H16.936V97.0832H17.0868V3.12427Z",
    fill: "#8C8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2376 3.12427H17.0868V97.0832H17.2376V3.12427Z",
    fill: "#8B8383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3843 3.12427H17.2334V97.0832H17.3843V3.12427Z",
    fill: "#8A8282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5351 3.12427H17.3843V97.0832H17.5351V3.12427Z",
    fill: "#898181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6859 3.12427H17.5351V97.0832H17.6859V3.12427Z",
    fill: "#888081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8325 3.12427H17.6817V97.0832H17.8325V3.12427Z",
    fill: "#878080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9833 3.12427H17.8325V97.0832H17.9833V3.12427Z",
    fill: "#877F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1342 3.12427H17.9833V97.0832H18.1342V3.12427Z",
    fill: "#867E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.285 3.12427H18.1342V97.0832H18.285V3.12427Z",
    fill: "#857D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4316 3.12427H18.2808V97.0832H18.4316V3.12427Z",
    fill: "#847C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5824 3.12427H18.4316V97.0832H18.5824V3.12427Z",
    fill: "#847C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7332 3.12427H18.5824V97.0832H18.7332V3.12427Z",
    fill: "#837B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8799 3.12427H18.729V97.0832H18.8799V3.12427Z",
    fill: "#827A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0307 3.12427H18.8799V97.0832H19.0307V3.12427Z",
    fill: "#82797A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1815 3.12427H19.0307V97.0832H19.1815V3.12427Z",
    fill: "#817979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3281 3.12427H19.1773V97.0832H19.3281V3.12427Z",
    fill: "#807878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4789 3.12427H19.3281V97.0832H19.4789V3.12427Z",
    fill: "#807778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6298 3.12427H19.4789V97.0832H19.6298V3.12427Z",
    fill: "#7F7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7806 3.12427H19.6298V97.0832H19.7806V3.12427Z",
    fill: "#7F7677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9272 3.12427H19.7764V97.0832H19.9272V3.12427Z",
    fill: "#7E7676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.078 3.12427H19.9272V97.0832H20.078V3.12427Z",
    fill: "#7E7676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.254 3.12427H20.078V97.0832H20.254V3.12427Z",
    fill: "#7E7676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4257 3.12427H20.2498V97.0832H20.4257V3.12427Z",
    fill: "#7E7676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6017 3.12427H20.4257V97.0832H20.6017V3.12427Z",
    fill: "#7F7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7776 3.12427H20.6017V97.0832H20.7776V3.12427Z",
    fill: "#7F7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9536 3.12427H20.7776V97.0832H20.9536V3.12427Z",
    fill: "#807878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1254 3.12427H20.9494V97.0832H21.1254V3.12427Z",
    fill: "#817879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3013 3.12427H21.1254V97.0832H21.3013V3.12427Z",
    fill: "#817979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4773 3.12427H21.3013V97.0832H21.4773V3.12427Z",
    fill: "#827A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6532 3.12427H21.4773V97.0832H21.6532V3.12427Z",
    fill: "#837B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.825 3.12427H21.649V97.0832H21.825V3.12427Z",
    fill: "#837B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0009 3.12427H21.825V97.0832H22.0009V3.12427Z",
    fill: "#847C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1769 3.12427H22.0009V97.0832H22.1769V3.12427Z",
    fill: "#857D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3528 3.12427H22.1769V97.0832H22.3528V3.12427Z",
    fill: "#867E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5246 3.12427H22.3487V97.0832H22.5246V3.12427Z",
    fill: "#877F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7006 3.12427H22.5246V97.0832H22.7006V3.12427Z",
    fill: "#878080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8765 3.12427H22.7006V97.0832H22.8765V3.12427Z",
    fill: "#888181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0525 3.12427H22.8765V97.0832H23.0525V3.12427Z",
    fill: "#898182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2242 3.12427H23.0483V97.0832H23.2242V3.12427Z",
    fill: "#8A8282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4002 3.12427H23.2242V97.0832H23.4002V3.12427Z",
    fill: "#8B8383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5761 3.12427H23.4002V97.0832H23.5761V3.12427Z",
    fill: "#8C8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7521 3.12427H23.5761V97.0832H23.7521V3.12427Z",
    fill: "#8D8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9238 3.12427H23.7479V97.0832H23.9238V3.12427Z",
    fill: "#8D8686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0998 3.12427H23.9239V97.0832H24.0998V3.12427Z",
    fill: "#8E8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2758 3.12427H24.0998V97.0832H24.2758V3.12427Z",
    fill: "#8F8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4517 3.12427H24.2758V97.0832H24.4517V3.12427Z",
    fill: "#908989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6235 3.12427H24.4475V97.0832H24.6235V3.12427Z",
    fill: "#918A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7994 3.12427H24.6235V97.0832H24.7994V3.12427Z",
    fill: "#928B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9754 3.12427H24.7994V97.0832H24.9754V3.12427Z",
    fill: "#938C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1513 3.12427H24.9754V97.0832H25.1513V3.12427Z",
    fill: "#948D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3231 3.12427H25.1472V97.0832H25.3231V3.12427Z",
    fill: "#958E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4991 3.12427H25.3231V97.0832H25.4991V3.12427Z",
    fill: "#968F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.675 3.12427H25.4991V97.0832H25.675V3.12427Z",
    fill: "#979090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.851 3.12427H25.675V97.0832H25.851V3.12427Z",
    fill: "#989191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0227 3.12427H25.8468V97.0832H26.0227V3.12427Z",
    fill: "#999292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1987 3.12427H26.0227V97.0832H26.1987V3.12427Z",
    fill: "#9A9393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3746 3.12427H26.1987V97.0832H26.3746V3.12427Z",
    fill: "#9B9494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5506 3.12427H26.3746V97.0832H26.5506V3.12427Z",
    fill: "#9C9596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7223 3.12427H26.5464V97.0832H26.7223V3.12427Z",
    fill: "#9D9797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8983 3.12427H26.7224V97.0832H26.8983V3.12427Z",
    fill: "#9E9898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0743 3.12427H26.8983V97.0832H27.0743V3.12427Z",
    fill: "#A09999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2502 3.12427H27.0742V97.0832H27.2502V3.12427Z",
    fill: "#A19A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.422 3.12427H27.246V97.0832H27.422V3.12427Z",
    fill: "#A29B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5979 3.12427H27.422V97.0832H27.5979V3.12427Z",
    fill: "#A39C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7739 3.12427H27.5979V97.0832H27.7739V3.12427Z",
    fill: "#A49E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9498 3.12427H27.7739V97.0832H27.9498V3.12427Z",
    fill: "#A59F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1216 3.12427H27.9456V97.0832H28.1216V3.12427Z",
    fill: "#A6A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2975 3.12427H28.1216V97.0832H28.2975V3.12427Z",
    fill: "#A7A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4735 3.12427H28.2975V97.0832H28.4735V3.12427Z",
    fill: "#A9A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6494 3.12427H28.4735V97.0832H28.6494V3.12427Z",
    fill: "#AAA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8212 3.12427H28.6453V97.0832H28.8212V3.12427Z",
    fill: "#ABA5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9972 3.12427H28.8212V97.0832H28.9972V3.12427Z",
    fill: "#ACA6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1731 3.12427H28.9972V97.0832H29.1731V3.12427Z",
    fill: "#ADA7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3491 3.12427H29.1731V97.0832H29.3491V3.12427Z",
    fill: "#AEA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5208 3.12427H29.3449V97.0832H29.5208V3.12427Z",
    fill: "#B0AAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6968 3.12427H29.5208V97.0832H29.6968V3.12427Z",
    fill: "#B1ABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8727 3.12427H29.6968V97.0832H29.8727V3.12427Z",
    fill: "#B2ACAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0487 3.12427H29.8727V97.0832H30.0487V3.12427Z",
    fill: "#B3AEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2205 3.12427H30.0445V97.0832H30.2205V3.12427Z",
    fill: "#B4AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3964 3.12427H30.2205V97.0832H30.3964V3.12427Z",
    fill: "#B6B0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5724 3.12427H30.3964V97.0832H30.5724V3.12427Z",
    fill: "#B7B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7483 3.12427H30.5724V97.0832H30.7483V3.12427Z",
    fill: "#B8B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9201 3.12427H30.7441V97.0832H30.9201V3.12427Z",
    fill: "#B9B4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.096 3.12427H30.9201V97.0832H31.096V3.12427Z",
    fill: "#BBB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.272 3.12427H31.096V97.0832H31.272V3.12427Z",
    fill: "#BCB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4479 3.12427H31.272V97.0832H31.4479V3.12427Z",
    fill: "#BDB8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6197 3.12427H31.4438V97.0832H31.6197V3.12427Z",
    fill: "#BEBABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7957 3.12427H31.6197V97.0832H31.7957V3.12427Z",
    fill: "#C0BBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9716 3.12427H31.7957V97.0832H31.9716V3.12427Z",
    fill: "#C1BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1476 3.12427H31.9716V97.0832H32.1476V3.12427Z",
    fill: "#C2BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3193 3.12427H32.1434V97.0832H32.3193V3.12427Z",
    fill: "#C3BFC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4953 3.12427H32.3193V97.0832H32.4953V3.12427Z",
    fill: "#C5C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6712 3.12427H32.4953V97.0832H32.6712V3.12427Z",
    fill: "#C6C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8472 3.12427H32.6712V97.0832H32.8472V3.12427Z",
    fill: "#C7C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.019 3.12427H32.843V97.0832H33.019V3.12427Z",
    fill: "#C9C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1949 3.12427H33.019V97.0832H33.1949V3.12427Z",
    fill: "#CAC7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3709 3.12427H33.1949V97.0832H33.3709V3.12427Z",
    fill: "#CBC8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5468 3.12427H33.3708V97.0832H33.5468V3.12427Z",
    fill: "#CDC9CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7186 3.12427H33.5426V97.0832H33.7186V3.12427Z",
    fill: "#CECBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8945 3.12427H33.7186V97.0832H33.8945V3.12427Z",
    fill: "#CFCCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0705 3.12427H33.8945V97.0832H34.0705V3.12427Z",
    fill: "#D1CECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2464 3.12427H34.0705V97.0832H34.2464V3.12427Z",
    fill: "#D2D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4182 3.12427H34.2422V97.0832H34.4182V3.12427Z",
    fill: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5941 3.12427H34.4182V97.0832H34.5941V3.12427Z",
    fill: "#D5D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7701 3.12427H34.5941V97.0832H34.7701V3.12427Z",
    fill: "#D6D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9461 3.12427H34.7701V97.0832H34.9461V3.12427Z",
    fill: "#D8D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1178 3.12427H34.9419V97.0832H35.1178V3.12427Z",
    fill: "#D9D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2938 3.12427H35.1178V97.0832H35.2938V3.12427Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4697 3.12427H35.2938V97.0832H35.4697V3.12427Z",
    fill: "#DCDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6457 3.12427H35.4697V97.0832H35.6457V3.12427Z",
    fill: "#DEDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8174 3.12427H35.6415V97.0832H35.8174V3.12427Z",
    fill: "#DFDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9934 3.12427H35.8174V97.0832H35.9934V3.12427Z",
    fill: "#E1DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1693 3.12427H35.9934V97.0832H36.1693V3.12427Z",
    fill: "#E2E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3453 3.12427H36.1693V97.0832H36.3453V3.12427Z",
    fill: "#E4E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5171 3.12427H36.3411V97.0832H36.5171V3.12427Z",
    fill: "#E5E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.693 3.12427H36.5171V97.0832H36.693V3.12427Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.869 3.12427H36.693V97.0832H36.869V3.12427Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0407 3.12427H36.8648V97.0832H37.0407V3.12427Z",
    fill: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2167 3.12427H37.0407V97.0832H37.2167V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5141 3.12427H37.2167V97.0832H37.5141V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8116 3.12427H37.5141V97.0832H37.8116V3.12427Z",
    fill: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1132 3.12427H37.8158V97.0832H38.1132V3.12427Z",
    fill: "#E8E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4107 3.12427H38.1132V97.0832H38.4107V3.12427Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7081 3.12427H38.4107V97.0832H38.7081V3.12427Z",
    fill: "#E5E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0097 3.12427H38.7123V97.0832H39.0097V3.12427Z",
    fill: "#E3E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3072 3.12427H39.0097V97.0832H39.3072V3.12427Z",
    fill: "#E2E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6046 3.12427H39.3072V97.0832H39.6046V3.12427Z",
    fill: "#E0DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9063 3.12427H39.6088V97.0832H39.9063V3.12427Z",
    fill: "#DFDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2037 3.12427H39.9062V97.0832H40.2037V3.12427Z",
    fill: "#DEDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5011 3.12427H40.2037V97.0832H40.5011V3.12427Z",
    fill: "#DCDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8028 3.12427H40.5053V97.0832H40.8028V3.12427Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1002 3.12427H40.8028V97.0832H41.1002V3.12427Z",
    fill: "#D9D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3977 3.12427H41.1002V97.0832H41.3977V3.12427Z",
    fill: "#D8D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6993 3.12427H41.4019V97.0832H41.6993V3.12427Z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9968 3.12427H41.6993V97.0832H41.9968V3.12427Z",
    fill: "#D6D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2942 3.12427H41.9967V97.0832H42.2942V3.12427Z",
    fill: "#D5D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5958 3.12427H42.2984V97.0832H42.5958V3.12427Z",
    fill: "#D4D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8933 3.12427H42.5958V97.0832H42.8933V3.12427Z",
    fill: "#D3D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1907 3.12427H42.8933V97.0832H43.1907V3.12427Z",
    fill: "#D2CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4923 3.12427H43.1949V97.0832H43.4923V3.12427Z",
    fill: "#D1CECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9364 3.12427H43.4923V97.0832H43.9364V3.12427Z",
    fill: "#D1CECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3847 3.12427H43.9406V97.0832H44.3847V3.12427Z",
    fill: "#D2CFD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8287 3.12427H44.3847V97.0832H44.8287V3.12427Z",
    fill: "#D3D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2728 3.12427H44.8288V97.0832H45.2728V3.12427Z",
    fill: "#D5D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7211 3.12427H45.277V97.0832H45.7211V3.12427Z",
    fill: "#D6D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1652 3.12427H45.7211V97.0832H46.1652V3.12427Z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6092 3.12427H46.1652V97.0832H46.6092V3.12427Z",
    fill: "#D8D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0575 3.12427H46.6134V97.0832H47.0575V3.12427Z",
    fill: "#D9D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5016 3.12427H47.0575V97.0832H47.5016V3.12427Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9498 3.12427H47.5058V97.0832H47.9498V3.12427Z",
    fill: "#DCDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3939 3.12427H47.9498V97.0832H48.3939V3.12427Z",
    fill: "#DDDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.838 3.12427H48.3939V97.0832H48.838V3.12427Z",
    fill: "#DFDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2862 3.12427H48.8422V97.0832H49.2862V3.12427Z",
    fill: "#E0DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7303 3.12427H49.2862V97.0832H49.7303V3.12427Z",
    fill: "#E1E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1786 3.12427H49.7345V97.0832H50.1786V3.12427Z",
    fill: "#E3E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6226 3.12427H50.1786V97.0832H50.6226V3.12427Z",
    fill: "#E4E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0667 3.12427H50.6226V97.0832H51.0667V3.12427Z",
    fill: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.515 3.12427H51.0709V97.0832H51.515V3.12427Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.959 3.12427H51.515V97.0832H51.959V3.12427Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4073 3.12427H51.9632V97.0832H52.4073V3.12427Z",
    fill: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8514 3.12427H52.4073V97.0832H52.8514V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1991 3.12427H52.8514V97.0832H53.1991V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5468 3.12427H53.1991V97.0832H53.5468V3.12427Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8987 3.12427H53.551V97.0832H53.8987V3.12427Z",
    fill: "#EEEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2464 3.12427H53.8987V97.0832H54.2464V3.12427Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5941 3.12427H54.2464V97.0832H54.5941V3.12427Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9419 3.12427H54.5941V97.0832H54.9419V3.12427Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2896 3.12427H54.9419V97.0832H55.2896V3.12427Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6415 3.12427H55.2938V97.0832H55.6415V3.12427Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9892 3.12427H55.6415V97.0832H55.9892V3.12427Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3369 3.12427H55.9892V97.0832H56.3369V3.12427Z",
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6846 3.12427H56.3369V97.0832H56.6846V3.12427Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0323 3.12427H56.6846V97.0832H57.0323V3.12427Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3843 3.12427H57.0366V97.0832H57.3843V3.12427Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.732 3.12427H57.3843V97.0832H57.732V3.12427Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0797 3.12427H57.732V97.0832H58.0797V3.12427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4274 3.12427H58.0797V97.0832H58.4274V3.12427Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7751 3.12427H58.4274V97.0832H58.7751V3.12427Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1228 3.12427H58.7751V97.0832H59.1228V3.12427Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4748 3.12427H59.127V97.0832H59.4748V3.12427Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8225 3.12427H59.4748V97.0832H59.8225V3.12427Z",
    fill: "#FEFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1702 3.12427H59.8225V97.0832H60.1702V3.12427Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5179 3.12427H60.1702V97.0832H60.5179V3.12427Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8656 3.12427H60.5179V97.0832H60.8656V3.12427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2175 3.12427H60.8698V97.0832H61.2175V3.12427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5024 3.12427H61.2175V97.0832H61.5024V3.12427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7873 3.12427H61.5024V97.0832H61.7873V3.12427Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0722 3.12427H61.7873V97.0832H62.0722V3.12427Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.357 3.12427H62.0722V97.0832H62.357V3.12427Z",
    fill: "#FDFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6419 3.12427H62.357V97.0832H62.6419V3.12427Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9268 3.12427H62.6419V97.0832H62.9268V3.12427Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2158 3.12427H62.931V97.0832H63.2158V3.12427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5007 3.12427H63.2159V97.0832H63.5007V3.12427Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7856 3.12427H63.5007V97.0832H63.7856V3.12427Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0705 3.12427H63.7856V97.0832H64.0705V3.12427Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3554 3.12427H64.0705V97.0832H64.3554V3.12427Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6402 3.12427H64.3553V97.0832H64.6402V3.12427Z",
    fill: "#F6F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9251 3.12427H64.6402V97.0832H64.9251V3.12427Z",
    fill: "#F5F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21 3.12427H64.9251V97.0832H65.21V3.12427Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4991 3.12427H65.2142V97.0832H65.4991V3.12427Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7839 3.12427H65.4991V97.0832H65.7839V3.12427Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0688 3.12427H65.7839V97.0832H66.0688V3.12427Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3537 3.12427H66.0688V97.0832H66.3537V3.12427Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6386 3.12427H66.3537V97.0832H66.6386V3.12427Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9234 3.12427H66.6385V97.0832H66.9234V3.12427Z",
    fill: "#EFEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2083 3.12427H66.9234V97.0832H67.2083V3.12427Z",
    fill: "#EEEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4932 3.12427H67.2083V97.0832H67.4932V3.12427Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7823 3.12427H67.4974V97.0832H67.7823V3.12427Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0671 3.12427H67.7823V97.0832H68.0671V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1258 3.12427H68.0671V97.0832H68.1258V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1844 3.12427H68.1258V97.0832H68.1844V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2431 3.12427H68.1844V97.0832H68.2431V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3059 3.12427H68.2473V97.0832H68.3059V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3646 3.12427H68.3059V97.0832H68.3646V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4232 3.12427H68.3646V97.0832H68.4232V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4861 3.12427H68.4274V97.0832H68.4861V3.12427Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5447 3.12427H68.4861V97.0832H68.5447V3.12427Z",
    fill: "#EBEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6034 3.12427H68.5447V97.0832H68.6034V3.12427Z",
    fill: "#EBEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6662 3.12427H68.6076V97.0832H68.6662V3.12427Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7248 3.12427H68.6662V97.0832H68.7248V3.12427Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7835 3.12427H68.7249V97.0832H68.7835V3.12427Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8422 3.12427H68.7835V97.0832H68.8422V3.12427Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.905 3.12427H68.8463V97.0832H68.905V3.12427Z",
    fill: "#EAE9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9636 3.12427H68.905V97.0832H68.9636V3.12427Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0223 3.12427H68.9637V97.0832H69.0223V3.12427Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0851 3.12427H69.0265V97.0832H69.0851V3.12427Z",
    fill: "#E9E8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1438 3.12427H69.0851V97.0832H69.1438V3.12427Z",
    fill: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2024 3.12427H69.1438V97.0832H69.2024V3.12427Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2653 3.12427H69.2066V97.0832H69.2653V3.12427Z",
    fill: "#E8E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3239 3.12427H69.2653V97.0832H69.3239V3.12427Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3826 3.12427H69.3239V97.0832H69.3826V3.12427Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4412 3.12427H69.3826V97.0832H69.4412V3.12427Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5041 3.12427H69.4454V97.0832H69.5041V3.12427Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5627 3.12427H69.5041V97.0832H69.5627V3.12427Z",
    fill: "#E6E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6214 3.12427H69.5627V97.0832H69.6214V3.12427Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6842 3.12427H69.6256V97.0832H69.6842V3.12427Z",
    fill: "#E5E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7429 3.12427H69.6842V97.0832H69.7429V3.12427Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8015 3.12427H69.7429V97.0832H69.8015V3.12427Z",
    fill: "#E4E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8644 3.12427H69.8057V97.0832H69.8644V3.12427Z",
    fill: "#E3E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.923 3.12427H69.8644V97.0832H69.923V3.12427Z",
    fill: "#E3E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9817 3.12427H69.923V97.0832H69.9817V3.12427Z",
    fill: "#E2E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0403 3.12427H69.9817V97.0832H70.0403V3.12427Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1031 3.12427H70.0445V97.0832H70.1031V3.12427Z",
    fill: "#E1E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1618 3.12427H70.1031V97.0832H70.1618V3.12427Z",
    fill: "#E0DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2205 3.12427H70.1618V97.0832H70.2205V3.12427Z",
    fill: "#DFDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2833 3.12427H70.2247V97.0832H70.2833V3.12427Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3419 3.12427H70.2833V97.0832H70.3419V3.12427Z",
    fill: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4006 3.12427H70.3419V97.0832H70.4006V3.12427Z",
    fill: "#DDDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4634 3.12427H70.4048V97.0832H70.4634V3.12427Z",
    fill: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5221 3.12427H70.4634V97.0832H70.5221V3.12427Z",
    fill: "#DBDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5807 3.12427H70.5221V97.0832H70.5807V3.12427Z",
    fill: "#DAD9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6394 3.12427H70.5807V97.0832H70.6394V3.12427Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7022 3.12427H70.6436V97.0832H70.7022V3.12427Z",
    fill: "#D9D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7609 3.12427H70.7022V97.0832H70.7609V3.12427Z",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8195 3.12427H70.7609V97.0832H70.8195V3.12427Z",
    fill: "#D7D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8824 3.12427H70.8237V97.0832H70.8824V3.12427Z",
    fill: "#D6D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.941 3.12427H70.8824V97.0832H70.941V3.12427Z",
    fill: "#D5D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9997 3.12427H70.941V97.0832H70.9997V3.12427Z",
    fill: "#D4D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0625 3.12427H71.0039V97.0832H71.0625V3.12427Z",
    fill: "#D3D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1212 3.12427H71.0625V97.0832H71.1212V3.12427Z",
    fill: "#D2D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1798 3.12427H71.1212V97.0832H71.1798V3.12427Z",
    fill: "#D1CFD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2385 3.12427H71.1798V97.0832H71.2385V3.12427Z",
    fill: "#CFCECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3013 3.12427H71.2427V97.0832H71.3013V3.12427Z",
    fill: "#CECDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.36 3.12427H71.3013V97.0832H71.36V3.12427Z",
    fill: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4186 3.12427H71.36V97.0832H71.4186V3.12427Z",
    fill: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4815 3.12427H71.4228V97.0832H71.4815V3.12427Z",
    fill: "#CBCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5401 3.12427H71.4815V97.0832H71.5401V3.12427Z",
    fill: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5988 3.12427H71.5401V97.0832H71.5988V3.12427Z",
    fill: "#C9C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6574 3.12427H71.5988V97.0832H71.6574V3.12427Z",
    fill: "#C7C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7202 3.12427H71.6616V97.0832H71.7202V3.12427Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7789 3.12427H71.7202V97.0832H71.7789V3.12427Z",
    fill: "#C5C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8376 3.12427H71.7789V97.0832H71.8376V3.12427Z",
    fill: "#C4C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9004 3.12427H71.8417V97.0832H71.9004V3.12427Z",
    fill: "#C2C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.959 3.12427H71.9004V97.0832H71.959V3.12427Z",
    fill: "#C1C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0177 3.12427H71.959V97.0832H72.0177V3.12427Z",
    fill: "#C0BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0805 3.12427H72.0219V97.0832H72.0805V3.12427Z",
    fill: "#BEBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1392 3.12427H72.0805V97.0832H72.1392V3.12427Z",
    fill: "#BDBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1978 3.12427H72.1392V97.0832H72.1978V3.12427Z",
    fill: "#BCBABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2565 3.12427H72.1978V97.0832H72.2565V3.12427Z",
    fill: "#BAB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3193 3.12427H72.2607V97.0832H72.3193V3.12427Z",
    fill: "#B9B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.378 3.12427H72.3193V97.0832H72.378V3.12427Z",
    fill: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4366 3.12427H72.378V97.0832H72.4366V3.12427Z",
    fill: "#B6B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4995 3.12427H72.4408V97.0832H72.4995V3.12427Z",
    fill: "#B4B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5581 3.12427H72.4995V97.0832H72.5581V3.12427Z",
    fill: "#B3B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6168 3.12427H72.5581V97.0832H72.6168V3.12427Z",
    fill: "#B1B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6796 3.12427H72.621V97.0832H72.6796V3.12427Z",
    fill: "#B0AEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7383 3.12427H72.6796V97.0832H72.7383V3.12427Z",
    fill: "#AEACAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7969 3.12427H72.7383V97.0832H72.7969V3.12427Z",
    fill: "#ACABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8556 3.12427H72.7969V97.0832H72.8556V3.12427Z",
    fill: "#ABA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9184 3.12427H72.8597V97.0832H72.9184V3.12427Z",
    fill: "#A9A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.977 3.12427H72.9184V97.0832H72.977V3.12427Z",
    fill: "#A7A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0357 3.12427H72.9771V97.0832H73.0357V3.12427Z",
    fill: "#A6A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0986 3.12427H73.0399V97.0832H73.0986V3.12427Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1572 3.12427H73.0985V97.0832H73.1572V3.12427Z",
    fill: "#A2A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2158 3.12427H73.1572V97.0832H73.2158V3.12427Z",
    fill: "#A09F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2787 3.12427H73.22V97.0832H73.2787V3.12427Z",
    fill: "#9F9D9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3373 3.12427H73.2787V97.0832H73.3373V3.12427Z",
    fill: "#9D9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.396 3.12427H73.3373V97.0832H73.396V3.12427Z",
    fill: "#9B9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4546 3.12427H73.396V97.0832H73.4546V3.12427Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5175 3.12427H73.4588V97.0832H73.5175V3.12427Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5761 3.12427H73.5175V97.0832H73.5761V3.12427Z",
    fill: "#969595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6348 3.12427H73.5761V97.0832H73.6348V3.12427Z",
    fill: "#949393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6976 3.12427H73.639V97.0832H73.6976V3.12427Z",
    fill: "#929191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7563 3.12427H73.6976V97.0832H73.7563V3.12427Z",
    fill: "#908F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8149 3.12427H73.7563V97.0832H73.8149V3.12427Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8778 3.12427H73.8191V97.0832H73.8778V3.12427Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9364 3.12427H73.8778V97.0832H73.9364V3.12427Z",
    fill: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9951 3.12427H73.9364V97.0832H73.9951V3.12427Z",
    fill: "#898888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0537 3.12427H73.9951V97.0832H74.0537V3.12427Z",
    fill: "#878686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1166 3.12427H74.0579V97.0832H74.1166V3.12427Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1752 3.12427H74.1166V97.0832H74.1752V3.12427Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2339 3.12427H74.1752V97.0832H74.2339V3.12427Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2967 3.12427H74.2381V97.0832H74.2967V3.12427Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3554 3.12427H74.2967V97.0832H74.3554V3.12427Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.414 3.12427H74.3554V97.0832H74.414V3.12427Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4768 3.12427H74.4182V97.0832H74.4768V3.12427Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5355 3.12427H74.4768V97.0832H74.5355V3.12427Z",
    fill: "#777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7114 3.12427H74.5355V97.0832H74.7114V3.12427Z",
    fill: "#777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8874 3.12427H74.7115V97.0832H74.8874V3.12427Z",
    fill: "#797879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0634 3.12427H74.8874V97.0832H75.0634V3.12427Z",
    fill: "#7A797A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2435 3.12427H75.0675V97.0832H75.2435V3.12427Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4195 3.12427H75.2435V97.0832H75.4195V3.12427Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5954 3.12427H75.4194V97.0832H75.5954V3.12427Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7714 3.12427H75.5954V97.0832H75.7714V3.12427Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9473 3.12427H75.7714V97.0832H75.9473V3.12427Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1275 3.12427H75.9515V97.0832H76.1275V3.12427Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3034 3.12427H76.1275V97.0832H76.3034V3.12427Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4794 3.12427H76.3034V97.0832H76.4794V3.12427Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6553 3.12427H76.4794V97.0832H76.6553V3.12427Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8313 3.12427H76.6553V97.0832H76.8313V3.12427Z",
    fill: "#858484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0072 3.12427H76.8313V97.0832H77.0072V3.12427Z",
    fill: "#868585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1874 3.12427H77.0114V97.0832H77.1874V3.12427Z",
    fill: "#878686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3633 3.12427H77.1874V97.0832H77.3633V3.12427Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5393 3.12427H77.3633V97.0832H77.5393V3.12427Z",
    fill: "#898888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7152 3.12427H77.5393V97.0832H77.7152V3.12427Z",
    fill: "#8A898A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8912 3.12427H77.7152V97.0832H77.8912V3.12427Z",
    fill: "#8B8A8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0671 3.12427H77.8912V97.0832H78.0671V3.12427Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2473 3.12427H78.0713V97.0832H78.2473V3.12427Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4232 3.12427H78.2473V97.0832H78.4232V3.12427Z",
    fill: "#8F8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5992 3.12427H78.4232V97.0832H78.5992V3.12427Z",
    fill: "#908F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7751 3.12427H78.5992V97.0832H78.7751V3.12427Z",
    fill: "#919090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9511 3.12427H78.7751V97.0832H78.9511V3.12427Z",
    fill: "#929191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.127 3.12427H78.9511V97.0832H79.127V3.12427Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3072 3.12427H79.1312V97.0832H79.3072V3.12427Z",
    fill: "#949393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4831 3.12427H79.3072V97.0832H79.4831V3.12427Z",
    fill: "#959494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6591 3.12427H79.4831V97.0832H79.6591V3.12427Z",
    fill: "#969596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.835 3.12427H79.6591V97.0832H79.835V3.12427Z",
    fill: "#989697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.011 3.12427H79.835V97.0832H80.011V3.12427Z",
    fill: "#999798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1869 3.12427H80.011V97.0832H80.1869V3.12427Z",
    fill: "#9A9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3671 3.12427H80.1911V97.0832H80.3671V3.12427Z",
    fill: "#9B9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.543 3.12427H80.3671V97.0832H80.543V3.12427Z",
    fill: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.719 3.12427H80.543V97.0832H80.719V3.12427Z",
    fill: "#9D9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8949 3.12427H80.719V97.0832H80.8949V3.12427Z",
    fill: "#9F9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0709 3.12427H80.895V97.0832H81.0709V3.12427Z",
    fill: "#A09E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2469 3.12427H81.0709V97.0832H81.2469V3.12427Z",
    fill: "#A19FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.427 3.12427H81.251V97.0832H81.427V3.12427Z",
    fill: "#A2A0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6029 3.12427H81.427V97.0832H81.6029V3.12427Z",
    fill: "#A3A1A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7789 3.12427H81.603V97.0832H81.7789V3.12427Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9549 3.12427H81.7789V97.0832H81.9549V3.12427Z",
    fill: "#A5A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1308 3.12427H81.9549V97.0832H82.1308V3.12427Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3068 3.12427H82.1308V97.0832H82.3068V3.12427Z",
    fill: "#A8A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4869 3.12427H82.3109V97.0832H82.4869V3.12427Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6629 3.12427H82.4869V97.0832H82.6629V3.12427Z",
    fill: "#AAA8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8388 3.12427H82.6629V97.0832H82.8388V3.12427Z",
    fill: "#ABA9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0148 3.12427H82.8388V97.0832H83.0148V3.12427Z",
    fill: "#ACAAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1907 3.12427H83.0148V97.0832H83.1907V3.12427Z",
    fill: "#AEACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3667 3.12427H83.1907V97.0832H83.3667V3.12427Z",
    fill: "#AFADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5468 3.12427H83.3708V97.0832H83.5468V3.12427Z",
    fill: "#B0AEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7228 3.12427H83.5468V97.0832H83.7228V3.12427Z",
    fill: "#B1AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8987 3.12427H83.7228V97.0832H83.8987V3.12427Z",
    fill: "#B2B0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0747 3.12427H83.8987V97.0832H84.0747V3.12427Z",
    fill: "#B3B1B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2506 3.12427H84.0747V97.0832H84.2506V3.12427Z",
    fill: "#B4B2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4266 3.12427H84.2506V97.0832H84.4266V3.12427Z",
    fill: "#B6B3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6067 3.12427H84.4308V97.0832H84.6067V3.12427Z",
    fill: "#B7B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7827 3.12427H84.6067V97.0832H84.7827V3.12427Z",
    fill: "#B8B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9586 3.12427H84.7827V97.0832H84.9586V3.12427Z",
    fill: "#B9B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1346 3.12427H84.9586V97.0832H85.1346V3.12427Z",
    fill: "#BAB8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3105 3.12427H85.1346V97.0832H85.3105V3.12427Z",
    fill: "#BBB9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4865 3.12427H85.3105V97.0832H85.4865V3.12427Z",
    fill: "#BCBABB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6666 3.12427H85.4907V97.0832H85.6666V3.12427Z",
    fill: "#BDBBBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8426 3.12427H85.6666V97.0832H85.8426V3.12427Z",
    fill: "#BEBCBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0185 3.12427H85.8426V97.0832H86.0185V3.12427Z",
    fill: "#BFBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1945 3.12427H86.0185V97.0832H86.1945V3.12427Z",
    fill: "#C1BFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3704 3.12427H86.1945V97.0832H86.3704V3.12427Z",
    fill: "#C2C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5464 3.12427H86.3705V97.0832H86.5464V3.12427Z",
    fill: "#C3C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7265 3.12427H86.5506V97.0832H86.7265V3.12427Z",
    fill: "#C4C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9025 3.12427H86.7265V97.0832H86.9025V3.12427Z",
    fill: "#C5C3C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0784 3.12427H86.9025V97.0832H87.0784V3.12427Z",
    fill: "#C6C4C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2544 3.12427H87.0784V97.0832H87.2544V3.12427Z",
    fill: "#C7C5C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4303 3.12427H87.2544V97.0832H87.4303V3.12427Z",
    fill: "#C8C6C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6063 3.12427H87.4304V97.0832H87.6063V3.12427Z",
    fill: "#C9C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7865 3.12427H87.6105V97.0832H87.7865V3.12427Z",
    fill: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9624 3.12427H87.7864V97.0832H87.9624V3.12427Z",
    fill: "#CBCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1384 3.12427H87.9624V97.0832H88.1384V3.12427Z",
    fill: "#CDCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3143 3.12427H88.1383V97.0832H88.3143V3.12427Z",
    fill: "#CECCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4903 3.12427H88.3143V97.0832H88.4903V3.12427Z",
    fill: "#CFCDCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6704 3.12427H88.4944V97.0832H88.6704V3.12427Z",
    fill: "#D0CECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8464 3.12427H88.6704V97.0832H88.8464V3.12427Z",
    fill: "#D1CFD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0223 3.12427H88.8463V97.0832H89.0223V3.12427Z",
    fill: "#D2D0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1983 3.12427H89.0223V97.0832H89.1983V3.12427Z",
    fill: "#D3D1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3742 3.12427H89.1983V97.0832H89.3742V3.12427Z",
    fill: "#D4D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5502 3.12427H89.3742V97.0832H89.5502V3.12427Z",
    fill: "#D5D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7303 3.12427H89.5544V97.0832H89.7303V3.12427Z",
    fill: "#D6D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9063 3.12427H89.7303V97.0832H89.9063V3.12427Z",
    fill: "#D7D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0822 3.12427H89.9062V97.0832H90.0822V3.12427Z",
    fill: "#D8D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2582 3.12427H90.0822V97.0832H90.2582V3.12427Z",
    fill: "#DAD8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4341 3.12427H90.2582V97.0832H90.4341V3.12427Z",
    fill: "#DBD9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6101 3.12427H90.4341V97.0832H90.6101V3.12427Z",
    fill: "#DCDADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7902 3.12427H90.6143V97.0832H90.7902V3.12427Z",
    fill: "#DDDBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9662 3.12427H90.7902V97.0832H90.9662V3.12427Z",
    fill: "#DEDCDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1421 3.12427H90.9662V97.0832H91.1421V3.12427Z",
    fill: "#DFDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3181 3.12427H91.1421V97.0832H91.3181V3.12427Z",
    fill: "#E0DEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.494 3.12427H91.3181V97.0832H91.494V3.12427Z",
    fill: "#E1E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.67 3.12427H91.494V97.0832H91.67V3.12427Z",
    fill: "#E2E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8501 3.12427H91.6742V97.0832H91.8501V3.12427Z",
    fill: "#E3E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0261 3.12427H91.8501V97.0832H92.0261V3.12427Z",
    fill: "#E4E3E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.202 3.12427H92.0261V97.0832H92.202V3.12427Z",
    fill: "#E5E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.378 3.12427H92.202V97.0832H92.378V3.12427Z",
    fill: "#E6E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5539 3.12427H92.378V97.0832H92.5539V3.12427Z",
    fill: "#E7E6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7299 3.12427H92.5539V97.0832H92.7299V3.12427Z",
    fill: "#E8E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.91 3.12427H92.7341V97.0832H92.91V3.12427Z",
    fill: "#E9E8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.086 3.12427H92.91V97.0832H93.086V3.12427Z",
    fill: "#EAE9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2619 3.12427H93.086V97.0832H93.2619V3.12427Z",
    fill: "#EBEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4379 3.12427H93.2619V97.0832H93.4379V3.12427Z",
    fill: "#ECEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6138 3.12427H93.4379V97.0832H93.6138V3.12427Z",
    fill: "#EDECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7898 3.12427H93.6138V97.0832H93.7898V3.12427Z",
    fill: "#EEEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9699 3.12427H93.794V97.0832H93.9699V3.12427Z",
    fill: "#EFEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1459 3.12427H93.9699V97.0832H94.1459V3.12427Z",
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3218 3.12427H94.1459V97.0832H94.3218V3.12427Z",
    fill: "#F1F0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4978 3.12427H94.3218V97.0832H94.4978V3.12427Z",
    fill: "#F2F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6738 3.12427H94.4978V97.0832H94.6738V3.12427Z",
    fill: "#F3F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8497 3.12427H94.6738V97.0832H94.8497V3.12427Z",
    fill: "#F4F3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0298 3.12427H94.8539V97.0832H95.0298V3.12427Z",
    fill: "#F5F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2058 3.12427H95.0298V97.0832H95.2058V3.12427Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3818 3.12427H95.2058V97.0832H95.3818V3.12427Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5577 3.12427H95.3817V97.0832H95.5577V3.12427Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7337 3.12427H95.5577V97.0832H95.7337V3.12427Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9096 3.12427H95.7337V97.0832H95.9096V3.12427Z",
    fill: "#F9F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0897 3.12427H95.9138V97.0832H96.0897V3.12427Z",
    fill: "#FAF9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2657 3.12427H96.0898V97.0832H96.2657V3.12427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4417 3.12427H96.2657V97.0832H96.4417V3.12427Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6176 3.12427H96.4417V97.0832H96.6176V3.12427Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7936 3.12427H96.6176V97.0832H96.7936V3.12427Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9695 3.12427H96.7936V97.0832H96.9695V3.12427Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1497 3.12427H96.9737V97.0832H97.1497V3.12427Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3256 3.12427H97.1497V97.0832H97.3256V3.12427Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5016 3.12427H97.3256V97.0832H97.5016V3.12427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6775 3.12427H97.5016V97.0832H97.6775V3.12427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5321 3.12427H97.6775V97.0832H98.5321V3.12427Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_26_4148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 81,
    height: 80
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7955 78.2362C94.333 62.6987 94.333 37.5074 78.7955 21.9698C63.2579 6.4323 38.0666 6.4323 22.5291 21.9698C6.99154 37.5074 6.99154 62.6987 22.5291 78.2362C38.0666 93.7738 63.2579 93.7738 78.7955 78.2362Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_26_4148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 10.3175H10.874V11.2056H90.4509V10.3175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 11.2057H10.874V11.3104H90.4509V11.2057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 11.3062H10.874V11.4109H90.4509V11.3062Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 11.4109H10.874V11.5156H90.4509V11.4109Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 11.5156H10.874V11.6204H90.4509V11.5156Z",
    fill: "#FDFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 11.6204H10.874V11.7251H90.4509V11.6204Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 11.7251H10.874V11.8298H90.4509V11.7251Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 11.8298H10.874V11.9346H90.4509V11.8298Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 11.9304H10.874V12.0352H90.4509V11.9304Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.0352H10.874V12.1399H90.4509V12.0352Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.1399H10.874V12.2446H90.4509V12.1399Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.2446H10.874V12.3494H90.4509V12.2446Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.3494H10.874V12.4541H90.4509V12.3494Z",
    fill: "#F6F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.4541H10.874V12.5588H90.4509V12.4541Z",
    fill: "#F5F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.5546H10.874V12.6593H90.4509V12.5546Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.6593H10.874V12.764H90.4509V12.6593Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.764H10.874V12.8688H90.4509V12.764Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.8688H10.874V12.9735H90.4509V12.8688Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 12.9735H10.874V13.0782H90.4509V12.9735Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.0782H10.874V13.183H90.4509V13.0782Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.1788H10.874V13.2836H90.4509V13.1788Z",
    fill: "#EFEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.2836H10.874V13.3883H90.4509V13.2836Z",
    fill: "#EEEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.3883H10.874V13.493H90.4509V13.3883Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.493H10.874V13.5978H90.4509V13.493Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.5978H10.874V13.7025H90.4509V13.5978Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.6984H10.874V13.7654H90.4509V13.6984Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.7695H10.874V13.8366H90.4509V13.7695Z",
    fill: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.8365H10.874V13.9036H90.4509V13.8365Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.9036H10.874V13.9706H90.4509V13.9036Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 13.9706H10.874V14.0376H90.4509V13.9706Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.0419H10.874V14.1089H90.4509V14.0419Z",
    fill: "#E4E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.1089H10.874V14.1759H90.4509V14.1089Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.1759H10.874V14.2429H90.4509V14.1759Z",
    fill: "#E1E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.2429H10.874V14.3099H90.4509V14.2429Z",
    fill: "#DFDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.3142H10.874V14.3812H90.4509V14.3142Z",
    fill: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.3812H10.874V14.4483H90.4509V14.3812Z",
    fill: "#DCDBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.4482H10.874V14.5153H90.4509V14.4482Z",
    fill: "#DBDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.5153H10.874V14.5823H90.4509V14.5153Z",
    fill: "#D9D8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.5864H10.874V14.6535H90.4509V14.5864Z",
    fill: "#D8D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.6534H10.874V14.7205H90.4509V14.6534Z",
    fill: "#D7D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.7206H10.874V14.7876H90.4509V14.7206Z",
    fill: "#D5D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.7876H10.874V14.8546H90.4509V14.7876Z",
    fill: "#D4D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.8588H10.874V14.9258H90.4509V14.8588Z",
    fill: "#D2D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.9258H10.874V14.9928H90.4509V14.9258Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 14.9928H10.874V15.0598H90.4509V14.9928Z",
    fill: "#D0CECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.0598H10.874V15.1268H90.4509V15.0598Z",
    fill: "#CECDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.1311H10.874V15.1981H90.4509V15.1311Z",
    fill: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.1981H10.874V15.2651H90.4509V15.1981Z",
    fill: "#CBCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.2651H10.874V15.3322H90.4509V15.2651Z",
    fill: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.3322H10.874V15.3992H90.4509V15.3322Z",
    fill: "#C9C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.4034H10.874V15.4705H90.4509V15.4034Z",
    fill: "#C8C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.4705H10.874V15.5375H90.4509V15.4705Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.5375H10.874V15.6045H90.4509V15.5375Z",
    fill: "#C5C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.6045H10.874V15.6715H90.4509V15.6045Z",
    fill: "#C4C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.6757H10.874V15.7427H90.4509V15.6757Z",
    fill: "#C2C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.7427H10.874V15.8097H90.4509V15.7427Z",
    fill: "#C1C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.8098H10.874V15.8768H90.4509V15.8098Z",
    fill: "#C0BEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.8768H10.874V15.9439H90.4509V15.8768Z",
    fill: "#BFBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 15.948H10.874V16.015H90.4509V15.948Z",
    fill: "#BDBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.015H10.874V16.082H90.4509V16.015Z",
    fill: "#BCBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.082H10.874V16.1491H90.4509V16.082Z",
    fill: "#BBB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.149H10.874V16.2161H90.4509V16.149Z",
    fill: "#BAB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.2203H10.874V16.2874H90.4509V16.2203Z",
    fill: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.2874H10.874V16.3544H90.4509V16.2874Z",
    fill: "#B7B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.3544H10.874V16.4214H90.4509V16.3544Z",
    fill: "#B6B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.4214H10.874V16.4884H90.4509V16.4214Z",
    fill: "#B5B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.4927H10.874V16.5597H90.4509V16.4927Z",
    fill: "#B3B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.5597H10.874V16.6267H90.4509V16.5597Z",
    fill: "#B2B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.6267H10.874V16.6937H90.4509V16.6267Z",
    fill: "#B1AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.6937H10.874V16.7608H90.4509V16.6937Z",
    fill: "#B0AEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.7649H10.874V16.8319H90.4509V16.7649Z",
    fill: "#AEADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.8319H10.874V16.8989H90.4509V16.8319Z",
    fill: "#ADACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.899H10.874V16.9661H90.4509V16.899Z",
    fill: "#ACABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 16.9661H10.874V17.0331H90.4509V16.9661Z",
    fill: "#ABA9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.0372H10.874V17.1043H90.4509V17.0372Z",
    fill: "#AAA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.1042H10.874V17.1713H90.4509V17.1042Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.1713H10.874V17.2383H90.4509V17.1713Z",
    fill: "#A7A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.2383H10.874V17.3053H90.4509V17.2383Z",
    fill: "#A6A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.3096H10.874V17.3766H90.4509V17.3096Z",
    fill: "#A5A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.3766H10.874V17.4436H90.4509V17.3766Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.4436H10.874V17.5106H90.4509V17.4436Z",
    fill: "#A3A1A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.5106H10.874V17.5776H90.4509V17.5106Z",
    fill: "#A2A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.5819H10.874V17.6489H90.4509V17.5819Z",
    fill: "#A19F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.6489H10.874V17.716H90.4509V17.6489Z",
    fill: "#9F9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.7159H10.874V17.783H90.4509V17.7159Z",
    fill: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.783H10.874V17.85H90.4509V17.783Z",
    fill: "#9D9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.8541H10.874V17.9212H90.4509V17.8541Z",
    fill: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.9211H10.874V17.9882H90.4509V17.9211Z",
    fill: "#9B9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 17.9883H10.874V18.0553H90.4509V17.9883Z",
    fill: "#9A9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.0553H10.874V18.1223H90.4509V18.0553Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.1265H10.874V18.1935H90.4509V18.1265Z",
    fill: "#989797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.1935H10.874V18.2605H90.4509V18.1935Z",
    fill: "#979696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.2605H10.874V18.3275H90.4509V18.2605Z",
    fill: "#969595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.3275H10.874V18.3945H90.4509V18.3275Z",
    fill: "#959494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.3988H10.874V18.4658H90.4509V18.3988Z",
    fill: "#949393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.4658H10.874V18.5328H90.4509V18.4658Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.5328H10.874V18.5999H90.4509V18.5328Z",
    fill: "#929191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.5999H10.874V18.6669H90.4509V18.5999Z",
    fill: "#919090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.6711H10.874V18.7382H90.4509V18.6711Z",
    fill: "#908F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.7382H10.874V18.8052H90.4509V18.7382Z",
    fill: "#8F8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.8052H10.874V18.8722H90.4509V18.8052Z",
    fill: "#8E8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.8722H10.874V18.9392H90.4509V18.8722Z",
    fill: "#8D8C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 18.9434H10.874V19.0104H90.4509V18.9434Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.0104H10.874V19.0774H90.4509V19.0104Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.0774H10.874V19.1444H90.4509V19.0774Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.1445H10.874V19.2116H90.4509V19.1445Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.2157H10.874V19.2827H90.4509V19.2157Z",
    fill: "#898888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.2827H10.874V19.3497H90.4509V19.2827Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.3497H10.874V19.4168H90.4509V19.3497Z",
    fill: "#878686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.4167H10.874V19.4838H90.4509V19.4167Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.488H10.874V19.5551H90.4509V19.488Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.5551H10.874V19.6221H90.4509V19.5551Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.6221H10.874V19.6891H90.4509V19.6221Z",
    fill: "#848383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.6891H10.874V19.7561H90.4509V19.6891Z",
    fill: "#838282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.7604H10.874V19.8274H90.4509V19.7604Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.8274H10.874V19.8944H90.4509V19.8274Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.8944H10.874V19.9614H90.4509V19.8944Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 19.9614H10.874V20.0285H90.4509V19.9614Z",
    fill: "#807F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.0326H10.874V20.0996H90.4509V20.0326Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.0996H10.874V20.1666H90.4509V20.0996Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.1667H10.874V20.2338H90.4509V20.1667Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.2338H10.874V20.3008H90.4509V20.2338Z",
    fill: "#7D7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.3049H10.874V20.372H90.4509V20.3049Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.3719H10.874V20.439H90.4509V20.3719Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.439H10.874V20.506H90.4509V20.439Z",
    fill: "#7B7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.506H10.874V20.573H90.4509V20.506Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.5773H10.874V20.6443H90.4509V20.5773Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.6443H10.874V20.7113H90.4509V20.6443Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.7113H10.874V20.7783H90.4509V20.7113Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.7783H10.874V20.8453H90.4509V20.7783Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.8496H10.874V20.9166H90.4509V20.8496Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.9166H10.874V20.9837H90.4509V20.9166Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 20.9836H10.874V21.0507H90.4509V20.9836Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 21.0507H10.874V21.1177H90.4509V21.0507Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 21.1218H10.874V21.2643H90.4509V21.1218Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 21.2601H10.874V21.4026H90.4509V21.2601Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 21.4026H10.874V21.545H90.4509V21.4026Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 21.545H10.874V21.6875H90.4509V21.545Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 21.6832H10.874V21.8257H90.4509V21.6832Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 21.8257H10.874V21.9681H90.4509V21.8257Z",
    fill: "#797878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 21.9681H10.874V22.1106H90.4509V21.9681Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 22.1063H10.874V22.2488H90.4509V22.1063Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 22.2488H10.874V22.3912H90.4509V22.2488Z",
    fill: "#7B7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 22.3912H10.874V22.5337H90.4509V22.3912Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 22.5337H10.874V22.6761H90.4509V22.5337Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 22.6719H10.874V22.8143H90.4509V22.6719Z",
    fill: "#7D7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 22.8143H10.874V22.9568H90.4509V22.8143Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 22.9568H10.874V23.0992H90.4509V22.9568Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 23.0951H10.874V23.2375H90.4509V23.0951Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 23.2375H10.874V23.38H90.4509V23.2375Z",
    fill: "#807F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 23.3799H10.874V23.5223H90.4509V23.3799Z",
    fill: "#818080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 23.5182H10.874V23.6606H90.4509V23.5182Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 23.6606H10.874V23.8031H90.4509V23.6606Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 23.8031H10.874V23.9455H90.4509V23.8031Z",
    fill: "#838282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 23.9413H10.874V24.0837H90.4509V23.9413Z",
    fill: "#848383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 24.0837H10.874V24.2262H90.4509V24.0837Z",
    fill: "#858484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 24.2262H10.874V24.3686H90.4509V24.2262Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 24.3644H10.874V24.5068H90.4509V24.3644Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 24.5068H10.874V24.6493H90.4509V24.5068Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 24.6493H10.874V24.7917H90.4509V24.6493Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 24.7876H10.874V24.93H90.4509V24.7876Z",
    fill: "#898888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 24.9299H10.874V25.0724H90.4509V24.9299Z",
    fill: "#8A8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 25.0724H10.874V25.2148H90.4509V25.0724Z",
    fill: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 25.2107H10.874V25.3531H90.4509V25.2107Z",
    fill: "#8C8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 25.3531H10.874V25.4956H90.4509V25.3531Z",
    fill: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 25.4956H10.874V25.638H90.4509V25.4956Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 25.6379H10.874V25.7804H90.4509V25.6379Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 25.7762H10.874V25.9187H90.4509V25.7762Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 25.9187H10.874V26.0611H90.4509V25.9187Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 26.0612H10.874V26.2036H90.4509V26.0612Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 26.1993H10.874V26.3418H90.4509V26.1993Z",
    fill: "#929192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 26.3418H10.874V26.4842H90.4509V26.3418Z",
    fill: "#939293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 26.4843H10.874V26.6267H90.4509V26.4843Z",
    fill: "#949393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 26.6224H10.874V26.7649H90.4509V26.6224Z",
    fill: "#959494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 26.7649H10.874V26.9073H90.4509V26.7649Z",
    fill: "#969595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 26.9073H10.874V27.0498H90.4509V26.9073Z",
    fill: "#979696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 27.0457H10.874V27.1881H90.4509V27.0457Z",
    fill: "#989797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 27.1881H10.874V27.3305H90.4509V27.1881Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 27.3304H10.874V27.4729H90.4509V27.3304Z",
    fill: "#9A9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 27.4688H10.874V27.6112H90.4509V27.4688Z",
    fill: "#9C9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 27.6112H10.874V27.7536H90.4509V27.6112Z",
    fill: "#9D9B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 27.7537H10.874V27.8961H90.4509V27.7537Z",
    fill: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 27.8918H10.874V28.0343H90.4509V27.8918Z",
    fill: "#9F9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 28.0343H10.874V28.1767H90.4509V28.0343Z",
    fill: "#A09F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 28.1768H10.874V28.3192H90.4509V28.1768Z",
    fill: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 28.3149H10.874V28.4574H90.4509V28.3149Z",
    fill: "#A2A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 28.4574H10.874V28.5998H90.4509V28.4574Z",
    fill: "#A3A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 28.5999H10.874V28.7423H90.4509V28.5999Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 28.7423H10.874V28.8847H90.4509V28.7423Z",
    fill: "#A5A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 28.8805H10.874V29.0229H90.4509V28.8805Z",
    fill: "#A7A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 29.0229H10.874V29.1654H90.4509V29.0229Z",
    fill: "#A8A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 29.1654H10.874V29.3078H90.4509V29.1654Z",
    fill: "#A9A7A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 29.3037H10.874V29.4461H90.4509V29.3037Z",
    fill: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 29.4462H10.874V29.5886H90.4509V29.4462Z",
    fill: "#ABAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 29.5885H10.874V29.7309H90.4509V29.5885Z",
    fill: "#ACABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 29.7268H10.874V29.8692H90.4509V29.7268Z",
    fill: "#AEACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 29.8693H10.874V30.0117H90.4509V29.8693Z",
    fill: "#AFADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 30.0117H10.874V30.1542H90.4509V30.0117Z",
    fill: "#B0AEAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 30.1499H10.874V30.2923H90.4509V30.1499Z",
    fill: "#B1B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 30.2924H10.874V30.4348H90.4509V30.2924Z",
    fill: "#B2B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 30.4348H10.874V30.5773H90.4509V30.4348Z",
    fill: "#B4B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 30.573H10.874V30.7154H90.4509V30.573Z",
    fill: "#B5B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 30.7155H10.874V30.8579H90.4509V30.7155Z",
    fill: "#B6B4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 30.8579H10.874V31.0003H90.4509V30.8579Z",
    fill: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 30.9962H10.874V31.1387H90.4509V30.9962Z",
    fill: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 31.1387H10.874V31.2811H90.4509V31.1387Z",
    fill: "#BAB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 31.281H10.874V31.4234H90.4509V31.281Z",
    fill: "#BBB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 31.4193H10.874V31.5618H90.4509V31.4193Z",
    fill: "#BCBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 31.5618H10.874V31.7042H90.4509V31.5618Z",
    fill: "#BDBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 31.7042H10.874V31.8467H90.4509V31.7042Z",
    fill: "#BFBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 31.8467H10.874V31.9891H90.4509V31.8467Z",
    fill: "#C0BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 31.9849H10.874V32.1273H90.4509V31.9849Z",
    fill: "#C1C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 32.1273H10.874V32.2698H90.4509V32.1273Z",
    fill: "#C2C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 32.2698H10.874V32.4122H90.4509V32.2698Z",
    fill: "#C4C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 32.408H10.874V32.5504H90.4509V32.408Z",
    fill: "#C5C3C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 32.5504H10.874V32.6929H90.4509V32.5504Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 32.6929H10.874V32.8353H90.4509V32.6929Z",
    fill: "#C7C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 32.8312H10.874V32.9736H90.4509V32.8312Z",
    fill: "#C9C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 32.9735H10.874V33.116H90.4509V32.9735Z",
    fill: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 33.116H10.874V33.2584H90.4509V33.116Z",
    fill: "#CBCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 33.2543H10.874V33.3967H90.4509V33.2543Z",
    fill: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 33.3967H10.874V33.5392H90.4509V33.3967Z",
    fill: "#CECDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 33.5391H10.874V33.6815H90.4509V33.5391Z",
    fill: "#CFCECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 33.6774H10.874V33.8198H90.4509V33.6774Z",
    fill: "#D0CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 33.8198H10.874V33.9623H90.4509V33.8198Z",
    fill: "#D2D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 33.9623H10.874V34.1047H90.4509V33.9623Z",
    fill: "#D3D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 34.1005H10.874V34.2429H90.4509V34.1005Z",
    fill: "#D4D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 34.2429H10.874V34.3854H90.4509V34.2429Z",
    fill: "#D6D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 34.3854H10.874V34.5278H90.4509V34.3854Z",
    fill: "#D7D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 34.5237H10.874V34.6661H90.4509V34.5237Z",
    fill: "#D9D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 34.666H10.874V34.8085H90.4509V34.666Z",
    fill: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 34.8085H10.874V34.9509H90.4509V34.8085Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 34.9509H10.874V35.0934H90.4509V34.9509Z",
    fill: "#DDDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 35.0892H10.874V35.2317H90.4509V35.0892Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 35.2316H10.874V35.374H90.4509V35.2316Z",
    fill: "#E0DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 35.374H10.874V35.5165H90.4509V35.374Z",
    fill: "#E1E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 35.5123H10.874V35.6548H90.4509V35.5123Z",
    fill: "#E3E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 35.6548H10.874V35.7972H90.4509V35.6548Z",
    fill: "#E4E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 35.7972H10.874V35.9397H90.4509V35.7972Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 35.9354H10.874V36.0779H90.4509V35.9354Z",
    fill: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 36.0779H10.874V36.2203H90.4509V36.0779Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 36.2203H10.874V36.3628H90.4509V36.2203Z",
    fill: "#EAE9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 36.3585H10.874V36.501H90.4509V36.3585Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 36.501H10.874V36.8822H90.4509V36.501Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 36.8822H10.874V37.2634H90.4509V36.8822Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 37.2593H10.874V37.6405H90.4509V37.2593Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 37.6405H10.874V38.0217H90.4509V37.6405Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 38.0176H10.874V38.3988H90.4509V38.0176Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 38.3988H10.874V38.78H90.4509V38.3988Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 38.78H10.874V39.1613H90.4509V38.78Z",
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 39.1571H10.874V39.5383H90.4509V39.1571Z",
    fill: "#F2F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 39.5383H10.874V39.9196H90.4509V39.5383Z",
    fill: "#F3F3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 39.9153H10.874V40.2965H90.4509V39.9153Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 40.2965H10.874V40.6777H90.4509V40.2965Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 40.6736H10.874V41.0548H90.4509V40.6736Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 41.0548H10.874V41.436H90.4509V41.0548Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 41.436H10.874V41.8173H90.4509V41.436Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 41.8131H10.874V42.1943H90.4509V41.8131Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 42.1943H10.874V42.5756H90.4509V42.1943Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 42.5714H10.874V42.9526H90.4509V42.5714Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 42.9526H10.874V43.3339H90.4509V42.9526Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 43.3297H10.874V43.7109H90.4509V43.3297Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 43.7109H10.874V44.0922H90.4509V43.7109Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 44.0922H10.874V44.4734H90.4509V44.0922Z",
    fill: "#FEFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 44.4691H10.874V44.8503H90.4509V44.4691Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 44.8503H10.874V45.2316H90.4509V44.8503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 45.2274H10.874V45.6087H90.4509V45.2274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 45.6086H10.874V46.4172H90.4509V45.6086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 46.413H10.874V47.2215H90.4509V46.413Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 47.2216H10.874V48.0301H90.4509V47.2216Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 48.0302H10.874V48.8387H90.4509V48.0302Z",
    fill: "#FDFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 48.8345H10.874V49.643H90.4509V48.8345Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 49.6431H10.874V50.4516H90.4509V49.6431Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 50.4474H10.874V51.2559H90.4509V50.4474Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 51.256H10.874V52.0645H90.4509V51.256Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 52.0603H10.874V52.8688H90.4509V52.0603Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 52.8688H10.874V53.6773H90.4509V52.8688Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 53.6732H10.874V54.4818H90.4509V53.6732Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 54.4817H10.874V55.2902H90.4509V54.4817Z",
    fill: "#F6F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 55.2903H10.874V56.0988H90.4509V55.2903Z",
    fill: "#F5F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 56.0946H10.874V56.9031H90.4509V56.0946Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 56.9032H10.874V57.7117H90.4509V56.9032Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 57.7075H10.874V58.5161H90.4509V57.7075Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 58.5161H10.874V59.3247H90.4509V58.5161Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 59.3204H10.874V60.129H90.4509V59.3204Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 60.129H10.874V60.9376H90.4509V60.129Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 60.9333H10.874V61.7419H90.4509V60.9333Z",
    fill: "#EFEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 61.7419H10.874V62.5505H90.4509V61.7419Z",
    fill: "#EEEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 62.5504H10.874V63.359H90.4509V62.5504Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 63.3547H10.874V64.1633H90.4509V63.3547Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 64.1633H10.874V64.9719H90.4509V64.1633Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 64.9677H10.874V65.0808H90.4509V64.9677Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 65.085H10.874V65.1981H90.4509V65.085Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 65.1981H10.874V65.3112H90.4509V65.1981Z",
    fill: "#E8E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 65.3154H10.874V65.4285H90.4509V65.3154Z",
    fill: "#E6E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 65.4285H10.874V65.5416H90.4509V65.4285Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 65.5416H10.874V65.6547H90.4509V65.5416Z",
    fill: "#E3E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 65.6589H10.874V65.7721H90.4509V65.6589Z",
    fill: "#E1E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 65.7721H10.874V65.8852H90.4509V65.7721Z",
    fill: "#DFDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 65.8894H10.874V66.0025H90.4509V65.8894Z",
    fill: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 66.0024H10.874V66.1156H90.4509V66.0024Z",
    fill: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 66.1198H10.874V66.2329H90.4509V66.1198Z",
    fill: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 66.2329H10.874V66.346H90.4509V66.2329Z",
    fill: "#D9D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 66.3459H10.874V66.4591H90.4509V66.3459Z",
    fill: "#D7D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 66.4633H10.874V66.5764H90.4509V66.4633Z",
    fill: "#D5D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 66.5764H10.874V66.6895H90.4509V66.5764Z",
    fill: "#D4D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 66.6937H10.874V66.8068H90.4509V66.6937Z",
    fill: "#D2D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 66.8068H10.874V66.9199H90.4509V66.8068Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 66.9241H10.874V67.0372H90.4509V66.9241Z",
    fill: "#CFCECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 67.0372H10.874V67.1503H90.4509V67.0372Z",
    fill: "#CECCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 67.1504H10.874V67.2635H90.4509V67.1504Z",
    fill: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 67.2677H10.874V67.3808H90.4509V67.2677Z",
    fill: "#CBC9CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 67.3807H10.874V67.4939H90.4509V67.3807Z",
    fill: "#C9C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 67.498H10.874V67.6112H90.4509V67.498Z",
    fill: "#C8C6C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 67.6112H10.874V67.7243H90.4509V67.6112Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 67.7285H10.874V67.8416H90.4509V67.7285Z",
    fill: "#C5C3C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 67.8416H10.874V67.9547H90.4509V67.8416Z",
    fill: "#C3C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 67.9589H10.874V68.072H90.4509V67.9589Z",
    fill: "#C2C0C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 68.072H10.874V68.1851H90.4509V68.072Z",
    fill: "#C1BFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 68.1852H10.874V68.2983H90.4509V68.1852Z",
    fill: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 68.3024H10.874V68.4155H90.4509V68.3024Z",
    fill: "#BEBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 68.4155H10.874V68.5286H90.4509V68.4155Z",
    fill: "#BCBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 68.5328H10.874V68.646H90.4509V68.5328Z",
    fill: "#BBB9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 68.646H10.874V68.7591H90.4509V68.646Z",
    fill: "#BAB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 68.7633H10.874V68.8764H90.4509V68.7633Z",
    fill: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 68.8763H10.874V68.9895H90.4509V68.8763Z",
    fill: "#B7B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 68.9895H10.874V69.1026H90.4509V68.9895Z",
    fill: "#B6B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 69.1068H10.874V69.2199H90.4509V69.1068Z",
    fill: "#B4B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 69.2198H10.874V69.333H90.4509V69.2198Z",
    fill: "#B3B1B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 69.3372H10.874V69.4503H90.4509V69.3372Z",
    fill: "#B2B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 69.4503H10.874V69.5634H90.4509V69.4503Z",
    fill: "#B0AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 69.5676H10.874V69.6807H90.4509V69.5676Z",
    fill: "#AFAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 69.6807H10.874V69.7938H90.4509V69.6807Z",
    fill: "#AEACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 69.7938H10.874V69.9069H90.4509V69.7938Z",
    fill: "#ACABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 69.9111H10.874V70.0242H90.4509V69.9111Z",
    fill: "#ABAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 70.0243H10.874V70.1374H90.4509V70.0243Z",
    fill: "#AAA8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 70.1416H10.874V70.2547H90.4509V70.1416Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 70.2546H10.874V70.3678H90.4509V70.2546Z",
    fill: "#A7A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 70.3719H10.874V70.4851H90.4509V70.3719Z",
    fill: "#A6A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 70.4851H10.874V70.5982H90.4509V70.4851Z",
    fill: "#A5A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 70.5981H10.874V70.7113H90.4509V70.5981Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 70.7155H10.874V70.8286H90.4509V70.7155Z",
    fill: "#A3A1A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 70.8286H10.874V70.9417H90.4509V70.8286Z",
    fill: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 70.9459H10.874V71.059H90.4509V70.9459Z",
    fill: "#A09F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 71.059H10.874V71.1721H90.4509V71.059Z",
    fill: "#9F9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 71.1763H10.874V71.2894H90.4509V71.1763Z",
    fill: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 71.2894H10.874V71.4025H90.4509V71.2894Z",
    fill: "#9D9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 71.4067H10.874V71.5199H90.4509V71.4067Z",
    fill: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 71.5199H10.874V71.633H90.4509V71.5199Z",
    fill: "#9B9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 71.6329H10.874V71.746H90.4509V71.6329Z",
    fill: "#9A9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 71.7502H10.874V71.8634H90.4509V71.7502Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 71.8634H10.874V71.9765H90.4509V71.8634Z",
    fill: "#989797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 71.9807H10.874V72.0938H90.4509V71.9807Z",
    fill: "#979696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 72.0938H10.874V72.2069H90.4509V72.0938Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 72.2111H10.874V72.3242H90.4509V72.2111Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 72.3242H10.874V72.4373H90.4509V72.3242Z",
    fill: "#949393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 72.4373H10.874V72.5504H90.4509V72.4373Z",
    fill: "#939292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 72.5546H10.874V72.6677H90.4509V72.5546Z",
    fill: "#929191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 72.6677H10.874V72.7808H90.4509V72.6677Z",
    fill: "#919090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 72.785H10.874V72.8981H90.4509V72.785Z",
    fill: "#908F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 72.8982H10.874V73.0113H90.4509V72.8982Z",
    fill: "#8F8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 73.0155H10.874V73.1286H90.4509V73.0155Z",
    fill: "#8E8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 73.1285H10.874V73.2417H90.4509V73.1285Z",
    fill: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 73.2417H10.874V73.3548H90.4509V73.2417Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 73.359H10.874V73.4721H90.4509V73.359Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 73.472H10.874V73.5852H90.4509V73.472Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 73.5894H10.874V73.7025H90.4509V73.5894Z",
    fill: "#8A8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 73.7025H10.874V73.8156H90.4509V73.7025Z",
    fill: "#898888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 73.8198H10.874V73.9329H90.4509V73.8198Z",
    fill: "#888788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 73.9329H10.874V74.046H90.4509V73.9329Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 74.046H10.874V74.1591H90.4509V74.046Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 74.1633H10.874V74.2764H90.4509V74.1633Z",
    fill: "#868585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 74.2765H10.874V74.3896H90.4509V74.2765Z",
    fill: "#858484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 74.3938H10.874V74.5069H90.4509V74.3938Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 74.5068H10.874V74.6199H90.4509V74.5068Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 74.6241H10.874V74.7373H90.4509V74.6241Z",
    fill: "#838282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 74.7373H10.874V74.8504H90.4509V74.7373Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 74.8546H10.874V74.9677H90.4509V74.8546Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 74.9677H10.874V75.0808H90.4509V74.9677Z",
    fill: "#818080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 75.0808H10.874V75.1939H90.4509V75.0808Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 75.1981H10.874V75.3112H90.4509V75.1981Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 75.3113H10.874V75.4244H90.4509V75.3113Z",
    fill: "#7F7E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 75.4285H10.874V75.5416H90.4509V75.4285Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 75.5416H10.874V75.6547H90.4509V75.5416Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 75.6589H10.874V75.772H90.4509V75.6589Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 75.7721H10.874V75.8852H90.4509V75.7721Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 75.8851H10.874V75.9982H90.4509V75.8851Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 76.0024H10.874V76.1156H90.4509V76.0024Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 76.1156H10.874V76.2287H90.4509V76.1156Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 76.2329H10.874V76.346H90.4509V76.2329Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 76.3459H10.874V76.4591H90.4509V76.3459Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 76.4633H10.874V76.5764H90.4509V76.4633Z",
    fill: "#79797A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 76.5764H10.874V76.6895H90.4509V76.5764Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 76.6895H10.874V76.8026H90.4509V76.6895Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 76.8068H10.874V76.9199H90.4509V76.8068Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 76.9199H10.874V77.033H90.4509V76.9199Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.0372H10.874V77.1503H90.4509V77.0372Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.1504H10.874V77.2635H90.4509V77.1504Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.2677H10.874V77.3808H90.4509V77.2677Z",
    fill: "#777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.3807H10.874V77.4603H90.4509V77.3807Z",
    fill: "#777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.4603H10.874V77.5399H90.4509V77.4603Z",
    fill: "#777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.5442H10.874V77.6238H90.4509V77.5442Z",
    fill: "#777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.6238H10.874V77.7034H90.4509V77.6238Z",
    fill: "#777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.7075H10.874V77.7871H90.4509V77.7075Z",
    fill: "#777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.7871H10.874V77.8667H90.4509V77.7871Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.8667H10.874V77.9463H90.4509V77.8667Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 77.9506H10.874V78.0302H90.4509V77.9506Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.0302H10.874V78.1097H90.4509V78.0302Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.1139H10.874V78.1935H90.4509V78.1139Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.1935H10.874V78.2731H90.4509V78.1935Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.2731H10.874V78.3527H90.4509V78.2731Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.3569H10.874V78.4365H90.4509V78.3569Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.4365H10.874V78.5161H90.4509V78.4365Z",
    fill: "#797879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.5161H10.874V78.5957H90.4509V78.5161Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.5999H10.874V78.6795H90.4509V78.5999Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.6794H10.874V78.759H90.4509V78.6794Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.7633H10.874V78.8429H90.4509V78.7633Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.8429H10.874V78.9225H90.4509V78.8429Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 78.9225H10.874V79.0021H90.4509V78.9225Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.0062H10.874V79.0858H90.4509V79.0062Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.0858H10.874V79.1654H90.4509V79.0858Z",
    fill: "#7B7A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.1654H10.874V79.245H90.4509V79.1654Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.2493H10.874V79.3289H90.4509V79.2493Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.3289H10.874V79.4085H90.4509V79.3289Z",
    fill: "#7C7B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.4126H10.874V79.4922H90.4509V79.4126Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.4922H10.874V79.5718H90.4509V79.4922Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.5718H10.874V79.6514H90.4509V79.5718Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.6556H10.874V79.7352H90.4509V79.6556Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.7352H10.874V79.8148H90.4509V79.7352Z",
    fill: "#7E7D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.819H10.874V79.8986H90.4509V79.819Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.8986H10.874V79.9782H90.4509V79.8986Z",
    fill: "#7F7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 79.9781H10.874V80.0577H90.4509V79.9781Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.062H10.874V80.1416H90.4509V80.062Z",
    fill: "#807F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.1416H10.874V80.2212H90.4509V80.1416Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.2212H10.874V80.3008H90.4509V80.2212Z",
    fill: "#818080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.3049H10.874V80.3845H90.4509V80.3049Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.3845H10.874V80.4641H90.4509V80.3845Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.4683H10.874V80.5479H90.4509V80.4683Z",
    fill: "#838282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.548H10.874V80.6276H90.4509V80.548Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.6276H10.874V80.7072H90.4509V80.6276Z",
    fill: "#848384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.7113H10.874V80.7909H90.4509V80.7113Z",
    fill: "#858484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.7909H10.874V80.8705H90.4509V80.7909Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.8746H10.874V80.9542H90.4509V80.8746Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 80.9543H10.874V81.0339H90.4509V80.9543Z",
    fill: "#878686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.0339H10.874V81.1135H90.4509V81.0339Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.1177H10.874V81.1973H90.4509V81.1177Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.1973H10.874V81.2769H90.4509V81.1973Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.2769H10.874V81.3564H90.4509V81.2769Z",
    fill: "#8A8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.3606H10.874V81.4402H90.4509V81.3606Z",
    fill: "#8B8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.4403H10.874V81.5199H90.4509V81.4403Z",
    fill: "#8C8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.524H10.874V81.6036H90.4509V81.524Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.6036H10.874V81.6832H90.4509V81.6036Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.6832H10.874V81.7628H90.4509V81.6832Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.7671H10.874V81.8467H90.4509V81.7671Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.8467H10.874V81.9263H90.4509V81.8467Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 81.9263H10.874V82.0059H90.4509V81.9263Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.01H10.874V82.0896H90.4509V82.01Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.0896H10.874V82.1692H90.4509V82.0896Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.1733H10.874V82.2529H90.4509V82.1733Z",
    fill: "#959494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.2529H10.874V82.3325H90.4509V82.2529Z",
    fill: "#969595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.3325H10.874V82.4121H90.4509V82.3325Z",
    fill: "#979696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.4164H10.874V82.496H90.4509V82.4164Z",
    fill: "#989797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.496H10.874V82.5756H90.4509V82.496Z",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.5797H10.874V82.6593H90.4509V82.5797Z",
    fill: "#9A999A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.6593H10.874V82.7389H90.4509V82.6593Z",
    fill: "#9C9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.739H10.874V82.8186H90.4509V82.739Z",
    fill: "#9D9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.8228H10.874V82.9024H90.4509V82.8228Z",
    fill: "#9E9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.9023H10.874V82.9819H90.4509V82.9023Z",
    fill: "#A09E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 82.9819H10.874V83.0615H90.4509V82.9819Z",
    fill: "#A1A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.0657H10.874V83.1453H90.4509V83.0657Z",
    fill: "#A2A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.1453H10.874V83.2249H90.4509V83.1453Z",
    fill: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.2291H10.874V83.3087H90.4509V83.2291Z",
    fill: "#A5A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.3087H10.874V83.3883H90.4509V83.3087Z",
    fill: "#A7A5A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.3883H10.874V83.4679H90.4509V83.3883Z",
    fill: "#A8A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.472H10.874V83.5516H90.4509V83.472Z",
    fill: "#AAA8A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.5516H10.874V83.6312H90.4509V83.5516Z",
    fill: "#ABAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.6355H10.874V83.7151H90.4509V83.6355Z",
    fill: "#ADACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.7151H10.874V83.7947H90.4509V83.7151Z",
    fill: "#AFADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.7947H10.874V83.8743H90.4509V83.7947Z",
    fill: "#B0AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.8784H10.874V83.958H90.4509V83.8784Z",
    fill: "#B2B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 83.958H10.874V84.0376H90.4509V83.958Z",
    fill: "#B4B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.0376H10.874V84.1172H90.4509V84.0376Z",
    fill: "#B6B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.1215H10.874V84.2011H90.4509V84.1215Z",
    fill: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.201H10.874V84.2806H90.4509V84.201Z",
    fill: "#B9B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.2848H10.874V84.3644H90.4509V84.2848Z",
    fill: "#BBB9BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.3644H10.874V84.444H90.4509V84.3644Z",
    fill: "#BDBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.444H10.874V84.5236H90.4509V84.444Z",
    fill: "#BFBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.5278H10.874V84.6074H90.4509V84.5278Z",
    fill: "#C0BFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.6074H10.874V84.687H90.4509V84.6074Z",
    fill: "#C2C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.687H10.874V84.7666H90.4509V84.687Z",
    fill: "#C4C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.7708H10.874V84.8504H90.4509V84.7708Z",
    fill: "#C6C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.8503H10.874V84.9299H90.4509V84.8503Z",
    fill: "#C8C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 84.9342H10.874V85.0138H90.4509V84.9342Z",
    fill: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.0138H10.874V85.0934H90.4509V85.0138Z",
    fill: "#CCCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.0934H10.874V85.173H90.4509V85.0934Z",
    fill: "#CECDCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.1771H10.874V85.2567H90.4509V85.1771Z",
    fill: "#D1D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.2567H10.874V85.3363H90.4509V85.2567Z",
    fill: "#D3D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.3406H10.874V85.4202H90.4509V85.3406Z",
    fill: "#D5D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.4202H10.874V85.4998H90.4509V85.4202Z",
    fill: "#D7D6D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.4998H10.874V85.5794H90.4509V85.4998Z",
    fill: "#DAD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.5835H10.874V85.6631H90.4509V85.5835Z",
    fill: "#DCDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.6631H10.874V85.7427H90.4509V85.6631Z",
    fill: "#DFDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.7427H10.874V85.8223H90.4509V85.7427Z",
    fill: "#E1E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.8265H10.874V85.9061H90.4509V85.8265Z",
    fill: "#E4E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.9061H10.874V85.9857H90.4509V85.9061Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 85.9899H10.874V86.0695H90.4509V85.9899Z",
    fill: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 86.0695H10.874V86.1491H90.4509V86.0695Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 86.149H10.874V86.2831H90.4509V86.149Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 86.2832H10.874V86.4173H90.4509V86.2832Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 86.4131H10.874V86.5471H90.4509V86.4131Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 86.5471H10.874V86.6812H90.4509V86.5471Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 86.6812H10.874V86.8152H90.4509V86.6812Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 86.811H10.874V86.9451H90.4509V86.811Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 86.9451H10.874V87.0791H90.4509V86.9451Z",
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 87.075H10.874V87.209H90.4509V87.075Z",
    fill: "#F2F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 87.209H10.874V87.343H90.4509V87.209Z",
    fill: "#F3F3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 87.3389H10.874V87.4729H90.4509V87.3389Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 87.4729H10.874V87.607H90.4509V87.4729Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 87.6028H10.874V87.7368H90.4509V87.6028Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 87.7368H10.874V87.8709H90.4509V87.7368Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 87.8667H10.874V88.0008H90.4509V87.8667Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 88.0007H10.874V88.1348H90.4509V88.0007Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 88.1306H10.874V88.2647H90.4509V88.1306Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 88.2648H10.874V88.3988H90.4509V88.2648Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 88.3945H10.874V88.5286H90.4509V88.3945Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 88.5287H10.874V88.6627H90.4509V88.5287Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 88.6627H10.874V88.7968H90.4509V88.6627Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 88.7926H10.874V88.9267H90.4509V88.7926Z",
    fill: "#FEFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 88.9266H10.874V89.0607H90.4509V88.9266Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 89.0565H10.874V89.1906H90.4509V89.0565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 89.1906H10.874V89.3246H90.4509V89.1906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4509 89.3204H10.874V89.8902H90.4509V89.3204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_26_4148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 12,
    width: 75,
    height: 76
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6603 87.0037C71.1067 87.0037 87.6817 70.4286 87.6817 49.9823C87.6817 29.536 71.1067 12.9609 50.6603 12.9609C30.214 12.9609 13.639 29.536 13.639 49.9823C13.639 70.4286 30.214 87.0037 50.6603 87.0037Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_26_4148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 12.9609H13.639V87.0079H14.1333V12.9609Z",
    fill: "#59A845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6277 12.9609H14.1333V87.0079H14.6277V12.9609Z",
    fill: "#5AA944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1178 12.9609H14.6235V87.0079H15.1178V12.9609Z",
    fill: "#5BA943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6122 12.9609H15.1178V87.0079H15.6122V12.9609Z",
    fill: "#5CAA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1065 12.9609H15.6122V87.0079H16.1065V12.9609Z",
    fill: "#5DAB41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6009 12.9609H16.1065V87.0079H16.6009V12.9609Z",
    fill: "#5EAB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0952 12.9609H16.6009V87.0079H17.0952V12.9609Z",
    fill: "#5FAC3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5895 12.9609H17.0952V87.0079H17.5895V12.9609Z",
    fill: "#60AD3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0797 12.9609H17.5854V87.0079H18.0797V12.9609Z",
    fill: "#61AD3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.574 12.9609H18.0797V87.0079H18.574V12.9609Z",
    fill: "#62AE3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0684 12.9609H18.574V87.0079H19.0684V12.9609Z",
    fill: "#63AE3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5627 12.9609H19.0684V87.0079H19.5627V12.9609Z",
    fill: "#63AF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0571 12.9609H19.5627V87.0079H20.0571V12.9609Z",
    fill: "#64B039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5514 12.9609H20.0571V87.0079H20.5514V12.9609Z",
    fill: "#65B038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0416 12.9609H20.5472V87.0079H21.0416V12.9609Z",
    fill: "#66B137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5359 12.9609H21.0416V87.0079H21.5359V12.9609Z",
    fill: "#67B236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0303 12.9609H21.5359V87.0079H22.0303V12.9609Z",
    fill: "#68B235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5246 12.9609H22.0303V87.0079H22.5246V12.9609Z",
    fill: "#69B334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4379 12.9609H22.5246V87.0079H23.4379V12.9609Z",
    fill: "#69B334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.347 12.9609H23.4337V87.0079H24.347V12.9609Z",
    fill: "#6AB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2603 12.9609H24.347V87.0079H25.2603V12.9609Z",
    fill: "#6CB433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1694 12.9609H25.2561V87.0079H26.1694V12.9609Z",
    fill: "#6DB432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0826 12.9609H26.1693V87.0079H27.0826V12.9609Z",
    fill: "#6FB531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9917 12.9609H27.0784V87.0079H27.9917V12.9609Z",
    fill: "#70B531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.905 12.9609H27.9917V87.0079H28.905V12.9609Z",
    fill: "#71B530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8141 12.9609H28.9008V87.0079H29.8141V12.9609Z",
    fill: "#73B62F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7274 12.9609H29.8141V87.0079H30.7274V12.9609Z",
    fill: "#74B62F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6365 12.9609H30.7232V87.0079H31.6365V12.9609Z",
    fill: "#76B72E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5497 12.9609H31.6365V87.0079H32.5497V12.9609Z",
    fill: "#77B72D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.463 12.9609H32.5497V87.0079H33.463V12.9609Z",
    fill: "#78B82C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3721 12.9609H33.4588V87.0079H34.3721V12.9609Z",
    fill: "#7AB82C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9347 12.9609H34.3721V87.0079H35.9347V12.9609Z",
    fill: "#7AB82C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4974 12.9609H35.9347V87.0079H37.4974V12.9609Z",
    fill: "#7BB92B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.06 12.9609H37.4974V87.0079H39.06V12.9609Z",
    fill: "#7DB92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6226 12.9609H39.06V87.0079H40.6226V12.9609Z",
    fill: "#7EB929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1853 12.9609H40.6226V87.0079H42.1853V12.9609Z",
    fill: "#7FBA29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7479 12.9609H42.1853V87.0079H43.7479V12.9609Z",
    fill: "#81BA28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3105 12.9609H43.7479V87.0079H45.3105V12.9609Z",
    fill: "#82BA27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8774 12.9609H45.3147V87.0079H46.8774V12.9609Z",
    fill: "#84BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44 12.9609H46.8773V87.0079H48.44V12.9609Z",
    fill: "#85BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6603 12.9609H48.44V87.0079H50.6603V12.9609Z",
    fill: "#85BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8807 12.9609H50.6603V87.0079H52.8807V12.9609Z",
    fill: "#87BC25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1011 12.9609H52.8807V87.0079H55.1011V12.9609Z",
    fill: "#88BC25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3256 12.9609H55.1053V87.0079H57.3256V12.9609Z",
    fill: "#89BD25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.546 12.9609H57.3256V87.0079H59.546V12.9609Z",
    fill: "#8BBD25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7663 12.9609H59.546V87.0079H61.7663V12.9609Z",
    fill: "#8CBE25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9867 12.9609H61.7663V87.0079H63.9867V12.9609Z",
    fill: "#8DBE25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8384 12.9609H63.9909V87.0079H75.8384V12.9609Z",
    fill: "#8DBE25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6859 12.9609H75.8384V87.0079H87.6859V12.9609Z",
    fill: "#8EBF25"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_26_4148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 14,
    width: 75,
    height: 75
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6603 88.0886C71.1067 88.0886 87.6817 71.5136 87.6817 51.0673C87.6817 30.6209 71.1067 14.0459 50.6603 14.0459C30.214 14.0459 13.639 30.6209 13.639 51.0673C13.639 71.5136 30.214 88.0886 50.6603 88.0886Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_26_4148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 14.0459H13.639V88.0928H14.1333V14.0459Z",
    fill: "#59A845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6277 14.0459H14.1333V88.0928H14.6277V14.0459Z",
    fill: "#5AA944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1178 14.0459H14.6235V88.0928H15.1178V14.0459Z",
    fill: "#5BA943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6122 14.0459H15.1178V88.0928H15.6122V14.0459Z",
    fill: "#5CAA42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1065 14.0459H15.6122V88.0928H16.1065V14.0459Z",
    fill: "#5DAB41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6009 14.0459H16.1065V88.0928H16.6009V14.0459Z",
    fill: "#5EAB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0952 14.0459H16.6009V88.0928H17.0952V14.0459Z",
    fill: "#5FAC3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5895 14.0459H17.0952V88.0928H17.5895V14.0459Z",
    fill: "#60AD3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0797 14.0459H17.5854V88.0928H18.0797V14.0459Z",
    fill: "#61AD3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.574 14.0459H18.0797V88.0928H18.574V14.0459Z",
    fill: "#62AE3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0684 14.0459H18.574V88.0928H19.0684V14.0459Z",
    fill: "#63AE3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5627 14.0459H19.0684V88.0928H19.5627V14.0459Z",
    fill: "#63AF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0571 14.0459H19.5627V88.0928H20.0571V14.0459Z",
    fill: "#64B039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5514 14.0459H20.0571V88.0928H20.5514V14.0459Z",
    fill: "#65B038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0416 14.0459H20.5472V88.0928H21.0416V14.0459Z",
    fill: "#66B137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5359 14.0459H21.0416V88.0928H21.5359V14.0459Z",
    fill: "#67B236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0303 14.0459H21.5359V88.0928H22.0303V14.0459Z",
    fill: "#68B235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5246 14.0459H22.0303V88.0928H22.5246V14.0459Z",
    fill: "#69B334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4379 14.0459H22.5246V88.0928H23.4379V14.0459Z",
    fill: "#69B334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.347 14.0459H23.4337V88.0928H24.347V14.0459Z",
    fill: "#6AB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2603 14.0459H24.347V88.0928H25.2603V14.0459Z",
    fill: "#6CB433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1694 14.0459H25.2561V88.0928H26.1694V14.0459Z",
    fill: "#6DB432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0826 14.0459H26.1693V88.0928H27.0826V14.0459Z",
    fill: "#6FB531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9917 14.0459H27.0784V88.0928H27.9917V14.0459Z",
    fill: "#70B531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.905 14.0459H27.9917V88.0928H28.905V14.0459Z",
    fill: "#71B530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8141 14.0459H28.9008V88.0928H29.8141V14.0459Z",
    fill: "#73B62F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7274 14.0459H29.8141V88.0928H30.7274V14.0459Z",
    fill: "#74B62F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6365 14.0459H30.7232V88.0928H31.6365V14.0459Z",
    fill: "#76B72E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5497 14.0459H31.6365V88.0928H32.5497V14.0459Z",
    fill: "#77B72D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.463 14.0459H32.5497V88.0928H33.463V14.0459Z",
    fill: "#78B82C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3721 14.0459H33.4588V88.0928H34.3721V14.0459Z",
    fill: "#7AB82C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9347 14.0459H34.3721V88.0928H35.9347V14.0459Z",
    fill: "#7AB82C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4974 14.0459H35.9347V88.0928H37.4974V14.0459Z",
    fill: "#7BB92B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.06 14.0459H37.4974V88.0928H39.06V14.0459Z",
    fill: "#7DB92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6226 14.0459H39.06V88.0928H40.6226V14.0459Z",
    fill: "#7EB929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1853 14.0459H40.6226V88.0928H42.1853V14.0459Z",
    fill: "#7FBA29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7479 14.0459H42.1853V88.0928H43.7479V14.0459Z",
    fill: "#81BA28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3105 14.0459H43.7479V88.0928H45.3105V14.0459Z",
    fill: "#82BA27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8774 14.0459H45.3147V88.0928H46.8774V14.0459Z",
    fill: "#84BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44 14.0459H46.8773V88.0928H48.44V14.0459Z",
    fill: "#85BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6603 14.0459H48.44V88.0928H50.6603V14.0459Z",
    fill: "#85BB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8807 14.0459H50.6603V88.0928H52.8807V14.0459Z",
    fill: "#87BC25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1011 14.0459H52.8807V88.0928H55.1011V14.0459Z",
    fill: "#88BC25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3256 14.0459H55.1053V88.0928H57.3256V14.0459Z",
    fill: "#89BD25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.546 14.0459H57.3256V88.0928H59.546V14.0459Z",
    fill: "#8BBD25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7663 14.0459H59.546V88.0928H61.7663V14.0459Z",
    fill: "#8CBE25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9867 14.0459H61.7663V88.0928H63.9867V14.0459Z",
    fill: "#8DBE25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8384 14.0459H63.9909V88.0928H75.8384V14.0459Z",
    fill: "#8DBE25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6859 14.0459H75.8384V88.0928H87.6859V14.0459Z",
    fill: "#8EBF25"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5238 78.4406L35.6666 76.7356C35.2016 76.4549 34.8581 76.3669 34.6402 76.4717C34.5104 76.5345 34.3344 76.7523 34.1166 77.121C33.9993 77.3137 33.9993 77.519 34.1082 77.7326C34.2045 77.9044 34.414 78.0887 34.7408 78.2856L35.9222 78.9895C36.4249 79.2911 36.7684 79.6304 36.9528 80.0158C37.1329 80.3971 37.1161 80.7741 36.8983 81.1386L36.3704 82.0226C36.14 82.408 35.8091 82.6091 35.3776 82.63C34.9461 82.651 34.4601 82.5001 33.9239 82.1776L30.7357 80.2756L31.2259 79.4587L34.083 81.1637C34.5564 81.4486 34.9083 81.5282 35.1346 81.4109C35.2435 81.3439 35.4195 81.1093 35.6624 80.7029C35.8887 80.3217 35.6918 79.9446 35.0759 79.576L33.8945 78.8722C33.4044 78.5789 33.0608 78.2479 32.8598 77.8751C32.6377 77.4645 32.6335 77.0833 32.8472 76.7272L33.3709 75.8516C33.6055 75.4578 33.9783 75.2609 34.4894 75.2525C34.8497 75.2442 35.277 75.3866 35.7714 75.684L39.0181 77.6237L38.528 78.4406H38.5238Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3591 86.7816L46.1526 86.5009L47.313 81.4988L44.0495 85.4368C43.7311 85.8222 43.3792 85.9688 42.9896 85.8808C42.755 85.8264 42.5791 85.7175 42.4618 85.5583C42.3905 85.4535 42.3319 85.2901 42.2732 85.0681L41.0332 80.0451L39.8727 85.0472L38.6662 84.7665L39.9523 79.2323C40.0068 78.9893 40.1492 78.8134 40.3796 78.7003C40.6059 78.5872 40.8907 78.5662 41.2301 78.6458C41.7412 78.7631 42.047 79.0438 42.1476 79.4795L43.2996 84.4942L46.5841 80.5017C46.8773 80.1498 47.2711 80.0325 47.7655 80.1456C48.1132 80.2252 48.3604 80.3718 48.5112 80.5771C48.6578 80.7824 48.7039 81.0128 48.6453 81.2684L47.3633 86.7816H47.3591Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8116 86.0777L56.4291 86.2118L55.5032 84.6953L51.9967 85.0346L51.3767 86.6978L49.9942 86.8318L52.3068 80.6525C52.466 80.2462 52.7885 80.0157 53.2745 79.9697C53.7647 79.9236 54.1249 80.0828 54.3554 80.4556L57.8074 86.0777H57.8116ZM55.0089 83.8448L53.3206 81.0924L52.3193 84.1046L55.0089 83.8448Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9515 83.1495L64.4433 83.7318L60.5766 82.542C60.4467 82.5043 60.3461 82.3954 60.2749 82.2194C60.1451 81.8801 60.3252 81.612 60.8279 81.4193L62.5916 80.7238C63.1782 80.4976 63.396 80.1792 63.2368 79.7728L62.9645 79.0732C62.8011 78.6459 62.3864 78.5621 61.7203 78.8218L59.2192 79.7896L61.2259 84.9802L60.0152 85.4494L57.6691 79.3707L61.7328 77.7996C62.9687 77.3221 63.7563 77.5148 64.0872 78.3778L64.4936 79.4293C64.6402 79.8063 64.5983 80.1708 64.3637 80.5269C64.1333 80.883 63.7563 81.1595 63.2326 81.3606L61.8376 81.8968L65.9431 83.1495H65.9515Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2066 74.3016L67.3885 75.5709L70.5849 80.1541L69.5208 80.8956L66.3244 76.3125L64.5146 77.5734L63.9699 76.7942L68.662 73.5223L69.2066 74.3016Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6603 58.7213C51.5002 58.7213 52.1811 58.0404 52.1811 57.2005C52.1811 56.3607 51.5002 55.6798 50.6603 55.6798C49.8205 55.6798 49.1396 56.3607 49.1396 57.2005C49.1396 58.0404 49.8205 58.7213 50.6603 58.7213Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6603 58.7213C51.5002 58.7213 52.1811 58.0404 52.1811 57.2005C52.1811 56.3607 51.5002 55.6798 50.6603 55.6798C49.8205 55.6798 49.1396 56.3607 49.1396 57.2005C49.1396 58.0404 49.8205 58.7213 50.6603 58.7213Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_26_4148",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 16,
    width: 3,
    height: 4
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9691 18.9727C49.9691 18.9727 50.0403 18.7255 50.1367 18.5202C50.1576 18.4741 50.1827 18.4197 50.2037 18.3694C50.2288 18.3191 50.254 18.2689 50.2791 18.2186C50.3084 18.1725 50.3336 18.118 50.3629 18.072C50.3922 18.0259 50.4215 17.9756 50.4509 17.9295C50.4802 17.8834 50.5095 17.8415 50.5347 17.7997C50.564 17.7578 50.5891 17.7242 50.6142 17.6865C50.6394 17.653 50.6603 17.6195 50.6813 17.5944C50.7022 17.5692 50.719 17.5441 50.7357 17.5232C50.7651 17.4855 50.7818 17.4645 50.7818 17.4645L50.7357 17.5273C50.7357 17.5273 50.7022 17.5734 50.6855 17.5986C50.6645 17.6279 50.6436 17.6572 50.6226 17.6949C50.6017 17.7326 50.5765 17.7703 50.5472 17.808C50.5221 17.8499 50.4969 17.896 50.4676 17.9379C50.4425 17.984 50.4173 18.0301 50.388 18.0803C50.3629 18.1264 50.3377 18.1809 50.3126 18.2312C50.2917 18.2814 50.2665 18.3317 50.2414 18.3862C50.2204 18.4364 50.1953 18.4867 50.1827 18.537C50.1618 18.5831 50.1492 18.6333 50.1325 18.6794C50.1157 18.7255 50.1031 18.7674 50.0906 18.8093C50.0822 18.8512 50.0696 18.8847 50.0613 18.9182C50.0529 18.9517 50.0487 18.9769 50.0403 19.0062V19.0188C50.5263 19.0355 51.096 18.6878 51.2468 18.3359C51.4814 17.7871 51.2468 17.1461 51.2887 16.8445C51.3139 16.6769 51.3893 16.5135 51.5401 16.4381C50.388 16.7481 49.8015 17.6824 49.7848 18.3568C49.7764 18.6082 49.8685 18.8344 49.9649 18.9769L49.9691 18.9727Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_26_4148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5359 16.4297H49.7764V19.0271H51.5359V16.4297Z",
    fill: "#8EBF25"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8246 71.1511C44.4266 70.992 44.0034 71.0506 43.5929 70.992C42.9854 70.9082 42.3696 70.9082 41.7747 70.7448C41.9046 70.5898 42.0931 70.5311 42.2649 70.4599C43.3373 70.0158 44.3847 69.5215 45.4111 68.9685C48.0336 67.5567 50.4467 65.8558 52.6377 63.8491C54.2716 62.3535 55.7881 60.7364 57.1119 58.9559C59.0307 56.3837 60.631 53.6229 61.8124 50.6317C62.9393 47.7829 63.7269 44.842 64.083 41.7921C64.1249 41.4402 64.0244 41.0422 64.2883 40.728C65.0885 42.8018 65.6499 44.9383 66.0311 47.1252C66.5422 50.0577 66.6469 53.007 66.1987 55.9563C65.7504 58.9308 64.9209 61.7796 63.1614 64.2764C61.1421 67.1419 58.3646 68.9392 55.0592 69.9823C53.1698 70.5814 51.2343 70.8998 49.2611 71.059C49.148 71.0674 49.0097 71.0045 48.9259 71.1428H44.8162L44.8246 71.1511Z",
    fill: "#3C8032"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2925 40.7364C64.0286 41.0506 64.1291 41.4485 64.0872 41.8005C63.7311 44.8545 62.9436 47.7912 61.8166 50.64C60.6352 53.627 59.0349 56.392 57.1161 58.9643C55.7881 60.7405 54.2716 62.3618 52.6419 63.8574C50.4509 65.8641 48.0378 67.565 45.4153 68.9768C44.3889 69.5298 43.3415 70.0242 42.2691 70.4682C42.0973 70.5395 41.9046 70.5981 41.7789 70.7531C41.6281 70.2546 41.7789 69.756 41.8166 69.2659C41.9926 67.1042 42.3235 64.9592 42.8556 62.852C43.6934 59.5466 44.9586 56.4297 46.936 53.6312C48.6159 51.2558 50.6352 49.2408 53.2033 47.8206C53.2242 47.808 53.241 47.787 53.2661 47.7619C53.0986 47.6614 52.9519 47.7661 52.8137 47.8122C48.7751 49.0899 45.6206 51.5533 43.2578 55.0388C41.2217 58.0468 39.9607 61.3857 39.1522 64.909C38.8589 66.1867 38.6159 67.4687 38.4819 68.7757C38.4693 68.9056 38.4274 69.0313 38.3855 69.2198C37.8828 68.4322 37.4764 67.6656 37.091 66.8863C36.0646 64.8252 35.2812 62.676 34.9838 60.3844C34.2967 55.1436 36.0562 50.8578 40.1157 47.4938C42.1518 45.8055 44.5271 44.754 46.9486 43.7653C49.8769 42.5755 52.621 41.0547 54.9 38.8176C56.5422 37.2089 57.7613 35.3405 58.1844 33.0363C58.4065 31.8298 58.4149 30.6191 58.0839 29.4251C58.0713 29.3748 58.0713 29.3204 58.0629 29.224C58.3017 29.3832 58.4149 29.6052 58.5489 29.7979C60.8656 33.0782 62.755 36.5931 64.1668 40.3551C64.2129 40.4808 64.2506 40.6149 64.2925 40.7405V40.7364Z",
    fill: "#4CA034"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0529 32.4163C41.1798 32.4163 42.0931 33.3254 42.1057 34.4439C42.1182 35.5625 41.1589 36.5218 40.0403 36.5135C38.905 36.5051 37.9875 35.5709 37.9959 34.4314C38.0085 33.3086 38.9176 32.4121 40.0487 32.4163H40.0529Z",
    fill: "#4DA134"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0026 35.462C49.9942 34.4188 50.8195 33.5768 51.8585 33.5684C52.9184 33.5558 53.7814 34.4021 53.7772 35.4494C53.7772 36.4716 52.9184 37.3304 51.892 37.3388C50.8698 37.3472 50.0068 36.4967 50.0026 35.4662V35.462Z",
    fill: "#4DA134"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3227 43.4176C38.3227 44.0376 37.7864 44.5738 37.1706 44.5697C36.5422 44.5697 36.0269 44.0502 36.0269 43.4176C36.0269 42.7766 36.5296 42.2781 37.1706 42.2781C37.8032 42.2781 38.3269 42.7934 38.3227 43.4176Z",
    fill: "#3F8232"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6071 42.2781C41.5988 42.7096 41.2175 43.0824 40.786 43.0824C40.3378 43.0824 39.9565 42.6886 39.9733 42.2362C39.99 41.7921 40.3629 41.4486 40.807 41.4611C41.2427 41.4737 41.6155 41.8508 41.6071 42.2781Z",
    fill: "#4EA334"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0324 39.1234C47.0449 39.4628 46.7391 39.7812 46.3956 39.7937C46.0437 39.8063 45.7378 39.513 45.7295 39.1611C45.7211 38.8008 45.9976 38.5076 46.3621 38.4992C46.7223 38.4908 47.024 38.7715 47.0365 39.1234H47.0324Z",
    fill: "#4EA334"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7563 42.0434C23.5594 42.5419 23.3038 42.9986 22.9938 43.4133C22.6838 43.8239 22.3738 44.1381 22.0596 44.3476L21.0122 43.2751C21.2929 43.0698 21.5652 42.8143 21.8208 42.5001C22.0763 42.1859 22.2732 41.8549 22.4157 41.4988C22.5078 41.26 22.5665 41.0589 22.5791 40.8997C22.5916 40.7363 22.5791 40.6065 22.5288 40.5101C22.4827 40.4138 22.4115 40.3467 22.3109 40.309C22.1727 40.2546 22.0344 40.2755 21.9046 40.3677C21.7705 40.464 21.6406 40.6023 21.5066 40.7866C21.3725 40.9709 21.2301 41.172 21.0793 41.3983C20.9284 41.6245 20.7651 41.8465 20.5849 42.0602C20.4048 42.2738 20.2079 42.4582 19.9984 42.609C19.7889 42.7598 19.5501 42.8562 19.2862 42.9022C19.0223 42.9441 18.729 42.9022 18.4023 42.7724C18.0378 42.6257 17.7445 42.3953 17.5267 42.0769C17.3088 41.7585 17.1915 41.3647 17.1706 40.8913C17.1496 40.4179 17.2586 39.8817 17.4974 39.2868C17.6566 38.8846 17.8576 38.5118 18.1006 38.1599C18.3436 37.808 18.6117 37.5189 18.9092 37.2843L19.9775 38.3233C19.7052 38.5537 19.4747 38.7925 19.282 39.048C19.0893 39.2994 18.9427 39.5633 18.8338 39.8272C18.7374 40.066 18.6871 40.2671 18.6788 40.4305C18.6704 40.5939 18.6955 40.7238 18.75 40.8201C18.8044 40.9165 18.884 40.9877 18.9888 41.0296C19.1228 41.0841 19.2527 41.0631 19.3826 40.9667C19.5124 40.8746 19.6423 40.7321 19.7722 40.5478C19.9062 40.3593 20.0445 40.154 20.1953 39.9278C20.3461 39.7016 20.5095 39.4795 20.6855 39.2659C20.8614 39.048 21.0541 38.8679 21.2678 38.7129C21.4814 38.5621 21.716 38.4657 21.98 38.4238C22.2439 38.3819 22.533 38.4238 22.8514 38.5537C23.2075 38.6961 23.4923 38.9265 23.7144 39.2449C23.9322 39.5633 24.0537 39.9571 24.0747 40.4305C24.0956 40.8997 23.9867 41.436 23.7479 42.0434H23.7563Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 36.7188C26.1484 37.2215 25.7672 37.5985 25.3315 37.8499C24.8958 38.1012 24.4475 38.2227 23.9783 38.2144C23.5091 38.206 23.065 38.0635 22.6377 37.787C22.2146 37.5105 21.9004 37.1628 21.6993 36.7481C21.4982 36.3291 21.4186 35.8809 21.4647 35.4033C21.5108 34.9257 21.6784 34.4649 21.9674 34.0208C22.2397 33.6019 22.5749 33.2751 22.9687 33.0363C23.3625 32.8017 23.794 32.6886 24.2548 32.697C24.7198 32.7053 25.1848 32.8645 25.6582 33.1704C25.7085 33.2039 25.7714 33.2458 25.8342 33.296C25.9012 33.3463 25.9599 33.3924 26.0101 33.4343L23.8191 36.8067L23.0315 36.2956L24.7073 33.715L24.5606 34.423C24.3679 34.2931 24.1794 34.2177 23.9867 34.2009C23.794 34.1842 23.618 34.2177 23.4505 34.3015C23.2871 34.3853 23.1446 34.5151 23.0273 34.6911C22.91 34.8671 22.8514 35.0514 22.8388 35.2357C22.8304 35.42 22.8765 35.596 22.9729 35.7636C23.0692 35.9312 23.2117 36.0778 23.4086 36.2035L23.6348 36.3501C23.8443 36.4841 24.0537 36.5596 24.2632 36.5721C24.4727 36.5847 24.6696 36.5344 24.8581 36.4255C25.0466 36.3166 25.21 36.149 25.3566 35.9228C25.4907 35.7133 25.5786 35.5122 25.6163 35.3237C25.6541 35.1352 25.6541 34.9257 25.6247 34.6995L26.9528 34.4439C27.0449 34.7958 27.0533 35.1603 26.9779 35.5332C26.9025 35.9102 26.7307 36.2998 26.4668 36.7104L26.4752 36.7188Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2473 34.1632L23.019 29.5675L24.1962 28.2269L29.4245 32.8227L28.2473 34.1591V34.1632Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0009 30.5101C31.5736 30.8704 31.1254 31.1008 30.6478 31.2055C30.1702 31.3103 29.7135 31.2935 29.2695 31.1469C28.8254 31.0003 28.4358 30.7321 28.1048 30.3425C27.7739 29.9487 27.577 29.5256 27.5099 29.0648C27.4429 28.6039 27.5099 28.1515 27.6901 27.7032C27.8786 27.255 28.1844 26.8528 28.6076 26.4925C29.0349 26.1322 29.4831 25.8976 29.9607 25.7887C30.4341 25.6798 30.8949 25.6965 31.3348 25.839C31.7747 25.9814 32.1601 26.2495 32.4911 26.6433C32.8221 27.0371 33.0231 27.4602 33.0902 27.9211C33.1614 28.3819 33.0985 28.8386 32.9142 29.291C32.7257 29.7435 32.4199 30.1498 31.9967 30.5101H32.0009ZM31.0877 29.4251C31.2427 29.291 31.3558 29.136 31.4144 28.9642C31.4773 28.7883 31.4856 28.5998 31.4354 28.3987C31.3893 28.1976 31.2804 27.9965 31.117 27.8038C30.9536 27.6069 30.7735 27.4728 30.5891 27.3974C30.4006 27.322 30.2163 27.3011 30.0361 27.3304C29.8518 27.3597 29.6842 27.4435 29.525 27.5776C29.37 27.7074 29.2653 27.8582 29.2024 28.0342C29.1396 28.2101 29.1312 28.3945 29.1731 28.5956C29.215 28.7925 29.3156 28.9936 29.4831 29.1863C29.6465 29.3832 29.8267 29.5214 30.0194 29.5968C30.2121 29.6764 30.4006 29.6974 30.5807 29.668C30.7651 29.6387 30.9326 29.5591 31.0835 29.4292L31.0877 29.4251Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9523 25.7929C39.4706 25.9898 38.9972 26.0987 38.5238 26.1155C38.0504 26.1322 37.6063 26.061 37.1915 25.8976C36.7768 25.7384 36.4081 25.4996 36.0814 25.1854C35.7546 24.8712 35.4949 24.4816 35.3063 24.0166C35.1178 23.5558 35.0257 23.095 35.034 22.6425C35.0424 22.19 35.1388 21.7585 35.3231 21.3522C35.5074 20.9458 35.7714 20.5813 36.1233 20.2546C36.4752 19.932 36.8941 19.6681 37.3843 19.467C37.9582 19.2324 38.507 19.1151 39.0391 19.1192C39.5711 19.1234 40.0529 19.2449 40.497 19.4837L39.8141 20.9249C39.5125 20.7866 39.2192 20.707 38.9301 20.6944C38.6453 20.6819 38.352 20.7363 38.0587 20.8536C37.799 20.9626 37.577 21.1008 37.3968 21.2684C37.2167 21.436 37.0826 21.6287 36.9947 21.8465C36.9067 22.0602 36.8648 22.2906 36.869 22.5378C36.869 22.7849 36.9276 23.0405 37.0365 23.3044C37.1413 23.56 37.2795 23.7736 37.4513 23.9538C37.6231 24.1339 37.8158 24.268 38.0294 24.3601C38.2431 24.4523 38.4735 24.4942 38.7165 24.4942C38.9595 24.4942 39.2108 24.4355 39.4664 24.3308C39.7219 24.2261 39.9523 24.0794 40.1618 23.8993C40.3713 23.715 40.5556 23.472 40.7232 23.1662L42.1811 23.9747C41.9381 24.3643 41.6113 24.7246 41.2133 25.043C40.8112 25.3656 40.3922 25.6169 39.9523 25.7971V25.7929ZM40.5724 24.3685L39.6298 22.0769L41.1463 21.4527L42.1811 23.9663L40.5682 24.3643L40.5724 24.3685Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2452 24.5278L42.2104 19.5508L43.8736 19.2031L44.1752 20.6526L43.8401 20.2923C43.9113 19.8902 44.0914 19.5592 44.3805 19.3037C44.6737 19.0481 45.055 18.8722 45.5242 18.7716L45.851 20.3426C45.7714 20.3468 45.7001 20.3552 45.6415 20.3636C45.5828 20.3719 45.52 20.3845 45.453 20.3971C45.0969 20.4683 44.8288 20.6275 44.6486 20.8663C44.4685 21.1051 44.4224 21.4402 44.5146 21.8759L44.9921 24.1633L43.2452 24.5278Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6758 23.715C49.0768 23.7402 48.5489 23.648 48.0923 23.4385C47.6356 23.2291 47.2753 22.9316 47.0156 22.542C46.7517 22.1566 46.6092 21.7083 46.5883 21.2014C46.5673 20.6945 46.6679 20.2379 46.8941 19.8315C47.1161 19.4251 47.4387 19.1025 47.8535 18.8637C48.2682 18.6249 48.7416 18.4951 49.2737 18.4699C49.7722 18.449 50.233 18.5328 50.6561 18.7171C51.0793 18.9056 51.4186 19.1863 51.6783 19.5717C51.9381 19.9572 52.0805 20.4264 52.1057 20.9919C52.1057 21.0548 52.1057 21.126 52.1057 21.2098C52.1057 21.2894 52.0973 21.3648 52.0973 21.436L48.0755 21.6036L48.0378 20.6652L51.1128 20.5395L50.4509 20.8286C50.4509 20.5981 50.3964 20.4012 50.3001 20.2337C50.2037 20.0703 50.0738 19.9404 49.9104 19.8566C49.7471 19.7686 49.5585 19.7309 49.3449 19.7393C49.1312 19.7477 48.9469 19.8022 48.7919 19.9027C48.6369 20.0032 48.5196 20.1415 48.44 20.3175C48.3604 20.4934 48.3227 20.6945 48.3352 20.9291L48.3436 21.2014C48.352 21.4528 48.4148 21.6664 48.5238 21.8424C48.6327 22.0183 48.7877 22.1524 48.9846 22.2404C49.1815 22.3283 49.4161 22.3702 49.6842 22.3577C49.9356 22.3493 50.145 22.3032 50.321 22.2236C50.497 22.144 50.6687 22.0267 50.8363 21.8675L51.8124 22.8059C51.5778 23.0866 51.2887 23.3003 50.9368 23.4553C50.5849 23.6103 50.166 23.6983 49.68 23.7192L49.6758 23.715Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3399 24.0752C54.745 23.9831 54.2464 23.7903 53.8401 23.4971C53.4337 23.2038 53.1404 22.8394 52.9561 22.412C52.7718 21.9805 52.7173 21.5155 52.7969 21.017C52.8723 20.5185 53.0608 20.087 53.3625 19.7309C53.6599 19.3748 54.037 19.1192 54.4894 18.9642C54.9419 18.8092 55.4362 18.7715 55.9599 18.8553C56.4542 18.9307 56.8899 19.1025 57.267 19.3664C57.644 19.6303 57.9247 19.9738 58.1048 20.4012C58.285 20.8285 58.3352 21.3186 58.2473 21.8758C58.2389 21.9386 58.2221 22.0099 58.2054 22.0895C58.1886 22.1691 58.1677 22.2403 58.1509 22.3073L54.1752 21.6915L54.3176 20.7656L57.3591 21.2348L56.6511 21.3898C56.693 21.1636 56.6804 20.9583 56.6176 20.7782C56.5548 20.5981 56.45 20.4472 56.3076 20.3299C56.1652 20.2126 55.985 20.1372 55.7755 20.1079C55.5661 20.0744 55.3734 20.0911 55.2016 20.1624C55.0298 20.2294 54.8874 20.3425 54.7743 20.5017C54.6612 20.6567 54.59 20.8494 54.5523 21.0798L54.5104 21.3479C54.4727 21.5951 54.4894 21.8172 54.5648 22.0099C54.6402 22.2026 54.7659 22.366 54.9419 22.4916C55.1178 22.6173 55.3398 22.7011 55.6038 22.743C55.8509 22.7807 56.0688 22.7765 56.2573 22.7346C56.4458 22.6927 56.6344 22.6089 56.8313 22.4875L57.6105 23.5934C57.3298 23.8239 56.9988 23.9789 56.626 24.0627C56.2531 24.1464 55.8258 24.1506 55.344 24.0794L55.3399 24.0752Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2494 20.8327C63.618 20.971 63.9238 21.1721 64.1668 21.4318C64.4098 21.6915 64.5606 22.0099 64.6151 22.387C64.6696 22.7598 64.6067 23.1955 64.4224 23.6857L63.4002 26.4088L61.7328 25.7845L62.6503 23.3338C62.776 22.9944 62.8011 22.7221 62.7215 22.5127C62.6419 22.3074 62.4785 22.1566 62.2313 22.0644C62.0554 21.9974 61.8794 21.9764 61.7035 22.0016C61.5275 22.0267 61.3683 22.1063 61.2259 22.2362C61.0835 22.3702 60.962 22.5671 60.8614 22.831L59.9984 25.131L58.3269 24.5068L60.1115 19.7477L61.7035 20.3426L61.1966 21.6957L61.0374 21.1846C61.3474 20.9081 61.6951 20.7406 62.0763 20.6861C62.4576 20.6316 62.8472 20.6777 63.2452 20.8285L63.2494 20.8327Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1844 29.6597C67.7571 29.333 67.3885 28.9643 67.0742 28.5538C66.76 28.1432 66.5464 27.762 66.4249 27.4017L67.7445 26.6853C67.8619 27.0121 68.0378 27.343 68.2682 27.674C68.4986 28.0049 68.7667 28.2856 69.0684 28.516C69.2695 28.6711 69.4496 28.78 69.6004 28.8386C69.7554 28.8973 69.8811 28.9182 69.9859 28.8973C70.0906 28.8763 70.1744 28.8261 70.2414 28.7423C70.3336 28.625 70.3503 28.4867 70.2959 28.3359C70.2414 28.1809 70.1409 28.0175 70.0026 27.8374C69.8644 27.6614 69.7052 27.4687 69.5292 27.2592C69.3533 27.054 69.1857 26.8361 69.0265 26.6015C68.8673 26.3711 68.7458 26.1323 68.6578 25.8893C68.5698 25.6463 68.5405 25.3908 68.5699 25.1269C68.5992 24.8629 68.7207 24.5906 68.9343 24.3141C69.1731 23.9999 69.4748 23.7821 69.8392 23.6606C70.2037 23.5391 70.6184 23.5307 71.0793 23.6396C71.5401 23.7486 72.0261 23.9999 72.5372 24.3895C72.8807 24.6535 73.1865 24.9467 73.4588 25.2777C73.7311 25.6086 73.9364 25.9438 74.083 26.2915L72.7885 27.0372C72.6419 26.7146 72.4743 26.4256 72.2816 26.17C72.0889 25.9186 71.8794 25.7008 71.6532 25.529C71.4479 25.374 71.2678 25.2693 71.1128 25.2148C70.9578 25.1604 70.8237 25.1478 70.7148 25.1771C70.6059 25.2065 70.5179 25.2651 70.4509 25.3531C70.3629 25.4662 70.3461 25.6003 70.4006 25.7469C70.4551 25.8935 70.5556 26.0611 70.7022 26.237C70.8447 26.413 71.0039 26.6057 71.184 26.811C71.36 27.0163 71.5275 27.2341 71.6867 27.4645C71.8459 27.6949 71.9716 27.9295 72.0596 28.1767C72.1476 28.4197 72.1769 28.6752 72.1434 28.9392C72.114 29.2031 71.9884 29.4712 71.7831 29.7435C71.5485 30.0452 71.251 30.2588 70.8824 30.3845C70.5137 30.5102 70.1032 30.5186 69.6423 30.4096C69.1857 30.3007 68.6955 30.0494 68.1802 29.6556L68.1844 29.6597Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3738 33.4804C71.9297 33.0028 71.7035 32.5252 71.6909 32.0393C71.6783 31.5533 71.9088 31.0925 72.3864 30.6484L75.5786 27.674L76.7936 28.9768L73.6138 31.9345C73.4798 32.0602 73.4127 32.1901 73.4044 32.3367C73.396 32.4833 73.4463 32.609 73.5552 32.7221C73.6976 32.8771 73.861 32.9735 74.0411 33.0112L73.4295 34.1842C73.2535 34.1423 73.0734 34.0585 72.8933 33.9287C72.7089 33.7988 72.5372 33.648 72.3738 33.4762V33.4804ZM73.1321 28.9391L74.1082 28.03L76.6218 30.728L75.6457 31.6371L73.1321 28.9391Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M74.879 36.7648C74.5439 36.2663 74.347 35.7677 74.2883 35.2692C74.2297 34.7707 74.2967 34.3098 74.4894 33.8825C74.6821 33.4552 74.9879 33.1033 75.4111 32.8226C75.8342 32.5419 76.2741 32.3911 76.7391 32.3702C77.2041 32.3492 77.644 32.454 78.0671 32.6844C78.4861 32.9148 78.8463 33.2499 79.1396 33.694C79.4203 34.1088 79.5879 34.5444 79.6465 35.0011C79.7093 35.4577 79.6423 35.8976 79.4496 36.3165C79.2569 36.7397 78.9259 37.1041 78.4609 37.4183C78.4107 37.4519 78.3478 37.4896 78.2766 37.5315C78.2054 37.5734 78.1383 37.6069 78.0797 37.6404L75.8426 34.2973L76.6218 33.7778L78.331 36.3333L77.7362 35.9186C77.9331 35.7929 78.0755 35.6504 78.1635 35.4787C78.2515 35.3111 78.2933 35.131 78.2808 34.9466C78.2682 34.7623 78.2054 34.5822 78.0881 34.4062C77.9708 34.2302 77.8283 34.1004 77.6608 34.0208C77.4932 33.9412 77.3172 33.9119 77.1245 33.9328C76.9318 33.9537 76.7391 34.0333 76.5506 34.159L76.3243 34.3098C76.1149 34.4481 75.9641 34.6115 75.8719 34.8C75.7797 34.9885 75.7462 35.1854 75.7755 35.4033C75.8007 35.6169 75.8887 35.839 76.0395 36.061C76.1777 36.2705 76.3285 36.4255 76.4877 36.5344C76.6469 36.6433 76.8355 36.7271 77.0575 36.7899L76.7684 38.1138C76.4081 38.0593 76.073 37.9253 75.7588 37.7074C75.4446 37.4896 75.1513 37.1754 74.879 36.7732V36.7648Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5225 41.8004C77.2921 41.2474 77.1999 40.7196 77.2376 40.2169C77.2754 39.7183 77.4346 39.2784 77.7069 38.8972C77.9792 38.516 78.3478 38.2311 78.817 38.0342C79.2862 37.8415 79.7471 37.7786 80.2079 37.8499C80.6687 37.9211 81.0793 38.1096 81.448 38.4154C81.8166 38.7254 82.1015 39.1234 82.3026 39.6136C82.4953 40.0744 82.5749 40.5352 82.5456 40.9961C82.5162 41.4569 82.3654 41.8717 82.0973 42.2487C81.825 42.6257 81.4312 42.919 80.9117 43.1368C80.8531 43.162 80.786 43.1871 80.7106 43.2122C80.6352 43.2374 80.5598 43.2625 80.497 43.2793L78.9595 39.5633L79.8267 39.203L81.0039 42.0434L80.5012 41.5197C80.719 41.436 80.8866 41.3228 81.0081 41.172C81.1296 41.0254 81.205 40.8578 81.2301 40.6735C81.2552 40.4892 81.2301 40.3006 81.1463 40.1037C81.0667 39.9068 80.9494 39.7518 80.8028 39.6429C80.6562 39.5298 80.4844 39.467 80.2917 39.4544C80.099 39.4376 79.8937 39.4753 79.68 39.5633L79.4287 39.668C79.1983 39.7644 79.0181 39.8943 78.8883 40.0577C78.7584 40.221 78.6914 40.4138 78.6746 40.6274C78.6578 40.8453 78.7039 41.0757 78.8045 41.3228C78.9008 41.5533 79.0139 41.7376 79.148 41.8758C79.2821 42.0141 79.4538 42.1356 79.6591 42.2361L79.1187 43.4762C78.7751 43.3547 78.4735 43.1536 78.2054 42.8813C77.9373 42.6048 77.711 42.2445 77.5267 41.7921L77.5225 41.8004Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6243 44.7079L85.3776 43.0154L85.8091 44.7456L79.0558 46.4381L78.6243 44.7079Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_4148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 98.1315,
    fill: "white",
    transform: "translate(0.660339 0.916504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeloGreenSteel);
export default __webpack_public_path__ + "static/media/selo_green_steel.79345f88ba363a80438c5ed9bd715c0c.svg";
export { ForwardRef as ReactComponent };